import 'react-dates/initialize';
import {DateRangePicker, SingleDatePicker, DayPickerRangeController} from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import Sticky from 'react-stickynode';
import { useState, useEffect,ElementConfig} from "react";
import * as NumericInput from "react-numeric-input";
import Textarea from 'react-textarea-autosize';
import {getInventory, updateCharge, updateCustomer} from "./../stripe/functions";
import {getRatePlans, postPayment, setTimeOut} from "./../cloudbeds/functions";
import { FiEdit } from "react-icons/fi";
import { MdDetails } from "react-icons/md";
import { IoTriangleOutline } from "react-icons/io5"
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import Loader from 'react-loader-spinner'
import ReactFlagsSelect from 'react-flags-select';
import { CountryDropdown, RegionDropdown, CountryRegionData } from 'react-country-region-selector';
import 'react-flags-select/css/react-flags-select.css';
import { FormattedMessage } from 'react-intl';
//import {NotificationContainer, NotificationManager} from 'react-notifications';
//import 'react-notifications/lib/notifications.css';
import 'airbnb-browser-shims';
//import * as Scroll from 'react-scroll';
//import { Link, Element , Events, animateScroll as scroll, scrollSpy  } from 'react-scroll'
var Scroll = require('react-scroll');
var scroll = Scroll.animateScroll;
var Element = Scroll.Element;
var scroller = Scroll.scroller;
import deLocale from 'moment/locale/de'
import moment1 from 'moment';




const HighBox = styled.div`
border: 1px solid #8AD1A9;
border-radius:5px;
color:#8AD1A9;
font-size:12px;
width:auto;
height:19.4px;
display:flex;
align-items:center;
text-transform:uppercase;
 font-family:${fonts.engraversBold};
 font-weight:bold;
margin-top: 7px;
padding: 0px 5px;
margin-right: 3px;
margin-left: 1px;




`



const Amneties = styled.div`
display:none;

 @media screen and (max-width: 666px) {
 display:flex;
 align-items:flex-start;
   flex-wrap: wrap;
   margin-left:2%;

 }
`



const sleep = m => new Promise(r => setTimeout(r, m));
import 'rc-steps/assets/index.css';
import 'rc-steps/assets/iconfont.css';
import Steps from 'rc-steps';
const { Step } = Steps;
const GiropayIcon = require('../../../assets/images/giropay.png');
import FloatingLabelInput from 'react-floating-label-input';




import NumberInput from 'semantic-ui-react-numberinput';

import { FiCheck } from "react-icons/fi";

//import {isBefore} from "../auth/authFunctions";

import {GiChurch, GiDutchBike} from "react-icons/gi";
import {GiFamilyHouse} from "react-icons/gi";
import {GiBlockHouse} from "react-icons/gi";
import { IoIosMoon } from "react-icons/io";
import {MdFreeBreakfast, MdLocalLaundryService, MdPeople} from "react-icons/md";


import SwipeableBottomSheet from '../react-swipeable-bottom-sheet';

import {SlideDown} from 'react-slidedown'
import 'react-slidedown/lib/slidedown.css'

import Popup from 'reactjs-popup'


type StaticQueryProps = {
  allDatoCmsResidence: {
      edges: {
        node: {
        id: string
        title: string
        images: []
      }
  }

  }
}

const StyledPopup:any = styled(Popup)`

`
const cross= require('../../../assets/images/cross.png');

const FlexGuestDiv = styled.div`
width:50%;
font-size:24px !important;
margin-top:1em;
text-align:left !important;

label{
height:40px !important;
}

@media screen and (max-width:640px){
width:100%;
margin-top:1.7em;


}

`
const FlexGuestDiv1 = styled.div`
width:50%;
font-size:24px !important;
margin-top:2em;
text-align:left !important;

label{
height:40px !important;
}

@media screen and (max-width:640px){
width:100%;
margin-top:1.7em;


}

`
const FlexGuestDiv2 = styled.div`
width:50%;
font-size:24px !important;
margin-top:1.8em;
text-align:left !important;

label{
height:40px !important;
}

@media screen and (max-width:640px){
width:100%;
margin-top:1.7em;


}

`

const Input: any = styled(FloatingLabelInput)`
width:100%;
border-radius: 2px;
font-family: "Theano Didot",Regular;
text-align:left !important;

font-size: 19px;
height:70px;
padding-left:7px;
margin-top:10px;
transition: all .2s ease;
padding-left:7px;
color:rgb(68,68,68,1);

span{
 font-family:${fonts.engraversBold} !important;
 text-transform:uppercase !important;

}

label{
left:7px;
font-size:0.9em;
 font-family:${fonts.engraversBold} !important;
  text-transform:uppercase !important;


}


:focus{
border-bottom:2px solid #54aaf1;
background: rgba(84, 170, 241,.1);


}


`

const RightFlexDiv = styled.div`
width:40%;
margin-left:10%;
font-size:24px !important;
text-align:left !important;
margin-top:1em;

label{
height:40px !important;
}
.flag-select .arrow-down{
display:none;
}


@media screen and (max-width:640px){
width:100%;
margin-left:0px;
margin-top:1.7em;

}

`

const Flex = styled.div`
width:100%;
display:flex;
color:rgb(68,68,68,1);
margin-top:0.7em;
@media screen and (max-width:640px){
display:block;

}

`
const Flex2 = styled.div`
width:100%;
display:flex;
color:rgb(68,68,68,1);
@media screen and (max-width:640px){
display:block;

}

`

const StyledAttention = styled(GoIssueOpened)`
font-size:32px;
`



const EmailIconDiv = styled.div`
border-right:1px solid rgba(68,68,68,.04);
width:100%;
display:flex;
justify-content:center;
text-align:center;
align-items: center;
`

const  EmailTextDiv = styled.div`
width:100%;
display:flex;
justify-content:space-between;
//text-align:center;
align-items: center;
padding-left:3%;
padding-right:3%;




`

const EmailText = styled.a`
font-weight:bold;

`


const EmailVerification = styled.div`
display:flex;
margin-bottom:20px;
width:100%;
height:auto;
//border:1px solid rgba(68,68,68,.2);
border-radius:2px;
//box-shadow: 1px 2px 4px rgba(0,0,0,.1);
  border:1px solid rgba(68,68,68,.04);
background:rgba(68,68,68,.02);



`



const containerStyle = {
  border: '1px solid rgb(235, 237, 240)',
  marginBottom: 24,
};

const DateDiv = styled.div`
width:100%;
padding-left:6px;
padding-right:6px;
display:flex;
justify-content:space-between;
 font-family: "Theano Didot",Regular !important;
 text-transform:none !important;
 font-weight:normal;


`

const CheckinDiv= styled.div`
width:50%;
 font-family:${fonts.engraversBold} !important;
 font-weight:bold;
 text-transform:uppercase;


`


const StyledSpinner = styled.div`
width:100%;
height:100%;
margin-top:15px;
margin-bottom:15px;
transform: rotate(180deg);
display:flex;
justify-content:center;
align-items:center;
-moz-transform: scale(1, -1);
-webkit-transform: scale(1, -1);
-o-transform: scale(1, -1);
-ms-transform: scale(1, -1);
transform: scale(1, -1);


`

const StyledBikeIon = styled(GiDutchBike)`
color:black;
`



const roomTypeIDs = [

  {type:0, id:227827},
  {type:1, id:227828},
  {type:2, id:227829},
]
const ratePlanIDs = [

  {rate:0, id:512202}, // studio -15
  {rate:1, id:512203},  //  studio plus -15
  {rate:2, id:512204},  // suite -15
  {rate:3, id:512196},  // studio -7
  {rate:4, id:512197},  // studio plus -7
  {rate:5, id:512198},  // suite -7
  {rate:6, id:512199},  // studio -5
  {rate:7, id:512200},  // studio plus -5
  {rate:8, id:512201},  // suite -5
  {rate:9, id:483836},  // studio portale
  {rate:10, id:483837},  // studio plus portale
  {rate:11, id:483838},  // suite portale
]



let specialsGuestOptions = [
  {value: 0, label: '0'},
  {value: 1, label: '1'},
  {value: 2, label: '2'},
  {value: 3, label: '3'},
  {value: 4, label: '4'},
  {value: 5, label: '5'},
  {value: 6, label: '6'},
  {value: 7, label: '7'},
  {value: 8, label: '8'},
  {value: 9, label: '9'},
  {value: 10, label: '10'},
  {value: 11, label: '11'},
  {value: 12, label: '12'},


]

let specialsDaysOptions = [
  {value: 0, label: '0'},
  {value: 1, label: '1'},
  {value: 2, label: '2'},
  {value: 3, label: '3'},
  {value: 4, label: '4'},
  {value: 5, label: '5'},
  {value: 6, label: '6'},
  {value: 7, label: '7'},
  {value: 8, label: '8'},
  {value: 9, label: '9'},
  {value: 10, label: '10'},
  {value: 11, label: '11'},
  {value: 12, label: '12'},
  {value: 13, label: '13'},
  {value: 14, label: '14'},
  {value: 15, label: '15'},
  {value: 16, label: '16'},
  {value: 17, label: '17'},
  {value: 18, label: '18'},
  {value: 19, label: '19'},
  {value: 20, label: '20'},
  {value: 21, label: '21'},
  {value: 22, label: '22'},
  {value: 23, label: '23'},
  {value: 24, label: '24'},
  {value: 25, label: '25'},
  {value: 26, label: '26'},
  {value: 27, label: '27'},
  {value: 28, label: '28'},
  {value: 29, label: '29'},
  {value: 30, label: '30'},
  {value: 31, label: '31'}


]


const SpecialsPricingBlock = styled.div`
  margin-top:5px;
`

const StyledTextarea: any = styled(Textarea)`
  border:1px solid rgba(68,68,68,.04);
  background: rgba(68,68,68,.02);
min-width:100%;
max-width:500px !important;
padding:15px;
transition:all 0.2s;

:focus{
   border-bottom:2px solid rgb(84, 170, 241);
       background:rgba(84, 170, 241,.07);
}
:focus::placeholder{
       color:transparent;

  }

  :focus::-webkit-input-placeholder { color:transparent; }
:focus:-moz-placeholder { color:transparent; } /* FF 4-18 */
:focus::-moz-placeholder { color:transparent; } /* FF 19+ */
:focus:-ms-input-placeholder { color:transparent; } /* IE 10+ */


`

const customSingleValue = ({ data }) => (
  <div className="input-select" >
    <div className="input-select__single-value" style={{display:'flex'}}>
      { data.icon && <span style={{display:'flex', alignItems:'center', marginRight:'7px'}} className="input-select__icon">{ data.icon }</span> }
      <span>{ data.label }</span>
    </div>
  </div>
);


const ArrowImg = styled.img`
fill:black !important;
width:16px;
height:16px;
margin: 0 11px 0 11px;

`

const StyledExtrasP = styled.p`
span{ font-family: ${fonts.standard} !important;
      text-transform:none !important;
}


font-style: italic;
font-size: 180%;
line-height: 40px;
letter-spacing: 2px;
color:rgb(68, 68, 68);
margin-bottom:0px;
margin-left:2%;
margin-top:10%;
text-align:left !important;
  @media screen and (max-width: 666px) {
   }

`


const DropdownIndicator = (
  props: ElementConfig<typeof components.DropdownIndicator>

) => {
  return (
    <components.DropdownIndicator {...props}>
      <ArrowImg src={arrowDown}/>
    </components.DropdownIndicator>
  );
};

const Checkbox = styled.div`
width:50px;
display:flex;
align-items:center;
height:50px;
background:white;
border-radius:50%;
justify-content:center;
margin-left:10px;


  @media screen and (max-width: 666px) {
display:none;   }

`

const Span = styled.span`
padding-left:6px;
 font-family:${fonts.engraversBold} !important;
 font-weight:bold;
 text-transform:uppercase;

`
const NoChargeNote = styled.div`
display:flex;
justify-content:center;
align-items:center;
margin-top:15px;
margin-bottom:15px;
width:100%;
`

const StyledCheck = styled(FiCheck)`
font-size:40px;
color: rgb(102, 163, 102);
`

const StyledSmallCheck = styled(FiCheck)`
color: rgb(102, 163, 102);
`

const StyledSlideDown = styled(SlideDown)`
//padding-left:50px;

@media screen and (max-width:1200px){
padding-left:0px  ;

}
`

const ArrowImg_2 = styled.img`
width:16px;
margin-left:10px;
transition:all 0.2s;

`

const ArrowDiv = styled.div`
width:40px !important;
height: 23.55px !important;
margin-left:20px;
display:flex;
justify-content:center;

align-items:center;
//border-radius:200px;
transition: all .2s;
//background: rgba(68,68,68,.1);


border-left:1px solid lightgrey;
  `

const Centered = styled.div`
text-align:center;
color:rgb(68,68,68);
`

const LoginDiv = styled.div`
margin-top:14px;
text-align:center;
opacity:0.8;

:hover{
opacity:1;
}

@media screen and (max-width: 1295px) {
margin-bottom:40px;

`

const LoginA = styled.div`
font-family:${fonts.button};
text-transform:uppercase;
letter-spacing:1px;
font-weight:bold;
margin-left:4px;
letter-spacing:2px;
color: rgba(24,140,236,1);
cursor:pointer;
transition: all .7s ease;

:hover{
//letter-spacing:0px;
}

@media screen and (max-width:570px){
letter-spacing:0px;
}
`

const StyledSheet = styled.div`
display:none;
z-index:999999;


@media screen and (max-width: 1295px) {
display:block;
}
`

const SheetWrapper = styled.div`
height:auto;
margin-bottom:1em;

display:flex;
justify-content:center;
`




let options = {
  container: 'sticky-end'
};
/*
let lock = new Auth0Lock(
  'YY3uCnLuNwtYJ8w3S6Wdq5Z8bH7mD2GK',
  'dev-uv101.eu.auth0.com',
  options,
);
*/
//lock.show();
// initialize
const Pa = styled.p`
color:(68,68,68) !important;
margin-bottom:0px !important;
text-align:center;
`

const PopWrapperPayment = styled.div`
.modal > .close {
  cursor: pointer;
  position: absolute;
  display: flex;
  padding: 2px 5px;
  line-height: 20px;
  right: 14px;
  top: 14px;
  font-size: 24px;
  background: #ffffff;
  border-radius: 50%;
    border: 1px solid #cfcece;
    z-index:999999999  !important;
width:37px;
height:37px;
justify-content:center;
text-align:center;


}

button {
  white-space: nowrap;
  border: 0;
  outline: 0;
  display: inline-block;
  padding: 0 14px;
  box-shadow: 0 4px 6px rgba(50, 50, 93, .11), 0 1px 3px rgba(0, 0, 0, .08);
  color: #fff;
  //border-radius: 2px;
  font-weight: 600;
  text-transform: uppercase;
  //letter-spacing: 0.025em;
  background-color: #6772e5;
  text-decoration: none;
  -webkit-transition: all 150ms ease;
  transition: all 150ms ease;
  margin-top: 10px;
}

form {
margin-top:40px;
  padding-bottom: 40px;
  border-bottom: 3px solid #e6ebf1;
  width:400px;

  @media screen and (max-width:960px){
width:320px;
  margin-left: auto;
margin-right: auto;
  }

}

button:hover {
  color: #fff;
  cursor: pointer;
  background-color: #7795f8;
  box-shadow: 0 7px 14px rgba(50, 50, 93, .10), 0 3px 6px rgba(0, 0, 0, .08);
}

.StripeElement {
  display: block;
  margin: 10px 0 20px 0;
  padding: 10px 14px;
  box-shadow: rgba(50, 50, 93, 0.14902) 0px 1px 3px, rgba(0, 0, 0, 0.0196078) 0px 1px 0px;
  border-radius: 2px;
  background: white;
}

input {
  display: block;
  margin: 10px 0 20px 0;
  padding: 10px 14px;
  box-shadow: rgba(50, 50, 93, 0.14902) 0px 1px 3px, rgba(0, 0, 0, 0.0196078) 0px 1px 0px;
  border-radius: 2px;
  background: white;
  border:none;
}

.StripeElement--focus {
  box-shadow: rgba(50, 50, 93, 0.109804) 0px 4px 6px, rgba(0, 0, 0, 0.0784314) 0px 1px 3px;
  -webkit-transition: all 150ms ease;
  transition: all 150ms ease;
}

.modal {
min-height:200px;
display:flex;
justify-content:center;
align-items:center;

  @media screen and (max-width:960px){
  width:100%;
  }
}

.popup-content {
display:flex;
justify-content:center;
align-items:center;
border:none !important;
padding:0px !important;
border-radius:2px;

@media screen and (max-width:760px){
width:100% !important;
}

}

.popup-overlay{
z-index:999999 !important;
}

.CardDemo{
  @media screen and (max-width:960px){
  width:100% !important;
  }
}

`

const PopWrapper = styled.div`
position:relative;
z-index:9999999;

.auth0-lock.auth0-lock .auth0-lock-cred-pane-internal-wrapper{
@media screen and (max-height: 560px) {
max-height:340px !important;
}


@media screen and (max-height: 490px) {
max-height:340px !important;
}

@media screen and (max-height: 420px) {
}


max-height:340px !important;

}

.modal > .close {
  cursor: pointer;
  position: absolute;
  display: flex;
  padding: 2px 5px;
  line-height: 20px;
  right: 14px;
  top: 14px;
  font-size: 24px;
  background: #ffffff;
  border-radius: 50%;
    border: 1px solid #cfcece;
    z-index:999999999  !important;
width:37px;
height:37px;
justify-content:center;
text-align:center;


}


.popup-content {
width:50% !important;
border:none !important;
border-radius:2px;
padding:20px !important;
margin-top:2% !important;
margin-bottom:2% !important;

 @media screen and (max-width: 1095px) {
width:100% !important;
}



}

.auth0-lock.auth0-lock .auth0-lock-name{

 @media screen and (max-width: 1095px) {
font-size:16px !important;
}



}



}
.auth0-lock.auth0-lock .auth0-lock-cred-pane-internal-wrapper{

}

`

const PopIcon = styled.img`
width:15px;
height:15px;
margin: auto;

`



const StyledWrapper = styled.div`
select{
font-size:0.9rem !important;
}
.DayPickerNavigation_svg__horizontal{
width:14px !important;
height:14px !important;
}
width:316px;
z-index:9;
margin-bottom:15px;
position:relative;

.DateInput{
border-radius:10rem !important;
}

.DateInput DateInput_1 {
border-radius:10rem !important;
}

.DateRangePickerInput__withBorder{
border-radius:10rem !important;
}

.DateRangePickerInput DateRangePickerInput_1 DateRangePickerInput__withBorder DateRangePickerInput__withBorder_2 DateRangePickerInput__showClearDates DateRangePickerInput__showClearDates_3{
border-radius:10rem !important;
}

.CalendarDay__selected{
background-color:rgb(24,140,236);
border-color: rgba(68,68,68,.1) ;

}

.DayPickerKeyboardShortcuts_show__bottomRight{
display:none !important;}

.CalendarDay__selected_span{
background-color:rgb(24,140,236,.5);
border-color: rgba(68,68,68,.1) ;


}

.DateInput_input DateInput_input_1{
border-radius:10rem;
}

.DateRangePicker DateRangePicker_1{
border-radius:10rem;
}

.CalendarDay__selected_span:hover{
background-color: rgba(24,140,236,.7);
 border-color: rgba(68,68,68,.1) ;


}

.CalendarDay__hovered_span{
background-color: rgba(24,140,236,.5);
color:white;
border-color: rgba(68,68,68,.1) ;



}

.CalendarDay__hovered_span:hover{
background-color: rgba(24,140,236,1);
color:white;
border-color: rgba(255,255,255,.2) ;



}



background-color: rgba(24,140,236,.1);
color: rgba(24,140,236,1);
border-radius:10rem !important;

}

.DateInput_input__focused{
border-bottom-color: #54aaf1;
}

.DateInput_input {
border-radius:10rem !important;
}

 font-family: "Theano Didot",Regular;

 .DateRangePicker{
 border-radius:10rem !important;

 }

 .DateRangePickerInput_clearDates_default:focus, .DateRangePickerInput_clearDates_default:hover{
 background:white;



 }
 .DateRangePickerInput_clearDates_svg{
 fill:#484848;
 }

 DateRangePickerInput_clearDates DateRangePickerInput_clearDates_1 DateRangePickerInput_clearDates_default DateRangePickerInput_clearDates_default_2:hover{
  .DateRangePickerInput_clearDates_svg DateRangePickerInput_clearDates_svg_1{
 }
 }

`;


var moment = require('moment');
import * as React from 'react'
import styled from '@emotion/styled'

require('../../styles/global.css');
//const fs = require('fs');
import Select, {components} from 'react-select'

import {Suite} from "./suite/Suite";
import {Studio} from "./studio/Studio";
import {StudioPlus} from "./studio_plus/StudioPlus";
import BookingTextDiv from "./BookingText";
//import BookingLogin from "../auth/BookingLogin";
import {PopLock} from "../auth/PopLock";
//import BottomDiv from "./BottomDiv";
import {PopLogin} from "../auth/PopLogin";
//import {navigate} from "@reach/router";
import { updatePaymentIntent} from "../stripe/functions";
import {GoIssueOpened} from "react-icons/go";
import {AddBreakfast} from "./specials/AddBreakfast";
import {AddBikes} from "./specials/AddBikes";
import {AddLaundry} from "./specials/AddLaundry";
import {AddChampagne} from "./specials/AddChampagne";
import {FaCcPaypal, FaCreditCard, FaWineBottle} from "react-icons/fa";
import {fonts} from "../../styles/variables";
import {getAccessToken, postReservation, postReservationItem, postReservationNotes} from "../cloudbeds/functions";
import {AiFillBank} from "react-icons/ai";
import {FaIdeal} from "react-icons/fa";
import {Amex} from "react-icons/gr";

import {GiropayDemo} from "../stripe/GiropayProvider";
import {KlarnaDemo} from "../stripe/KlarnaProvider";
import {AsyncDemo} from "../stripe/StripeProvider";
//import {IbanDemo} from "../stripe/IbanProvider";
import PaypalExpress from "../stripe/PaypalProvider";
//import EmailVerificationHandler from "../notifications/EmailVerificationHandler";
//import EmailVerificationHandler from "../notifications/EmailVerificationHandler";
import {PopLoginVerify} from "../auth/PopLoginVerify";
import {BankTransferDemo} from "../stripe/BankTransferProvider";
import {PayDuringStayProvider} from "../stripe/PayDuringStayProvider";
import { PaymentLogosImg, PciCompliantImg, SslSecureImg } from '../stripe/PaymentImgs'
import { graphql, StaticQuery } from 'gatsby'
//import {createNotification} from "../notifications/notificationHandler";

// standard rates for studio, studio plus and suite
const standardRates = require('../../../data/standard_rates.json');


const su_blocked_dates = require('../../../data/suite_blocked_dates.json');
const st_blocked_dates = require('../../../data/studio_blocked_dates.json');
const stp_blocked_dates = require('../../../data/studio_plus_blocked_dates.json');

const su_keys = Object.keys(su_blocked_dates);
const st_keys = Object.keys(st_blocked_dates);
const stp_keys = Object.keys(stp_blocked_dates);


const available = require('../../../data/availablity.json')


let suite_blocker = available["suite"];
let studio_blocker = available["studio"];
let studio_plus_blocker = available["studio_plus"];


let curr_count;


const Outer = styled.div`
display:flex;
justify-content: space-between;
margin-left:auto;
margin-right:auto;
margin-bottom:50px;
//font-family:'Futura PT' !important;


 @media screen and (max-width: 1295px) {
  padding-bottom:0px;
}


`;

const Inner = styled.div`
  border:1px solid rgba(68,68,68,.04);
background:rgba(68,68,68,.02);

border-radius: 2px;
//box-shadow: 1px 2px 4px rgba(0,0,0,.1);
padding-left: 20px;
padding-right: 20px;
padding-top: 20px;
height:auto;
width:360px;
`

const MobileInner = styled.div`
  border:1px solid rgba(68,68,68,.04);
border-radius: 2px;
padding-left: 20px;
padding-right: 20px;
padding-top: 12px;
height:auto;
min-height:450px;
width:360px;
text-align:left;
`

const Div360 = styled.div`
width:100%;
//padding-left: 20px;
display:none;
//padding-right: 20px;
margin-left:auto;
margin-right:auto;

  @media screen and (max-width: 1295px) {
display:flex;
}



`

const ContinueDiv = styled.div`

width:100%;
`

const StyledSticky :any = styled(Sticky)`
width:45%;

  @media screen and (max-width: 1295px) {
  display:none;
}


`

const StyledStickyEdit: any = styled.div`
display:none;

height: 52px;
width: 52px;
position:absolute;
top:-25px;
left: 50%;
transform: translateX(-50%);

z-index:999;

  @media screen and (max-width: 1295px) {
  display:block;

}


`


const EditIcon: any = styled.div`

height: 52px;
width: 52px;


z-index:999;




`




const RoomGuestDiv = styled.div`
width:100%;
margin-left:2px;


`

const GuestDiv = styled.div`
width:50%;
padding-left:1px;
margin-right:2px;


`

const arrowDown = require('../../../assets/images/down-arrow.png')

  const StyledSelect = styled.div`


  width:100%;
   font-family: "Theano Didot",Regular;
  border-radius:10rem !important;
  font-size:19px;
  text-align:center;

    @media screen and (max-width:1295px){
    -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  }



  `



const StyledRoomSelect = styled.div`
width:100%;
font-family: "Theano Didot",Regular;
border-radius:0px !important;
font-size:19px;
text-align:center;




`


const LabelTxt = styled.div`
opacity:.5;
padding-left:0.4rem;
 font-family:${fonts.engraversBold} !important;
 text-transform:uppercase !important;
`

const SelectBlockWithMargin = styled.div`
margin-top: 25px;
`

const customGuestStyles = {
  dropdownIndicator: (base, state) => ({
    ...base,
    transition: 'all .2s ease',
    transform: state.isFocused ? 'rotate(180deg)' : null
  }),
  control: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      display: 'flex',

      borderRadius: '10rem',
      fontSize: '19px',
      borderTop: '1px solid lightgrey',
      borderLeft: '1px solid lightgrey',
      borderRight: '1px solid lightgrey',
      borderBottom: isFocused ? '2px solid #54aaf1' :'1px solid lightgrey',
      boxShadow: isFocused ? null : null,

      "&:hover": {
        // Overwrittes the different states of border
        borderColor: isFocused ? "none" : "rgba(68,68,68,.5)",


      }
    };
},
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      background: isSelected ? 'rgb(24,140,236)' : 'white',
      color: isSelected ? 'white' : 'rgb(68,68,68)',
      cursor: isDisabled ? 'not-allowed' : 'default',
      "&:hover": {
        // Overwrittes the different states of border
        background: isSelected ? "rgba(24,140,236,1)" : "rgba(24,140,236,.2)",


      }

    };
  },



  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';

    return { ...provided, opacity, transition };
  }
}


const customRoomStyles = {
  dropdownIndicator: (base, state) => ({
    ...base,
    transition: 'all .2s ease',
    transform: state.isFocused ? 'rotate(180deg)' : null
  }),
  control: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      display: 'flex',

      borderRadius: '10rem',
      fontSize: '19px',
      borderTop: '1px solid lightgrey',
      borderLeft: '1px solid lightgrey',
      borderRight: '1px solid lightgrey',
      borderBottom: isFocused ? '2px solid #54aaf1' :'1px solid lightgrey',
      boxShadow: isFocused ? null : null,

      "&:hover": {
        // Overwrittes the different states of border
        borderColor: isFocused ? "none" : "rgba(68,68,68,.5)",


      }
    };
  },
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      background: isSelected ? 'rgb(24,140,236)' : 'white',
      color: isSelected ? 'white' : 'rgb(68,68,68)',
      cursor: isDisabled ? 'not-allowed' : 'default',

      "&:hover": {
        // Overwrittes the different states of border
        background: isSelected ? "rgba(24,140,236,1)" : "rgba(24,140,236,.2)",


      }
    };
  },



  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';

    return { ...provided, opacity, transition };
  }
}

/*
let currencyOptions = [
  {value: 1, label: '€ - Euro'},
  {value: 2, label: '$ - USD'},


]
*/
let paymentOptions = [
  {value: 1, label: 'Non-refundable'},
  {value: 2, label: 'Anzahlung'},
  {value: 3, label: 'Vorort'}



]
/*

const KlarnaIcon  = (props) => {

  return <svg version="1.1" viewBox="0 0 45 25" height="25" width="45" xmlns="http://www.w3.org/2000/svg">
    <title>Klarna Payment Badge</title>
    <g fill="none" fill-rule="evenodd">
      <g transform="translate(-310 -37)" fill-rule="nonzero">
        <g transform="translate(310 37)">
          <rect x="5.6843e-14" width="45" height="25" rx="4.321" fill="#FFB3C7"/>
          <g transform="translate(4.4136 8.4)" fill="#0A0B09">
            <path
              d="m36.38 6.2463c-0.58875 0-1.066 0.48158-1.066 1.0757 0 0.594 0.47725 1.0757 1.066 1.0757 0.58874 0 1.0661-0.48167 1.0661-1.0757 0-0.59416-0.47734-1.0757-1.0661-1.0757zm-3.5073-0.83166c0-0.81338-0.68897-1.4726-1.5389-1.4726s-1.539 0.65925-1.539 1.4726c0 0.81339 0.68898 1.4728 1.539 1.4728s1.5389-0.65941 1.5389-1.4728zm0.0057148-2.8622h1.6984v5.7242h-1.6984v-0.36584c-0.47982 0.3302-1.059 0.52431-1.6837 0.52431-1.6531 0-2.9933-1.3523-2.9933-3.0205s1.3402-3.0204 2.9933-3.0204c0.6247 0 1.2039 0.1941 1.6837 0.5244v-0.36619zm-13.592 0.74562v-0.74554h-1.7389v5.7241h1.7428v-2.6725c0-0.90167 0.96849-1.3863 1.6405-1.3863 0.0068818 0 0.013306 6.6771e-4 0.020188 7.527e-4v-1.6656c-0.68973 0-1.3241 0.298-1.6646 0.7452zm-4.3316 2.1166c0-0.81338-0.68905-1.4726-1.539-1.4726-0.84991 0-1.539 0.65925-1.539 1.4726 0 0.81339 0.68905 1.4728 1.539 1.4728 0.84998 0 1.539-0.65941 1.539-1.4728zm0.0056186-2.8622h1.6985v5.7242h-1.6985v-0.36584c-0.47982 0.3302-1.059 0.52431-1.6836 0.52431-1.6532 0-2.9934-1.3523-2.9934-3.0205s1.3402-3.0204 2.9934-3.0204c0.62464 0 1.2038 0.1941 1.6836 0.5244v-0.36619zm10.223-0.15396c-0.67846 0-1.3206 0.21255-1.7499 0.79895v-0.64465h-1.6911v5.7239h1.7119v-3.0081c0-0.87046 0.57847-1.2967 1.275-1.2967 0.74646 0 1.1756 0.44996 1.1756 1.2849v3.0199h1.6964v-3.6401c0-1.3321-1.0496-2.238-2.4179-2.238zm-17.374 5.8782h1.7777v-8.2751h-1.7777v8.2751zm-7.8091 0.0022581h1.8824v-8.2789h-1.8824v8.2789zm6.584-8.2789c0 1.7923-0.69219 3.4596-1.9256 4.6989l2.602 3.5803h-2.325l-2.8278-3.891 0.72981-0.55152c1.2103-0.91484 1.9045-2.3132 1.9045-3.8367h1.8421z"/>
          </g>
        </g>
      </g>
    </g>
  </svg>;
}
*/

//  {value: 3, label: 'Klarna',icon:<KlarnaIcon/>},
//  {value: 4, label: 'Giropay',icon:<img style={{width:'45px'}} src={GiropayIcon}/>},


let paymentMethods = [
  {value: 1, label: 'Kreditkarte', icon:<FaCreditCard style={{fontSize:'25px'}}/> },
  {value: 2, label: 'PayPal',icon:<FaCcPaypal style={{fontSize:'25px'}}/>},
  {value: 5, label: 'Banküberweisung',icon:<AiFillBank/>},


]

let paymentMethods_2 = [
  {value: 1, label: 'Kreditkarte', icon:<FaCreditCard style={{fontSize:'25px'}}/> },

]

const roomOptions_de = [
  {value: 1, label: '1 Zimmer'},
  {value: 2, label: '2 Zimmer'},
  {value: 3, label: '3 Zimmer'},
  {value: 4, label: '4 Zimmer'}

]


  const roomOptions = [
    {value: 1, label: 1},
    {value: 2, label: 2},
    {value: 3, label: 3},
    {value: 4, label: 4}
  ]

let guestOptions = [
  {value: 1, label: 1},
  {value: 2, label: 2},
  {value: 3, label: 3},

]

let guestOptions_1 = [
  {value: 1, label: '1'},


]

let guestOptions_2 = [
  {value: 1, label: '1 guest'},
  {value: 2, label: '2 guests'},

]

let guestOptions_3 = [

  {value: 1, label: 1},
  {value: 2, label: 2},
  {value: 3, label: 3}
]


let guestOptions_4 = [
  {value: 4, label: '4 guests'},
  {value: 5, label: '5 guests'},
  {value: 6, label: '6 guests'},
  {value: 7, label: '7 guests'},
  {value: 8, label: '8 guests'},
  {value: 9, label: '9 guests'},
  {value: 10, label: '10 guests'},
  {value: 11, label: '11 guests'},
  {value: 12, label: '12 guests'}
]


let bed_options_1 = [
  {value: 1, label: 'single'},
]

let bed_options_2 = [
  {value: 2, label: 'double'},
]

let bed_options_3 = [
  {value: 1, label: 'single'},
  {value: 2, label: 'double'},
]





const StyledP = styled.p`
 font-family: "Theano Didot",Regular;
font-size: 120%;
//font-style:italic;
//font-weight:bold;
line-height: 40px;
letter-spacing: 0px;
color:rgb(68, 68, 68);
width: 167px;
white-space:nowrap;

text-align: left !important;


margin-bottom:0em;
  @media screen and (max-width: 666px) {
width:100%;
   }


`;

const HeaderDiv = styled.div`
transition: all .2s ;
padding-bottom:3px;
text-align:left !important;



@media screen and (max-width: 666px) {
padding-bottom:0%;
width:100%;
}

`

const SelectHeading = styled.div`


width:100%;
display:flex;
align-items:center;
padding-top: 20px;
border:1px solid rgba(68,68,68,.04);


padding-top: 20px;

padding-right: 3%;
background:rgba(68,68,68,.02);
padding-bottom: 20px;
padding-left: 2%;

@media screen and (max-width: 666px) {
flex-direction:column;
justify-content:center;


}

@media screen and (max-width: 1200px) {
padding-left:2%;
padding-right:2%;
padding-top:2%;
padding-bottom:2%;

margin-left:auto;
margin-right:auto;

}



}



`



const SelectHeadingWithMargin = styled.div`
margin-top:6%;
width:100%;
display:flex;
//justify-content:space-between;
align-items:center;
border:1px solid rgba(68,68,68,.04);


padding-right:3%;
padding-left: 2%;
padding-top: 20px;

background:rgba(68,68,68,.02);
padding-bottom: 20px;

@media screen and (max-width: 666px) {
flex-direction:column;
justify-content:center;


}

@media screen and (max-width: 1200px) {
padding-left: 2%;
padding-right:2%;
padding-top:2%;
padding-bottom:2%;
margin-left:auto;
margin-right:auto;

}



}



`

const HeadingLine = styled.div`

height:0px;
width:0px;
border-top:2px solid  rgb(84, 170, 241);
margin-left:auto;
margin-right:auto;
//box-shadow: 1px 2px 4px rgba(0,0,0,.1);
border-radius:2px;
transition:all 0.2s;

`



const GuestsDiv = styled.div`
width:170px;
height:70px;
text-align:left !important;
margin-left:10%;
@media screen and (max-width: 666px) {
margin-left:0px;
width:50%;
//margin-left:auto;
//margin-right:auto;
}
`

const FlexDropDown = styled.div`
cursor:pointer;
display:flex;
justify-content:space-between;
width:34%;
align-items:flex-end;
:active {
  ${ArrowDiv}{
  //box-shadow: 0 5px #666;
 // transform: translateY(1px);
 // background: rgba(68,68,68,.2)
}

${HeaderDiv}{
 // transform: translateY(1px);
}
}



@media screen and (max-width: 666px) {
justify-content:flex-start;
align-items:center;
width:100%;
margin-left:auto;
margin-right:auto;
margin-bottom:1rem;

}


`

const StyledBlock = styled.div`
background-color:white;
//  padding-bottom:14px;
//border: 1px solid lightgrey;

`



const FlexSelector = styled.div`
display:flex;
align-items:center;
border-left: 1px solid lightgrey;
border-right: 1px solid lightgrey;
border-top: 1px solid lightgrey;
border-radius:10rem;
padding-left:11px;
padding-right:11px;

transition: all .7s;
background:white;

:hover{
//1px solid rgba(68,68,68,.5 );

}



`


const DesktopGuestBeds = styled.div`
align-items: center;
display:flex;
width:100%;
justify-content:space-between;

@media screen and (max-width: 666px) {
display:none;

}
`
const FlexDivTwo= styled.div`
width:100%;
display:flex;
justify-content:space-between;
padding-left:2%;

`

const FlexDiv = styled.div`
display:none;

@media screen and (max-width: 666px) {
display:flex;
padding-left:2%;
padding-right:2%;

}
`



const SelectSuite = (props) => {

    return <Suite price={props.price} nights={props.nights}  isSelected={props.isSelected} selectBlock={props.selectBlock} handler={props.handler}>
    </Suite>
  /*
   if (props.availableSuites > 0) {
 }
   else {
    return <a/>
  }
   */


}

const SelectStudio = (props) => {

    return <Studio images={props.images} price={props.price} nights={props.nights} isSelected={props.isSelected} selectBlock={props.selectBlock} handler={props.handler}>
    </Studio>


}

const SelectStudioPlus = (props) => {
    return <StudioPlus price={props.price} nights={props.nights}  isSelected={props.isSelected} selectBlock={props.selectBlock} handler={props.handler}>
    </StudioPlus>


}
// render room labels

const SelectBlock_1 = (props) => {
  const sb = 1
  const s = props.roomsSelected
  const fs = props.firstSelection
  const stCount = props.stCount
  const selectedGuests = props.selectedGuests.value

  //const allResidences = props.datoCmsResidences

  //console.log(allResidences)


  const guestsLeft =selectedGuests-(stCount*2)
  let allSelected = props.currSelected
  let moreRooms = s.value - allSelected
  let selText = props.selectText;

  if(fs[0]){
    selText='Studio'
  }
  if(fs[1]){
    selText='Studio Plus'
  }
  if(fs[2]){
    selText='Suite'
  }


//  if (0=0) {
// s!== undefined && props.availableRooms >= s.value && props.availableRooms != 0 && s.value >= 1
   // if ( selectedGuests===3 ) {
/*
      return <StyledBlock>
        <SelectHeading >
          <FlexDropDown onClick={() => props.toggleSelect()}>

        <HeaderDiv  >
          <Span><FormattedMessage id="booking_fixed_box_3_1" />  1</Span>
          <FlexSelector style={{ borderBottom: props.blockClosed ? '1px solid lightgrey': '2px solid rgb(84,170,241)'}}>

            {(selText==='Studio'||selText==='Studio Plus'||selText==='Suite')&&
            <StyledP>{selText}</StyledP>
            }
            {(fs[0]===false&&fs[1]===false&&fs[2]===false)&&
            <StyledP style={{opacity:.5}}><FormattedMessage id={'selText'}/></StyledP>
            }
            <ArrowDiv onClick={() => props.toggleSelect()}> <ArrowImg_2 style={{transform: `rotate(${props.rotation}deg)`}} src={arrowDown}/>
            </ArrowDiv>
          </FlexSelector>
        </HeaderDiv>

          </FlexDropDown>
          <DesktopGuestBeds>
          <GuestsDiv>
          <Span><FormattedMessage id="booking_fixed_box_5_1" /></Span>
            <StyledSelect>
              <Select type={'number'} styles={customGuestStyles} components={{ DropdownIndicator }} onChange={props.handleGuestSelection}
                      value={props.selectedGuests}
                      clearable={false} options={props.guestOptions}/>
            </StyledSelect>        </GuestsDiv>
            <Checkbox style={{ opacity: props.checkVisible ? 1: 0}}>
              { props.checkVisible ? <StyledCheck /> : null }
            </Checkbox>
          </DesktopGuestBeds>

      </SelectHeading>
        <StyledSlideDown closed={props.blockClosed} className={'css-2289437'}>
          <FlexDiv>
            <GuestsDiv>
              <Span><FormattedMessage id="booking_fixed_box_5_1" /></Span>
              <StyledSelect>
                <Select type={'number'} styles={customGuestStyles} components={{ DropdownIndicator }} onChange={props.handleGuestSelection}
                        value={props.selectedGuests}
                        clearable={false} options={props.guestOptions}/>
              </StyledSelect>        </GuestsDiv>

          </FlexDiv>
        <SelectStudioPlus  price={props.stpPrice} nights={props.nights} isSelected={fs[1]} selectBlock={sb} handler={props.handleCatState}
                          availableStudioPlus={props.availableStudioPlus}/>
        <SelectSuite price={props.suPrice} nights={props.nights} isSelected={fs[2]} selectBlock={sb} handler={props.handleCatState}
                     availableSuites={props.availableSuites}/>
        </StyledSlideDown>

      </StyledBlock>

  */
    return <StyledBlock>

      <SelectHeading >
      <FlexDropDown onClick={() => props.toggleSelect()}>

        <HeaderDiv  >
          <Span><FormattedMessage id="booking_fixed_box_3_1" /> 1</Span>
          <FlexSelector style={{ borderBottom: props.blockClosed ? '1px solid lightgrey': '2px solid rgb(84,170,241)'}}>
            {(selText==='Studio'||selText==='Studio Plus'||selText==='Suite')&&
            <StyledP>{selText}</StyledP>
            }
            {(fs[0]===false&&fs[1]===false&&fs[2]===false)&&
            <StyledP style={{opacity:.5}}><FormattedMessage id={'selText'}/></StyledP>
            }
            <ArrowDiv onClick={() => props.toggleSelect()}> <ArrowImg_2 style={{transform: `rotate(${props.rotation}deg)`}} src={arrowDown}/>
            </ArrowDiv>
          </FlexSelector>
        </HeaderDiv>

      </FlexDropDown>
      <DesktopGuestBeds>
      <GuestsDiv>
        <Span><FormattedMessage id="booking_fixed_box_5_1" /></Span>
        <StyledSelect>
          <Select type={'number'} styles={customGuestStyles} components={{ DropdownIndicator }} onChange={props.handleGuestSelection}
                  value={props.selectedGuests}
                  clearable={false} options={props.guestOptions}/>
        </StyledSelect>        </GuestsDiv>
        <Checkbox style={{ opacity: props.checkVisible ? 1: 0}}>
          { props.checkVisible ? <StyledCheck /> : null }
        </Checkbox>
      </DesktopGuestBeds>

    </SelectHeading>
      <StyledSlideDown closed={props.blockClosed} className={'css-2289437'}>
        <FlexDiv>
          <GuestsDiv>
            <Span><FormattedMessage id="booking_fixed_box_5_1" /></Span>
            <StyledSelect>
              <Select type={'number'} styles={customGuestStyles} components={{ DropdownIndicator }} onChange={props.handleGuestSelection}
                      value={props.selectedGuests}
                      clearable={false} options={props.guestOptions}/>
            </StyledSelect>        </GuestsDiv>

        </FlexDiv>
      <SelectStudio images={props.images} price={props.stPrice} nights={props.nights}  isSelected={fs[0]} selectBlock={sb} handler={props.handleCatState}
                    availableStudios={props.availableStudios}/>
      <SelectStudioPlus price={props.stpPrice} nights={props.nights} isSelected={fs[1]} selectBlock={sb} handler={props.handleCatState}
                        availableStudioPlus={props.availableStudioPlus}/>
      <SelectSuite price={props.suPrice} nights={props.nights}  isSelected={fs[2]} selectBlock={sb} handler={props.handleCatState}
                   availableSuites={props.availableSuites}/>

      </StyledSlideDown>
    </StyledBlock>
  /*
  else {



    return <a/>

  }
  */

}

const SelectBlock_2 = (props) => {
  const sb = 2
  const s = props.roomsSelected
  const fs = props.secondSelection


  const selectedGuests = props.selectedGuests.value
  let allSelected = props.currSelected

 // let moreRooms = s.value - allSelected
  const stCount = props.stCount
 // const guestsLeft =selectedGuests-(stCount*2)

  let selText = props.selectText;
  if(fs[0]){
    selText='Studio'
  }
  if(fs[1]){
    selText='Studio Plus'
  }
  if(fs[2]){
    selText='Suite'
  }



  if (s !== undefined && props.availableRooms >= s.value && props.availableRooms != 0 && s.value >= 2) {
    if (selectedGuests===3) {

      return <StyledBlock>

        <SelectHeadingWithMargin >
          <FlexDropDown onClick={() => props.toggleSelect()}>

            <HeaderDiv  >
              <Span><FormattedMessage id="booking_fixed_box_3_1" /> 2</Span>
              <FlexSelector style={{ borderBottom: props.blockClosed ? '1px solid lightgrey': '2px solid rgb(84,170,241)'}}>

                {(selText==='Studio'||selText==='Studio Plus'||selText==='Suite')&&
                <StyledP>{selText}</StyledP>
                }
                {(fs[0]===false&&fs[1]===false&&fs[2]===false)&&
                <StyledP style={{opacity:.5}}><FormattedMessage id={'selText'}/></StyledP>
                }                <ArrowDiv onClick={() => props.toggleSelect()}> <ArrowImg_2 style={{transform: `rotate(${props.rotation}deg)`}} src={arrowDown}/>
                </ArrowDiv>
              </FlexSelector>
            </HeaderDiv>

          </FlexDropDown>
          <DesktopGuestBeds>
          <GuestsDiv>
            <Span><FormattedMessage id="booking_fixed_box_5_1" /></Span>
            <StyledSelect>
              <Select type={'number'} styles={customGuestStyles} components={{ DropdownIndicator }} onChange={props.handleGuestSelection}
                      value={props.selectedGuests}
                      clearable={false} options={props.guestOptions}/>
            </StyledSelect>        </GuestsDiv>
            <Checkbox style={{ opacity: props.checkVisible ? 1: 0}}>
              { props.checkVisible ? <StyledCheck /> : null }
            </Checkbox>
          </DesktopGuestBeds>

        </SelectHeadingWithMargin>
        <StyledSlideDown closed={props.blockClosed} className={'css-2289437'}>
          <FlexDiv>
            <GuestsDiv>
              <Span><FormattedMessage id="booking_fixed_box_5_1" /></Span>
              <StyledSelect>
                <Select type={'number'} styles={customGuestStyles} components={{ DropdownIndicator }} onChange={props.handleGuestSelection}
                        value={props.selectedGuests}
                        clearable={false} options={props.guestOptions}/>
              </StyledSelect>        </GuestsDiv>

          </FlexDiv>
          <SelectStudioPlus price={props.stpPrice} nights={props.nights}  isSelected={fs[1]} selectBlock={sb} handler={props.handleCatState}
                            availableStudioPlus={props.availableStudioPlus}/>
          <SelectSuite price={props.suPrice} nights={props.nights} isSelected={fs[2]} selectBlock={sb} handler={props.handleCatState}
                       availableSuites={props.availableSuites}/>
        </StyledSlideDown>

      </StyledBlock>
  }
  return <StyledBlock>

    <SelectHeadingWithMargin >
    <FlexDropDown onClick={() => props.toggleSelect()}>

      <HeaderDiv  >
        <Span><FormattedMessage id="booking_fixed_box_3_1" /> 2</Span>
        <FlexSelector style={{ borderBottom: props.blockClosed ? '1px solid lightgrey': '2px solid rgb(84,170,241)'}}>

          {(selText==='Studio'||selText==='Studio Plus'||selText==='Suite')&&
          <StyledP>{selText}</StyledP>
          }
          {(fs[0]===false&&fs[1]===false&&fs[2]===false)&&
          <StyledP style={{opacity:.5}}><FormattedMessage id={'selText'}/></StyledP>
          }          <ArrowDiv onClick={() => props.toggleSelect()}> <ArrowImg_2 style={{transform: `rotate(${props.rotation}deg)`}} src={arrowDown}/>
          </ArrowDiv>
        </FlexSelector>
      </HeaderDiv>

    </FlexDropDown>
    <DesktopGuestBeds>
    <GuestsDiv>
      <Span><FormattedMessage id="booking_fixed_box_5_1" /></Span>
      <StyledSelect>
        <Select type={'number'} styles={customGuestStyles} components={{ DropdownIndicator }} onChange={props.handleGuestSelection}
                value={props.selectedGuests}
                clearable={false} options={props.guestOptions}/>
      </StyledSelect>        </GuestsDiv>
      <Checkbox style={{ opacity: props.checkVisible ? 1: 0}}>
        { props.checkVisible ? <StyledCheck /> : null }
      </Checkbox>
    </DesktopGuestBeds>

  </SelectHeadingWithMargin>
    <StyledSlideDown closed={props.blockClosed} className={'css-2289437'}>
      <FlexDiv>
        <GuestsDiv>
          <Span><FormattedMessage id="booking_fixed_box_5_1" /></Span>
          <StyledSelect>
            <Select type={'number'} styles={customGuestStyles} components={{ DropdownIndicator }} onChange={props.handleGuestSelection}
                    value={props.selectedGuests}
                    clearable={false} options={props.guestOptions}/>
          </StyledSelect>        </GuestsDiv>

      </FlexDiv>
      <SelectStudio images={props.images} price={props.stPrice} nights={props.nights} isSelected={fs[0]} selectBlock={sb} handler={props.handleCatState}
                    availableStudios={props.availableStudios}/>
      <SelectStudioPlus price={props.stpPrice} nights={props.nights}  isSelected={fs[1]} selectBlock={sb} handler={props.handleCatState}
                        availableStudioPlus={props.availableStudioPlus}/>
      <SelectSuite price={props.suPrice} nights={props.nights} isSelected={fs[2]} selectBlock={sb} handler={props.handleCatState}
                   availableSuites={props.availableSuites}/>

    </StyledSlideDown>
  </StyledBlock>
  }
  else {


    return <a/>

  }
}

const SelectBlock_3 = (props) => {
  const sb = 3
  const s = props.roomsSelected
  const fs = props.thirdSelection
  const selectedGuests = props.selectedGuests.value
  let allSelected = props.currSelected

//  let moreRooms = s.value - allSelected
  const stCount = props.stCount
 // const guestsLeft =selectedGuests-(stCount*2)
  let selText = props.selectText;
  if(fs[0]){
    selText='Studio'
  }
  if(fs[1]){
    selText='Studio Plus'
  }
  if(fs[2]){
    selText='Suite'
  }

  if (s !== undefined && props.availableRooms >= s.value && props.availableRooms != 0 && s.value >= 3) {
    if ( selectedGuests===3) {

      return <StyledBlock>

        <SelectHeadingWithMargin >
          <FlexDropDown onClick={() => props.toggleSelect()}>

            <HeaderDiv  >
              <Span><FormattedMessage id="booking_fixed_box_3_1" /> 3</Span>
              <FlexSelector style={{ borderBottom: props.blockClosed ? '1px solid lightgrey': '2px solid rgb(84,170,241)'}}>

                {(selText==='Studio'||selText==='Studio Plus'||selText==='Suite')&&
                <StyledP>{selText}</StyledP>
                }
                {(fs[0]===false&&fs[1]===false&&fs[2]===false)&&
                <StyledP style={{opacity:.5}}><FormattedMessage id={'selText'}/></StyledP>
                }                <ArrowDiv onClick={() => props.toggleSelect()}> <ArrowImg_2 style={{transform: `rotate(${props.rotation}deg)`}} src={arrowDown}/>
                </ArrowDiv>
              </FlexSelector>
            </HeaderDiv>

          </FlexDropDown>
          <DesktopGuestBeds>
          <GuestsDiv>
            <Span><FormattedMessage id="booking_fixed_box_5_1" /></Span>
            <StyledSelect>
              <Select type={'number'} styles={customGuestStyles} components={{ DropdownIndicator }} onChange={props.handleGuestSelection}
                      value={props.selectedGuests}
                      clearable={false} options={props.guestOptions}/>
            </StyledSelect>        </GuestsDiv>
            <Checkbox style={{ opacity: props.checkVisible ? 1: 0}}>
              { props.checkVisible ? <StyledCheck /> : null }
            </Checkbox>
          </DesktopGuestBeds>

        </SelectHeadingWithMargin>
        <StyledSlideDown closed={props.blockClosed} className={'css-2289437'}>
          <FlexDiv>
            <GuestsDiv>
              <Span><FormattedMessage id="booking_fixed_box_5_1" /></Span>
              <StyledSelect>
                <Select type={'number'} styles={customGuestStyles} components={{ DropdownIndicator }} onChange={props.handleGuestSelection}
                        value={props.selectedGuests}
                        clearable={false} options={props.guestOptions}/>
              </StyledSelect>        </GuestsDiv>

          </FlexDiv>
          <SelectStudioPlus price={props.stpPrice} nights={props.nights}  isSelected={fs[1]} selectBlock={sb} handler={props.handleCatState}
                            availableStudioPlus={props.availableStudioPlus}/>
          <SelectSuite price={props.suPrice} nights={props.nights}  isSelected={fs[2]} selectBlock={sb} handler={props.handleCatState}
                       availableSuites={props.availableSuites}/>
        </StyledSlideDown>

      </StyledBlock>
    }
    return <StyledBlock>

      <SelectHeadingWithMargin >
      <FlexDropDown onClick={() => props.toggleSelect()}>

        <HeaderDiv  >
          <Span><FormattedMessage id="booking_fixed_box_3_1" /> 3</Span>
          <FlexSelector style={{ borderBottom: props.blockClosed ? '1px solid lightgrey': '2px solid rgb(84,170,241)'}}>

            {(selText==='Studio'||selText==='Studio Plus'||selText==='Suite')&&
            <StyledP>{selText}</StyledP>
            }
            {(fs[0]===false&&fs[1]===false&&fs[2]===false)&&
            <StyledP style={{opacity:.5}}><FormattedMessage id={'selText'}/></StyledP>
            }            <ArrowDiv onClick={() => props.toggleSelect()}> <ArrowImg_2 style={{transform: `rotate(${props.rotation}deg)`}} src={arrowDown}/>
            </ArrowDiv>
          </FlexSelector>
        </HeaderDiv>

      </FlexDropDown>
      <DesktopGuestBeds>
      <GuestsDiv>
        <Span><FormattedMessage id="booking_fixed_box_5_1" /></Span>
        <StyledSelect>
          <Select type={'number'} styles={customGuestStyles} components={{ DropdownIndicator }} onChange={props.handleGuestSelection}
                  value={props.selectedGuests}
                  clearable={false} options={props.guestOptions}/>
        </StyledSelect>        </GuestsDiv>
        <Checkbox style={{ opacity: props.checkVisible ? 1: 0}}>
          { props.checkVisible ? <StyledCheck /> : null }
        </Checkbox>
      </DesktopGuestBeds>

    </SelectHeadingWithMargin>
      <StyledSlideDown closed={props.blockClosed} className={'css-2289437'}>
        <FlexDiv>
          <GuestsDiv>
            <Span><FormattedMessage id="booking_fixed_box_5_1" /></Span>
            <StyledSelect>
              <Select type={'number'} styles={customGuestStyles} components={{ DropdownIndicator }} onChange={props.handleGuestSelection}
                      value={props.selectedGuests}
                      clearable={false} options={props.guestOptions}/>
            </StyledSelect>        </GuestsDiv>

        </FlexDiv>
        <SelectStudio  images={props.images} price={props.stPrice} nights={props.nights} isSelected={fs[0]} selectBlock={sb} handler={props.handleCatState}
                      availableStudios={props.availableStudios}/>
        <SelectStudioPlus price={props.stpPrice} nights={props.nights} isSelected={fs[1]} selectBlock={sb} handler={props.handleCatState}
                          availableStudioPlus={props.availableStudioPlus}/>
        <SelectSuite price={props.suPrice} nights={props.nights}  isSelected={fs[2]} selectBlock={sb} handler={props.handleCatState}
                     availableSuites={props.availableSuites}/>

      </StyledSlideDown>
    </StyledBlock>
  }
  else {


    return <a/>

  }
}

const SelectBlock_4 = (props) => {
  const sb = 4
  const s = props.roomsSelected
  const fs = props.fourthSelection
  const selectedGuests = props.selectedGuests.value
  let allSelected = props.currSelected

 // let moreRooms = s.value - allSelected
  const stCount = props.stCount
//  const guestsLeft =selectedGuests-(stCount*2)
  let selText = props.selectText;
  if(fs[0]){
    selText='Studio'
  }
  if(fs[1]){
    selText='Studio Plus'
  }
  if(fs[2]){
    selText='Suite'
  }

  if (s !== undefined && props.availableRooms >= s.value && props.availableRooms != 0 && s.value >= 4) {
    if ( selectedGuests===3 ) {


      return <StyledBlock>

        <SelectHeadingWithMargin >
          <FlexDropDown onClick={() => props.toggleSelect()}>

            <HeaderDiv  >
              <Span><FormattedMessage id="booking_fixed_box_3_1" /> 4</Span>
              <FlexSelector style={{ borderBottom: props.blockClosed ? '1px solid lightgrey': '2px solid rgb(84,170,241)'}}>

                {(selText==='Studio'||selText==='Studio Plus'||selText==='Suite')&&
                <StyledP>{selText}</StyledP>
                }
                {(fs[0]===false&&fs[1]===false&&fs[2]===false)&&
                <StyledP style={{opacity:.5}}><FormattedMessage id={'selText'}/></StyledP>
                }                <ArrowDiv onClick={() => props.toggleSelect()}> <ArrowImg_2 style={{transform: `rotate(${props.rotation}deg)`}} src={arrowDown}/>
                </ArrowDiv>
              </FlexSelector>
            </HeaderDiv>

          </FlexDropDown>
          <DesktopGuestBeds>
          <GuestsDiv>
            <Span><FormattedMessage id="booking_fixed_box_5_1" /></Span>
            <StyledSelect>
              <Select type={'number'} styles={customGuestStyles} components={{ DropdownIndicator }} onChange={props.handleGuestSelection}
                      value={props.selectedGuests}
                      clearable={false} options={props.guestOptions}/>
            </StyledSelect>        </GuestsDiv>
            <Checkbox style={{ opacity: props.checkVisible ? 1: 0}}>
              { props.checkVisible ? <StyledCheck /> : null }
            </Checkbox>
          </DesktopGuestBeds>

        </SelectHeadingWithMargin>
        <StyledSlideDown closed={props.blockClosed} className={'css-2289437'}>
          <FlexDiv>
            <GuestsDiv>
              <Span><FormattedMessage id="booking_fixed_box_5_1" /></Span>
              <StyledSelect>
                <Select type={'number'} styles={customGuestStyles} components={{ DropdownIndicator }} onChange={props.handleGuestSelection}
                        value={props.selectedGuests}
                        clearable={false} options={props.guestOptions}/>
              </StyledSelect>        </GuestsDiv>

          </FlexDiv>
          <SelectStudioPlus price={props.stpPrice} nights={props.nights} isSelected={fs[1]} selectBlock={sb} handler={props.handleCatState}
                            availableStudioPlus={props.availableStudioPlus}/>
          <SelectSuite price={props.suPrice} nights={props.nights} isSelected={fs[2]} selectBlock={sb} handler={props.handleCatState}
                       availableSuites={props.availableSuites}/>
        </StyledSlideDown>

      </StyledBlock>
    }
    return <StyledBlock>

      <SelectHeadingWithMargin >
      <FlexDropDown onClick={() => props.toggleSelect()}>

        <HeaderDiv  >
          <Span><FormattedMessage id="booking_fixed_box_3_1" /> 4</Span>
          <FlexSelector style={{ borderBottom: props.blockClosed ? '1px solid lightgrey': '2px solid rgb(84,170,241)'}}>

            {(selText==='Studio'||selText==='Studio Plus'||selText==='Suite')&&
            <StyledP>{selText}</StyledP>
            }
            {(fs[0]===false&&fs[1]===false&&fs[2]===false)&&
            <StyledP style={{opacity:.5}}><FormattedMessage id={'selText'}/></StyledP>
            }            <ArrowDiv onClick={() => props.toggleSelect()}> <ArrowImg_2 style={{transform: `rotate(${props.rotation}deg)`}} src={arrowDown}/>
            </ArrowDiv>
          </FlexSelector>
        </HeaderDiv>

      </FlexDropDown>
      <DesktopGuestBeds>
      <GuestsDiv>
        <Span><FormattedMessage id="booking_fixed_box_5_1" /></Span>
        <StyledSelect>
          <Select type={'number'} styles={customGuestStyles} components={{ DropdownIndicator }} onChange={props.handleGuestSelection}
                  value={props.selectedGuests}
                  clearable={false} options={props.guestOptions}/>
        </StyledSelect>        </GuestsDiv>
        <Checkbox style={{ opacity: props.checkVisible ? 1: 0}}>
          { props.checkVisible ? <StyledCheck /> : null }
        </Checkbox>
      </DesktopGuestBeds>

    </SelectHeadingWithMargin>
      <StyledSlideDown closed={props.blockClosed} className={'css-2289437'}>
        <FlexDiv>
          <GuestsDiv>
            <Span><FormattedMessage id="booking_fixed_box_5_1" /></Span>
            <StyledSelect>
              <Select type={'number'} styles={customGuestStyles} components={{ DropdownIndicator }} onChange={props.handleGuestSelection}
                      value={props.selectedGuests}
                      clearable={false} options={props.guestOptions}/>
            </StyledSelect>        </GuestsDiv>

        </FlexDiv>
        <SelectStudio images={props.images} price={props.stPrice} nights={props.nights} isSelected={fs[0]} selectBlock={sb} handler={props.handleCatState}
                      availableStudios={props.availableStudios}/>
        <SelectStudioPlus price={props.stpPrice} nights={props.nights} isSelected={fs[1]} selectBlock={sb} handler={props.handleCatState}
                          availableStudioPlus={props.availableStudioPlus}/>
        <SelectSuite price={props.suPrice} nights={props.nights} isSelected={fs[2]} selectBlock={sb} handler={props.handleCatState}
                     availableSuites={props.availableSuites}/>

      </StyledSlideDown>
    </StyledBlock>
  }
  else {


    return <a/>

  }
}

const SelectedNights = (props) => {
  const nights = props.nights
  if (nights != 0 && nights != 1) {
    return <NightLabel>
      <IoIosMoon/> <a> {props.nights} <FormattedMessage id="booking_fixed_box_7" /></a>
    </NightLabel>
  }
  if (nights != 0 && nights == 1) {
    return <NightLabel>
      <IoIosMoon/> <a> {props.nights} <FormattedMessage id="booking_fixed_box_6" /></a>
    </NightLabel>
  }

  return <Nonvisible/>


}

const SelectedGuests = (props) => {
  const guests = props.guests
  let g = <FormattedMessage id="booking_fixed_box_5" />
  if (guests != 0) {
    if (guests === 1) {
      g = <FormattedMessage id="booking_fixed_box_4" />
    }
    return <GuestLabel>
      <MdPeople/> <a>{guests} {g} </a>
    </GuestLabel>


  }
  else {
    return <a/>

  }
}

const Nonvisible = styled.a`
display:none;
`

const StudioIcon = styled(IoTriangleOutline)`
fill:#bf8970;
color:#bf8970;
font-size: 14px !important;
padding-bottom: 3.61px;
 transform: rotate(180deg);
`
const StudioPlusIcon = styled(IoTriangleOutline)`
fill:#c0c0c0;
color:#c0c0c0;
font-size: 14px !important;
padding-bottom: 3.61px;
 transform: rotate(180deg);

`
const SuiteIcon = styled(IoTriangleOutline)`
fill:#e7bd42;
color:#e7bd42;
font-size: 14px !important;
padding-bottom: 3.61px;
 transform: rotate(180deg);

`


const ConditionalStPricing = (props) => {
  let stCounter = props.stSelected;
let conditionalPrice = 0;
  if(props.payTotal){
    conditionalPrice=props.finalStudioPrice15
  }
  if(props.payHalf){
    conditionalPrice=props.finalStudioPrice7
  }

  if(props.payDuringStay){
    conditionalPrice=props.finalStudioPrice5
  }
  let price = props.finalStudioPrice.toLocaleString('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2
  });

  if (stCounter != 0) {
    return <StudioPricing>
      <PricingLabel><StudioIcon/> {stCounter}x Studio </PricingLabel> <StudioPrice>  </StudioPrice>
    </StudioPricing>
  }
  else {


    return <Nonvisible/>

  }
}

//{price}

const ConditionalStpPricing = (props) => {
  let stpCounter = props.stpSelected;
  let conditionalPrice = 0;
  if(props.payTotal){
    conditionalPrice=props.finalStudioPlusPrice15
  }
  if(props.payHalf){
    conditionalPrice=props.finalStudioPlusPrice7
  }

  if(props.payDuringStay){
    conditionalPrice=props.finalStudioPlusPrice5
  }
  let price = props.finalStudioPlusPrice.toLocaleString('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2
  });


  if (stpCounter != 0) {
    return <StudioPlusPricing>
      <PricingLabel><StudioPlusIcon/> {stpCounter}x Studio Plus </PricingLabel> <StudioPlusPrice>  </StudioPlusPrice>
    </StudioPlusPricing>
  }
  else {


    return <Nonvisible/>

  }
}

//{price}

const ConditionalSuPricing = (props) => {

  let suCounter = props.suSelected;
  let conditionalPrice = 0;
  if(props.payTotal){
    conditionalPrice=props.finalSuitePrice15
  }
  if(props.payHalf){
    conditionalPrice=props.finalSuitePrice7
  }

  if(props.payDuringStay){
    conditionalPrice=props.finalSuitePrice5
  }
  let price = props.finalSuitePrice.toLocaleString('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2
  });


  if (suCounter != 0) {
    return <SuitePricing>
      <PricingLabel><SuiteIcon/> {suCounter}x Suite </PricingLabel> <StudioPlusPrice>  </StudioPlusPrice>
    </SuitePricing>
  }
  else {


    return <Nonvisible/>

  }
}
//{price}
const Tax = styled.div`
color:rgba(68,68,68,.5);
font-size:10px;
`


const ConditionalTotalPricing = (props) => {
  let total = 0;

  if(props.payTotal){
    total=props.totalPrice15
  }
  if(props.payHalf){
    total=props.totalPrice7
  }

  if(props.payDuringStay){
    total=props.totalPrice5
  }
  let final = total.toLocaleString('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2
  });

  if (total != 0 && props.allSelected!=0) {
    return <TotalPricing>
      <PricingLabel> </PricingLabel> <TotalPrice>
      </TotalPrice>
    </TotalPricing>
  }

  /*
  Total:
  {final}
        <Tax><FormattedMessage id={'payment_text_18'}/></Tax>

   */
  else {


    return <Nonvisible/>

  }
}

const ConditionalPayButton = (props) => {
  let total = props.finalPrice;
  let allAvailable = props.avail
  let allSelected = props.currSelected
  let moreRooms = props.selRooms - allSelected
  let stDate = props.stDate;
  let eDate = props.eDate
  //let emailVerified=props.email;

  if (stDate != undefined && eDate != undefined && (allAvailable >= props.selRooms) && props.showSpinner==false) {
    if (moreRooms == 1 && allSelected == 0) {
      return <SelectMoreRooms> <FormattedMessage id="booking_fixed_box_8"/></SelectMoreRooms>
    }
    if (moreRooms >= 2 && allSelected == 0) {
      return <SelectMoreRooms> <FormattedMessage id="booking_fixed_box_8_1"/> {moreRooms} <FormattedMessage
        id="booking_fixed_box_8_4"/> </SelectMoreRooms>
    }
    if (moreRooms === 1 && allSelected != 0) {
      return <SelectMoreRooms> <FormattedMessage id="booking_fixed_box_8_1"/> 1 <FormattedMessage
        id="booking_fixed_box_8_2"/></SelectMoreRooms>
    }

    if (moreRooms > 1) {
      return <SelectMoreRooms> <FormattedMessage id="booking_fixed_box_8_1"/> {moreRooms} <FormattedMessage
        id="booking_fixed_box_8_3"/></SelectMoreRooms>
    }
  }
  if(props.guestFirstName==='' || props.guestLastName==='' || props.guestZipCode==='' || props.guestEmail===''){
    return <SelectMoreRooms> <FormattedMessage id="booking_fixed_box_18"/> </SelectMoreRooms>
  }
  if (total != 0 && moreRooms == 0 &&(props.paypal || props.paySepa ||
    props.payCreditCard || props.payDuringStay || props.payKlarna || props.payGiropay || props.payBankTransfer)
    ) {
    return <NextButton style={{display:(props.guestFirstName!='' && props.guestLastName!='' && props.guestZipCode!='' && props.guestEmail!='') ? 'flex':'none'}}  onClick={props.openModal}> <A><FormattedMessage id={'btn_x'}/></A></NextButton>


  }



  return <Nonvisible/>

}



const ConditionalNextButton = (props) => {
  let total = props.finalPrice;
  let allAvailable = props.avail;
  let allSelected = props.currSelected;
  let moreRooms = props.selRooms - allSelected;
  let stDate = props.stDate;
  let eDate = props.eDate;
  if (total != 0 && moreRooms == 0 && props.showSpinner==false) {

    return <NextButton > <A><FormattedMessage id="btn_book" /></A></NextButton>


  }
  //onClick={props.openModal}
  if (stDate != undefined && eDate != undefined && (allAvailable >= props.selRooms) && moreRooms!=0 && props.showSpinner==false) {
    if (moreRooms == 1 && allSelected == 0) {
      return <SelectMoreRooms> <FormattedMessage id="booking_fixed_box_8" /></SelectMoreRooms>
    }
    if (moreRooms >= 2 && allSelected == 0) {
      return <SelectMoreRooms> <FormattedMessage id="booking_fixed_box_8_1" /> {moreRooms} <FormattedMessage id="booking_fixed_box_8_4" /> </SelectMoreRooms>
    }
    if (moreRooms === 1 && allSelected != 0) {
      return <SelectMoreRooms> <FormattedMessage id="booking_fixed_box_8_1" /> 1 <FormattedMessage id="booking_fixed_box_8_2" /></SelectMoreRooms>
    }

    if (moreRooms > 1) {
      return <SelectMoreRooms> <FormattedMessage id="booking_fixed_box_8_1" /> {moreRooms} <FormattedMessage id="booking_fixed_box_8_3" /></SelectMoreRooms>
    }

  }




  return <Nonvisible/>
};

const ConditionalNextButton2 = (props) => {
  let total = props.finalPrice;
  let allAvailable = props.avail;
  let allSelected = props.currSelected;
  let moreRooms = props.selRooms - allSelected;
  let stDate = props.stDate;
  let eDate = props.eDate;
  if (total != 0 && moreRooms == 0 && props.showSpinner==false) {

    return <NextButton > <A><FormattedMessage id="btn_book" /></A></NextButton>


  }
  //onClick={props.openModal}
  if (stDate != undefined && eDate != undefined && (allAvailable >= props.selRooms) && moreRooms!=0 && props.showSpinner==false) {
    if (moreRooms == 1 && allSelected == 0) {
      return <SelectMoreRooms> <FormattedMessage id="booking_fixed_box_8" /></SelectMoreRooms>
    }
    if (moreRooms >= 2 && allSelected == 0) {
      return <SelectMoreRooms> <FormattedMessage id="booking_fixed_box_8_1" /> {moreRooms} <FormattedMessage id="booking_fixed_box_8_4" /> </SelectMoreRooms>
    }
    if (moreRooms === 1 && allSelected != 0) {
      return <SelectMoreRooms> <FormattedMessage id="booking_fixed_box_8_1" /> 1 <FormattedMessage id="booking_fixed_box_8_2" /></SelectMoreRooms>
    }

    if (moreRooms > 1) {
      return <SelectMoreRooms> <FormattedMessage id="booking_fixed_box_8_1" /> {moreRooms} <FormattedMessage id="booking_fixed_box_8_3" /></SelectMoreRooms>
    }

  }


  return <Nonvisible/>
};


const ConditionalEditButton = (props) => {
  if (!props.sheetOpen) {

    return <EditButton  onClick={props.openBottomSheet}> <FiEdit/></EditButton>


  }


  return  <CloseButton onClick={props.toggleBottomSheet}>
    <svg className="DateRangePickerInput_clearDates_svg DateRangePickerInput_clearDates_svg_1" focusable="false"
         viewBox="0 0 12 12">
      <path fill='white'
            d="M11.53.47a.75.75 0 0 0-1.061 0l-4.47 4.47L1.529.47A.75.75 0 1 0 .468 1.531l4.47 4.47-4.47 4.47a.75.75 0 1 0 1.061 1.061l4.47-4.47 4.47 4.47a.75.75 0 1 0 1.061-1.061l-4.47-4.47 4.47-4.47a.75.75 0 0 0 0-1.061z"/>
    </svg></CloseButton>
};

const ConditionalContinueButton = (props) => {
  if (!props.sheetOpen) {

    return <ContinueButton onClick={props.openBottomSheet}> <FormattedMessage id={'btn_continue'}/></ContinueButton>


  }


  return <Nonvisible/>
};

const ConditionalDiscount = (props) => {
  //let total = props.finalPrice
let conditionalDiscount = 0



    if((props.payTotal || props.payHalf) && props.allSelected!=0){
    conditionalDiscount= props.discount7
      let discount = conditionalDiscount.toLocaleString('de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
      });
      return <DiscountPricing>
        <PricingLabel> 7% Vilhelm7 Discount</PricingLabel> <DiscountPrice> </DiscountPrice>
      </DiscountPricing>

  }
//-{discount}

  if(props.payDuringStay && props.allSelected!=0){
    conditionalDiscount= props.discount5
    let discount = conditionalDiscount.toLocaleString('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2
    });
    return <DiscountPricing>
      <PricingLabel> 5% Vilhelm7 Discount</PricingLabel> <DiscountPrice>  </DiscountPrice>
    </DiscountPricing>
  }
 // -{discount}





    return <Nonvisible/>


};

const ConditionalLoyaltyDiscount = (props) => {
  let total = props.finalPrice;
  let discount=0;

  if(props.payTotal){
    discount = props.loyaltyDiscount.toLocaleString('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2
    });
  }


  if (total != 0 && props.payTotal=== true && props.allSelected!=0) {
    return <LoyaltyDiscountPricing>
      <PricingLabel> 8% Non-refundable Discount</PricingLabel> <DiscountPrice>  </DiscountPrice>
    </LoyaltyDiscountPricing>

  }
  //{discount}
  else {


    return <Nonvisible/>

  }
}
const ConditionalFreeBreakfast = (props) => {
  let nights = props.nights;









    return <Nonvisible/>


}

const ConditionalBreakfast = (props) => {
  let isSelected =props.breakfastSelected;
  let price = props.selectedBreakfastGuests.value*props.selectedBreakfastDays.value*15;
 let totalPrice = price.toLocaleString('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2
  });
  if (isSelected) {
    return <SpecialsPricing>
      <PricingLabel> <MdFreeBreakfast/>  {props.selectedBreakfastGuests.value*props.selectedBreakfastDays.value}x   <FormattedMessage id="booking_fixed_box_13" /></PricingLabel> <DiscountPrice>  </DiscountPrice>
    </SpecialsPricing>

  }
  //{totalPrice}
  else {


    return <Nonvisible/>

  }
}

const ConditionalBikes = (props) => {
  let isSelected =props.bikesSelected;
  let price = props.selectedBikeGuests.value*props.selectedBikeDays.value*12;
  let totalPrice = price.toLocaleString('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2
  });
  if (isSelected) {
    return <SpecialsPricing>
      <PricingLabel> <StyledBikeIon/> {props.selectedBikeGuests.value*props.selectedBikeDays.value}x   Bikes</PricingLabel> <DiscountPrice> </DiscountPrice>
    </SpecialsPricing>

  }
  //{totalPrice}
  else {


    return <Nonvisible/>

  }
}

const ConditionalLaundry = (props) => {
  let isSelected =props.laundrySelected;
  let price = props.selectedLaundryFillings.value*15;
  let totalPrice = price.toLocaleString('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2
  });

  if (isSelected) {
    return <SpecialsPricing>
      <PricingLabel> <MdLocalLaundryService/> {props.selectedLaundryFillings.value}x   <FormattedMessage id="booking_fixed_box_16" /></PricingLabel> <DiscountPrice> </DiscountPrice>
    </SpecialsPricing>

  }
  //{totalPrice}
  else {


    return <Nonvisible/>

  }
}

const ConditionalChampagne = (props) => {
  let isSelected =props.champagneSelected;
  let price = props.selectedChampagneBottles.value*40;
  let totalPrice = price.toLocaleString('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2
  });
  if (isSelected) {
    return <SpecialsPricing>
      <PricingLabel> <FaWineBottle/> {props.selectedChampagneBottles.value}x   Champagne</PricingLabel> <DiscountPrice>  </DiscountPrice>
    </SpecialsPricing>

  }
  //{totalPrice}
  else {


    return <Nonvisible/>

  }
};



const CountryWrapper =styled.div`
select{
width:100% !important;
}

padding-bottom:1rem;
`


const SelectDiv = styled.div`
display:flex;
margin-bottom:10px;
`;

const GuestNightDiv = styled.div`
display:flex;
justify-content:space-between;
margin-top:15px;
margin-bottom:15px;
padding-bottom:10px;
border-bottom:1px solid rgba(68,68,68,.2);


`;

const GuestLabel = styled.div`
width:138px;
 font-family: "Theano Didot",Regular;



`;
const NightLabel = styled.div`
width:187px;
 font-family: "Theano Didot",Regular;



`;


const Div = styled.div`

.rc-steps {
margin-bottom:0px !important;
}

.rc-steps-item-process .rc-steps-item-icon{
background: rgb(84, 170, 241) !important;
}

.rc-steps-navigation .rc-steps-item-active .rc-steps-item-container{
border-bottom:2px solid rgb(84, 170, 241) !important;
padding-bottom: 6px !important;
margin-bottom:0px !important;
}

.rc-steps-item{
font-family:${fonts.engraversBold} !important;
text-transform:uppercase;
}

 .rc-steps-item-description{
 font-size:10px;
 font-family: "Theano Didot",Regular !important;
 font-style:italic;
 text-transform:none !important;

   @media screen and (max-width: 460px) {
          display:none;

   }
 }

  .rc-steps-item-subtitle{

  @media screen and (max-width: 460px) {
        display:none;
  }
  }

width:80%;

  @media screen and (max-width: 1295px) {
  width:100%;
}



`;


const Checkin = styled.span`
padding-left:6px;
margin-right:90px;
 font-family:${fonts.engraversBold} !important;
 font-weight:bold;
 text-transform:uppercase;

`;

const CheckinSpan = styled.span`
padding-left:6px;
margin-right:80px;
 font-family:${fonts.engraversBold} !important;
 font-weight:bold;
 text-transform:uppercase;

`;

const NextButton = styled.div`
cursor:pointer;
font-weight:700;
width:98%;
margin-bottom:10px;
margin-top:20px;
height:48px;
 display: flex;
 align-items:center;
 justify-content:center;
  border-radius: 10rem;
  color: #fff;
  font-size: 1rem;
  //letter-spacing: .15rem;
  transition: all .3s;
  position: relative;
  overflow: hidden;
  z-index: 1;
  font-weight:bold;
  font-size:21px;
margin-left:auto;
margin-right:auto;
font-family:${fonts.button};
letter-spacing:2px;


:before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0%;
  height: 100%;
  background-color: #188cec;
  transition: all .3s;
  border-radius: 10rem;
  z-index: -1;
}

 :after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #54aaf1;
  border-radius: 10rem;
  z-index: -2;
}

:hover {
  color: #fff;
}

:hover:before {
  width: 100%;
}


   @media screen and (max-width: 1295px) {
z-index:999999;
}


`;

const BlueLine = styled.div`
//width:100%;
height:30px;
// background-color: #54aaf1;
    background-color: #188cec;
  cursor:pointer;


//margin-top:20px;

  color: #fff;
  font-size: 1rem;
  //letter-spacing: .15rem;
  transition: all .3s;
  position: relative;
  //overflow: hidden;
  z-index: 1;
  font-weight:bold;
  font-size:21px;

font-family:${fonts.button};
letter-spacing:2px;
text-transform:uppercase;




   @media screen and (max-width: 1295px) {
}




`;

const BackButton = styled.div`
cursor:pointer;
width:98%;
margin-bottom:10px;
//margin-top:20px;
height:45px;
 display: flex;
 align-items:center;
 justify-content:center;
  border-radius: 10rem;
  color: #fff;
  font-size: 1rem;
  //letter-spacing: .15rem;
  transition: all .3s;
  position: relative;
  overflow: hidden;
  z-index: 1;
  font-weight:bold;
  font-size:21px;
margin-left:auto;
margin-right:auto;
font-family:${fonts.button};
letter-spacing:2px;
text-transform:uppercase;


:before {
  content: '';
  position: absolute;
  bottom: 0;
  right: 0;
  width: 0%;
  height: 100%;
  background-color: #188cec;
  transition: all .3s;
  border-radius: 10rem;
  z-index: -1;
}

 :after {
  content: '';
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: #54aaf1;
  border-radius: 10rem;
  z-index: -2;
}

:hover {
  color: #fff;
}

:hover:before {
  width: 100%;
}


   @media screen and (max-width: 1295px) {
z-index:999999;
}


`;

const Without = styled.p`
font-family:${fonts.button};
letter-spacing:2px;
color: #188cec;
cursor:pointer;
`;


const EditButton = styled.div`
z-index:999999;
cursor:pointer;
width:98%;
margin-bottom:10px;
//margin-top:20px;
height:48px;
 display: flex;
 align-items:center;
 justify-content:center;
  border-radius: 10rem;
  color: #fff;
  font-size: 1rem;
  //letter-spacing: .15rem;
  transition: all .3s;
  position: relative;
  overflow: hidden;
  z-index: 1;
  font-weight:bold;
  font-size:21px;
margin-left:auto;
margin-right:auto;
font-family:${fonts.button};
letter-spacing:2px;
text-transform:uppercase;


:before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0;
  background-color: #54aaf1;
  transition: all .3s;
  border-radius: 10rem;
  z-index: -1;


}

 :after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #188cec;
  border-radius: 10rem;
  z-index: -2;

}

:hover {
  color: #fff;


}

:hover:before {
  height: 100%;

}

   @media screen and (max-width: 1295px) {
z-index:999999;
}


`;


const EditButton2 = styled.div`
//z-index:1;
cursor:pointer;
width:26px;

//margin-top:20px;
height:26px;
 display: flex;
 align-items:center;
 justify-content:center;
  border-radius: 10rem;
  color: #fff;
  font-size: 0.5rem;
  //letter-spacing: .15rem;
  transition: all .3s;
  position: relative;
  overflow: hidden;
 // z-index: 1;
  font-weight:bold;
  font-size:11px;
margin-left:6px;
margin-right:14px;
font-family:${fonts.button};
letter-spacing:2px;
text-transform:uppercase;


:before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0;
  background-color: #54aaf1;
  transition: all .3s;
  border-radius: 10rem;
  z-index: -1;


}

 :after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #188cec;
  border-radius: 10rem;
  z-index: -2;

}

:hover {
  color: #fff;


}

:hover:before {
  height: 100%;

}

   @media screen and (max-width: 1295px) {

}


`;



const EditButton3 = styled.div`
z-index:999999;
cursor:pointer;
width:26px;

//margin-top:20px;
height:26px;
 display: flex;
 align-items:center;
 justify-content:center;
  border-radius: 10rem;
  color: #fff;
  font-size: 0.5rem;
  //letter-spacing: .15rem;
  transition: all .3s;
  position: relative;
  overflow: hidden;
 // z-index: 1;
  font-weight:bold;
  font-size:11px;
margin-left:6px;
margin-right:14px;
font-family:${fonts.button};
letter-spacing:2px;
text-transform:uppercase;


:before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0;
  background-color: #54aaf1;
  transition: all .3s;
  border-radius: 10rem;
  z-index: -1;


}

 :after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #188cec;
  border-radius: 10rem;
  z-index: -2;

}

:hover {
  color: #fff;


}

:hover:before {
  height: 100%;

}

   @media screen and (max-width: 1295px) {
z-index:999999;
}


`;



const EditBookingDetails = styled.div`
display:none;
cursor:pointer;
text-align:center;
align-items:center;
padding-left:2%;
transition:all .2s ease;
span {
color: #188cec;
cursor:pointer;
font-weight: bold !important;
font-size: 16px !important;
}

   @media screen and (max-width: 1295px) {
display:flex;
}
`



const EditBookingDetails2 = styled.div`
display:none;
cursor:pointer;
text-align:center;
align-items:center;
padding-left:0%;
transition:all .2s ease;
span {
color: #188cec;
cursor:pointer;
font-weight: bold !important;
font-size: 16px !important;
}

   @media screen and (max-width: 1295px) {
display:flex;
}
`



const CloseButton = styled.div`
z-index:99999;
cursor:pointer;
width:98%;
margin-bottom:10px;
//margin-top:20px;
height:48px;
 display: flex;
 align-items:center;
 justify-content:center;
  border-radius: 10rem;
  color: #fff;
  font-size: 1rem;
  //letter-spacing: .15rem;
  transition: all .3s;
  position: relative;
  overflow: hidden;
  z-index: 1;
  font-weight:bold;
  font-size:21px;
margin-left:auto;
margin-right:auto;
font-family:${fonts.button};
letter-spacing:2px;
text-transform:uppercase;


:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 0;
  background-color: #54aaf1;
  transition: all .3s;
  border-radius: 10rem;
  z-index: -1;


}

 :after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #188cec;
  border-radius: 10rem;
  z-index: -2;

}

:hover {
  color: #fff;


}

:hover:before {
  height: 100%;

}

   @media screen and (max-width: 1295px) {
z-index:999999;
}


`;

const ContinueButton = styled.div`
display:none;
cursor:pointer;
width:311.633px;
position:relative;
margin-left:auto;
margin-right:auto;
margin-bottom:10px;
margin-top:40px;
height:50px;
 display: none;
 align-items:center;
 justify-content:center;
  border-radius: 10rem;
  color: #fff;
  font-size: 1rem;
  //letter-spacing: .15rem;
  transition: all .3s;
  position: relative;
  overflow: hidden;
  z-index: 99;
  font-weight:bold;
  font-size:21px;
margin-left:auto;
margin-right:auto;
font-family:${fonts.button};
letter-spacing:2px;
text-transform:uppercase;


:before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0%;
  height: 100%;
  background-color: #188cec;
  transition: all .3s;
  border-radius: 10rem;
  z-index: -1;
}

 :after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #54aaf1;
  border-radius: 10rem;
  z-index: -2;
}

:hover {
  color: #fff;
}

:hover:before {
  width: 100%;
}


   @media screen and (max-width: 1295px) {
//z-index:999999;
 display: flex;

}


`;

const A = styled.div`
display:flex;
justify-content:center;
align-items:center;
color:white;
`;

const SelectMoreRooms = styled.div`
text-align:center;
margin-top:30px;
padding-bottom: 15px;
color: rgba(24,140,236,1);
font-weight:bold;
font-size:17px;
`;


const SuitePricing = styled.div`
display:flex;
justify-content:space-between;
width:100%;
//padding-top:3px;


`



const StudioPricing = styled.div`
display:flex;
justify-content:space-between;
width:100%;
//padding-top:3px;


`;

const StudioPrice = styled.span`
font-weight:bold;

`;

const StudioPlusPricing = styled.div`
display:flex;
justify-content:space-between;
width:100%;
//padding-top:3px;


`;

const StudioPlusPrice = styled.span`
font-weight:bold;

`;

const DiscountPricing = styled.div`
display:flex;
justify-content:space-between;
width:100%;
padding-top:15px;
//padding-bottom:10px;
//padding-left:20px;



`;

const SpecialsPricing = styled.div`
display:flex;
justify-content:space-between;
width:100%;
//padding-top:10px;
//padding-bottom:5px;
  //border-bottom:1px solid rgba(68,68,68,.2);
padding-left:20px;



`;


const roomRateIDs = [

  {rate:0, id:'512202'}, //studio -15
  {rate:1, id:'512203'}, //studio plus -15
  {rate:2, id:'512204'}, //suite -15
  {rate:3, id:'512196'}, //studio -7
  {rate:4, id:'512197'}, //studio plus -7
  {rate:5, id:'512198'}, //suite -7
  {rate:6, id:'512199'}, //studio -5
  {rate:7, id:'512200'}, //studio plus -5
  {rate:8, id:'512201'}, //suite -5

];




const PricingPlan = styled.div`
width:100%;
height:auto;
padding-top:7%;
display:flex;
justify-content:space-between;

   @media screen and (max-width: 680px) {
display:block;
height:auto;}
`;

const PricingPlanDiv = styled.div`

padding-top:5%;
text-align:center;

  @media screen and (max-width: 680px) {
padding-top:0%;

}

`;

const PricingOptionDetails = styled.div`

padding-left:5%;
padding-right:5%;
padding-bottom:5%;
padding-top:12%;
text-align:center;
font-size:14px;

   @media screen and (max-width: 680px) {
padding-bottom:2%;
padding-top:2%;
}

`;

const SavePriceDiv = styled.div`

padding-top:7%;
padding-bottom:5%;
text-align:center;
font-style:bold;

   @media screen and (max-width: 680px) {
padding-top:2%;
padding-bottom:1%;

}


`;

const PricingOption = styled.div`
width:32%;
border:1px solid rgba(68,68,68,.05);
cursor:pointer;
transition: all .3s;
:hover{
transform: translateY(-7px);}

   @media screen and (max-width: 680px) {
width:90%;
height:auto;

margin-left:auto;
margin-right:auto;
margin-bottom:30px;
}
`;

const PricingOptionHeader = styled.div`
height:40px;
display:flex;
align-items:center;
justify-content:center;
font-size: 21px;
//letter-spacing:2px;
text-transform:uppercase;
 font-family:${fonts.engraversBold};

`;




const DiscountPrice = styled.span`
font-weight:bold;

`;

const LoyaltyDiscountPricing = styled.div`
display:flex;
justify-content:space-between;
width:100%;
//padding-top:5px;
//padding-left:20px;



`;

const TotalPricing = styled.div`
display:flex;
justify-content:space-between;
width:100%;
border-top:1px solid rgba(68,68,68,.2);

padding-top:10px;
margin-top:10px;
padding-bottom:10px;
padding-left:20px;
//font-size:19px;



`;
const TotalPrice = styled.span`
font-weight:bold;


`

const PricingLabel = styled.span`

`;

const InnerBottom = styled.div`
width:100%;
padding-left:10px;
padding-right:10px;
`;


const AttentionDiv = styled.div`
width:50%;
margin-left:auto;
margin-right:auto;

@media screen and (max-width:640px){
width:80%;
}

`;



const AttetionP = styled.p`
font-size:19px !important;
text-align:center;
`;



const Spn = styled.span`
padding-left:6px;
 font-family:${fonts.engraversBold} !important;
 font-weight:bold;
 text-transform:uppercase;
 //float:left;

`

const SpnDiv = styled.span`

width:100%;
display:none;

  @media screen and (max-width: 666px) {
display:flex;
margin-left: 2%;
   }
`


const AddressSlideDown = styled(SlideDown)`
`


const AddAddress1 = styled.div`
display:flex;
margin-top:2em;

.plus-minus-toggle {



display:flex;
align-items:center;
  cursor: pointer;
  height: 1px;
  position: relative;
  width: 7px;
  &:before,
  &:after{
   background: lightgrey;
    content: '';
    height: 1px;
    left: 0;
    position: absolute;
    top: 0;
    width: 7px;
    transition: transform 500ms ease;
  }
  &:after {
    transform-origin: center;

  }
  &.collapsed {

    &:after {
      transform: rotate(90deg);
                   background: rgba(24,140,236,1);
    }
    &:before {
      transform: rotate(180deg);
              background: rgba(24,140,236,1);


    }
  }
}


@media screen and (max-width:640px){
width:100%;
margin-top:2em;


}
`

const PlusMinus = styled.div`
margin-right:0.1rem;
display:flex;
align-items:center;

`



const SecuredPayment = styled.div`
display:flex;
justify-content:space-between;
width:50%;
margin:auto;
padding:10% 0;
height: 5vh;
align-items:center;

   @media screen and (max-width: 680px) {
width:90%;
}
`




export const isBrowser = typeof window !== 'undefined';

const StateToLocal = (props) => {

  useEffect(() => {
      window.localStorage.setItem('current', props.current);
      window.localStorage.setItem('stepOneStatus',props.stepOneStatus);
      window.localStorage.setItem('stepTwoStatus',props.stepTwoStatus);


      //console.log('startDate set')
    if(props.startDate!=null){      window.localStorage.setItem('startDate', props.startDate.toISOString())
    }
    if(props.endDate!=null){      window.localStorage.setItem('endDate', props.endDate.toISOString())
    }

    if(props.resExp!=null){      window.localStorage.setItem('resExp', props.resExp.toISOString())
    }
      window.localStorage.setItem('nights', props.nights);
      window.localStorage.setItem('selectedRooms', JSON.stringify(props.selectedRooms));
      window.localStorage.setItem('selectedGuests', JSON.stringify(props.selectedGuests));
      window.localStorage.setItem('guestOptions', JSON.stringify(props.guestOptions))
      window.localStorage.setItem('suite', props.suite);
      window.localStorage.setItem('studio', props.studio);
      window.localStorage.setItem('studioPlus', props.studioPlus);
      window.localStorage.setItem('allAvailable', props.allAvailable);
      window.localStorage.setItem('displayNoAvailable', props.displayNoAvailable);
      window.localStorage.setItem('displayPleaseSelect', props.displayPleaseSelect);

      window.localStorage.setItem('firstSelection', props.firstSelection);
      window.localStorage.setItem('secondSelection', props.secondSelection);
      window.localStorage.setItem('thirdSelection', props.thirdSelection);
      window.localStorage.setItem('fourthSelection', props.fourthSelection);
      window.localStorage.setItem('currentSelected', props.currentSelected);
      window.localStorage.setItem('stCount', props.stCount);
      window.localStorage.setItem('stpCount', props.stpCount);
      window.localStorage.setItem('suCount', props.suCount);

      window.localStorage.setItem('rotation_1', props.rotation_1);
      window.localStorage.setItem('rotation_2', props.rotation_2);
      window.localStorage.setItem('rotation_3', props.rotation_3);
      window.localStorage.setItem('rotation_4', props.rotation_4);

      window.localStorage.setItem('firstBlockClosed', props.firstBlockClosed);
      window.localStorage.setItem('secondBlockClosed', props.secondBlockClosed);
      window.localStorage.setItem('thirdBlockClosed', props.thirdBlockClosed);
      window.localStorage.setItem('fourthBlockClosed', props.fourthBlockClosed);

      window.localStorage.setItem('firstCheck', props.firstCheck);
      window.localStorage.setItem('secondCheck', props.secondCheck);
      window.localStorage.setItem('thirdCheck', props.thirdCheck);
      window.localStorage.setItem('fourthCheck', props.fourthCheck);

      window.localStorage.setItem('selectedBreakfastGuests', JSON.stringify(props.selectedBreakfastGuests));
      window.localStorage.setItem('selectedBreakfastDays', JSON.stringify(props.selectedBreakfastDays));
      window.localStorage.setItem('selectedBikeGuests', JSON.stringify(props.selectedBikeGuests));
      window.localStorage.setItem('selectedBikeDays', JSON.stringify(props.selectedBikeDays));
      window.localStorage.setItem('selectedLaundryFillings', JSON.stringify(props.selectedLaundryFillings));
      window.localStorage.setItem('selectedChampagneBottles', JSON.stringify(props.selectedChampagneBottles));
      window.localStorage.setItem('selectedWhiteWineBottles', JSON.stringify(props.selectedWhiteWineBottles));
      window.localStorage.setItem('selectedRedWineBottles', JSON.stringify(props.selectedRedWineBottles));
      window.localStorage.setItem('selectedSpaTours', JSON.stringify(props.selectedSpaTours));

      window.localStorage.setItem('selectedBikes', props.selectedBikes);
      window.localStorage.setItem('selectedBreakfast', props.selectedBreakfast);
      window.localStorage.setItem('selectedLaundry', props.selectedLaundry);
      window.localStorage.setItem('selectedChampagne', props.selectedChampagne);
      window.localStorage.setItem('selectedWhiteWine', props.selectedWhiteWine);
      window.localStorage.setItem('selectedRedWine', props.selectedRedWine);
      window.localStorage.setItem('selectedSpa', props.selectedSpa);

      window.localStorage.setItem('breakfastSelected',props.breakfastSelected);
      window.localStorage.setItem('bikesSelected',props.bikesSelected);
      window.localStorage.setItem('laundrySelected',props.laundrySelected);
      window.localStorage.setItem('champagneSelected',props.champagneSelected);
      window.localStorage.setItem('spaSelected',props.spaSelected);
      window.localStorage.setItem('whiteWineSelected',props.whiteWineSelected);
      window.localStorage.setItem('redWineSelected',props.redWineSelected);
      window.localStorage.setItem('notes',props.notes);

      window.localStorage.setItem('guestOptions_1', JSON.stringify(props.guestOptions_1));
      window.localStorage.setItem('guestOptions_2', JSON.stringify(props.guestOptions_2));
      window.localStorage.setItem('guestOptions_3', JSON.stringify(props.guestOptions_3));
      window.localStorage.setItem('guestOptions_4', JSON.stringify(props.guestOptions_4));
      window.localStorage.setItem('selectedGuests_1', JSON.stringify(props.selectedGuests_1));
      window.localStorage.setItem('selectedGuests_2', JSON.stringify(props.selectedGuests_2));
      window.localStorage.setItem('selectedGuests_3', JSON.stringify(props.selectedGuests_3));
      window.localStorage.setItem('selectedGuests_4', JSON.stringify(props.selectedGuests_4));

      window.localStorage.setItem('payTotal', props.payTotal);
      window.localStorage.setItem('payHalf', props.payHalf);
      window.localStorage.setItem('payDuringStay', props.payDuringStay);

      window.localStorage.setItem('paypal', props.paypal);
      window.localStorage.setItem('paySepa', props.paySepa);
      window.localStorage.setItem('payKlarna', props.payKlarna);
      window.localStorage.setItem('payGiropay', props.payGiropay);
      window.localStorage.setItem('payBankTransfer', props.payBankTransfer);
      window.localStorage.setItem('selectedPaymentOption', JSON.stringify(props.selectedPaymentOption));



    //console.log(props.firstSelection)
  //  console.log(window.localStorage)
let totalGuests = props.selectedGuests_1.value + props.selectedGuests_2.value + props.selectedGuests_3.value + props.selectedGuests_4.value
      props.calculateFinalPrice(totalGuests,props.firstSelection, props.secondSelection, props.thirdSelection, props.fourthSelection)
    },
    [props.current, props.stepOneStatus, props.stepTwoStatus, props.resExp, props.guestOptions,props.startDate, props.endDate, props.nights, props.selectedRooms, props.selectedGuests,
      props.suite, props.studio, props.studioPlus, props.allAvailable, props.displayNoAvailable,
      props.displayPleaseSelect, props.firstSelection,props.secondSelection, props.thirdSelection,
      props.fourthSelection, props.currentSelected, props.stCount, props.stpCount, props.suCount,
      props.rotation_1, props.rotation_2, props.rotation_3, props.rotation_4, props.firstBlockClosed,
      props.secondBlockClosed, props.thirdBlockClosed, props.fourthBlockClosed, props.firstCheck, props.secondCheck,
      props.thirdCheck, props.fourthCheck, props.selectedBikes, props.selectedBreakfast, props.selectedLaundry,
      props.selectedChampagne, props.selectedWhiteWine, props.selectedRedWine, props.selectedSpa, props.selectedBreakfastDays, props.selectedBreakfastGuests,
      props.selectedBikeDays,props.selectedBikeGuests, props.selectedLaundryFillings, props.selectedChampagneBottles,
      props.selectedWhiteWineBottles, props.selectedRedWineBottles, props.selectedSpaTours,
      props.breakfastSelected, props.bikesSelected, props.spaSelected, props.champagneSelected, props.whiteWineSelected, props.redWineSelected,
      props.notes, props.laundrySelected,
      props.guestOptions_1, props.guestOptions_2, props.guestOptions_3, props.guestOptions_4, props.selectedGuests_1, props.selectedGuests_2,
      props.selectedGuests_3, props.selectedGuests_4,
      props.payTotal, props.payHalf, props.payDuringStay,
      props.paypal, props.paySepa, props.payKlarna, props.payGiropay, props.payBankTransfer, props.selectedPaymentOption

    ],
  );




  return <Nonvisible/>

}

/*
const ConditionalEmailVerify = (props) => {



  //console.log(props.email_verified)

  if(!props.mailVerified){
    return <EmailVerification>
      <EmailTextDiv> <StyledAttention/> <EmailText>Please verify your email adress within 48 hours. </EmailText>
        <EmailVerificationHandler openVerifyModal={props.openVerifyModal}/>
      </EmailTextDiv>
    </EmailVerification>
  }

  return <EmailVerification>
    <EmailTextDiv>     <StyledCheck/><EmailText>Your email adress has been successful verified. </EmailText>
    </EmailTextDiv>
  </EmailVerification>
};


*/

const ConditionalPayment = (props) => {

  let paypal = props.paypal;
  let paySepa = props.paySepa;
  let payCreditCard = props.payCreditCard;
  let payKlarna = props.payKlarna;
  let payGiropay = props.payGiropay;
  let payBankTransfer = props.payBankTransfer;


  let descr = props.startDate.format('ll') + ' - ' +  props.endDate.format('ll') + ', ' + props.totalGuests
              + ' guest/s, ' +  props.nights + ' nights, ';
  if(props.selectedStudios!=0){
    descr+= props.selectedStudios +'x Studio | '
  }

  if(props.selectedStudioPlus!=0){
    descr+= props.selectedStudioPlus +'x Studio Plus | '
  }

  if(props.selectedSuites!=0){
    descr+= props.selectedSuites +'x Suite'
  }




  //console.log(profile.email_verified)

  if(paypal){
    return <PaypalExpress firstName={props.firstName} lastName={props.lastName}
                          email={props.email}
                          stCount={props.stCount} stpCount={props.stpCount} suCount={props.suCount} totalGuests={props.totalGuests}
                          checkIn={props.checkIn} checkOut={props.checkOut}
                          billingPlan={props.billingPlan}
                          breakfast={props.breakfast} bikes={props.bikes} spa={props.spa} laundry={props.laundry}
                          champagne={props.champagne} redWine={props.redWine} whiteWine={props.whiteWine} notes={props.notes}
                          postBooking={props.postBooking}  amount={props.amountToPay}  showPaymentError={props.showPaymentError}  />
  }

  if(paySepa){
    return <BankTransferDemo firstName={props.firstName} lastName={props.lastName}
                             email={props.email}
                             stCount={props.stCount} stpCount={props.stpCount} suCount={props.suCount} totalGuests={props.totalGuests}
                             checkIn={props.checkIn} checkOut={props.checkOut}
                             postBooking={props.postBooking}  amount={props.amountToPay} fullAmount={props.fullAmount}
                     guests={props.guests} nights={props.nights}
                     rooms={props.rooms} categories={props.categories}
                     payOption={props.payOption}
                             billingPlan={props.billingPlan}
                             breakfast={props.breakfast} bikes={props.bikes} spa={props.spa} laundry={props.laundry}
                             champagne={props.champagne} redWine={props.redWine} whiteWine={props.whiteWine} notes={props.notes}
                             startDate={props.startDate} endDate={props.endDate}/>
  }

  if(payCreditCard){
if(props.payDuringStay){
  return <PayDuringStayProvider firstName={props.firstName} lastName={props.lastName} email={props.email}
                                checkIn={props.checkIn} checkOut={props.checkOut}
                                billingPlan={props.billingPlan}
                                breakfast={props.breakfast} bikes={props.bikes} spa={props.spa} laundry={props.laundry}
                                champagne={props.champagne} redWine={props.redWine} whiteWine={props.whiteWine} notes={props.notes}

                                stCount={props.stCount} stpCount={props.stpCount} suCount={props.suCount} totalGuests={props.totalGuests}
                                postBooking={props.postBooking} showPaymentError={props.showPaymentError} amount={props.amountToPay}/>

}
    return <AsyncDemo ratePlan={props.payOption} firstName={props.firstName} lastName={props.lastName} email={props.email}
                      stCount={props.stCount} stpCount={props.stpCount} suCount={props.suCount} totalGuests={props.totalGuests}
                      checkIn={props.checkIn} checkOut={props.checkOut}
                      billingPlan={props.billingPlan}
                      breakfast={props.breakfast} bikes={props.bikes} spa={props.spa} laundry={props.laundry}
                      champagne={props.champagne} redWine={props.redWine} whiteWine={props.whiteWine} notes={props.notes}
                      postBooking={props.postBooking} showPaymentError={props.showPaymentError} amount={props.amountToPay}/>
  }

  if(payKlarna){
    return <KlarnaDemo firstName={props.firstName} lastName={props.lastName}
                       email={props.email}
                       stCount={props.stCount} stpCount={props.stpCount} suCount={props.suCount} totalGuests={props.totalGuests}
                       checkIn={props.checkIn} checkOut={props.checkOut}
                       postBooking={props.postBooking} descr={descr} showPaymentError={props.showPaymentError}  amount={props.amountToPay}/>

  }

  if(payGiropay){
    return <GiropayDemo firstName={props.firstName} lastName={props.lastName} postBooking={props.postBooking}  descr={descr} showPaymentError={props.showPaymentError}  amount={props.amountToPay}/>

  }

  if(payBankTransfer){
    return <BankTransferDemo firstName={props.firstName} lastName={props.lastName}
                             email={props.email}
                             billingPlan={props.billingPlan}
                             breakfast={props.breakfast} bikes={props.bikes} spa={props.spa} laundry={props.laundry}
                             champagne={props.champagne} redWine={props.redWine} whiteWine={props.whiteWine} notes={props.notes}
                             stCount={props.stCount} stpCount={props.stpCount} suCount={props.suCount} totalGuests={props.totalGuests}
                             checkIn={props.checkIn} checkOut={props.checkOut}
                             postBooking={props.postBooking} descr={descr} showPaymentError={props.showPaymentError}  amount={props.amountToPay}/>

  }


};



export class Dates extends React.Component<any, any>  {

  constructor(props) {
    super(props)
    this.state = {
      current: 0,
      stepOneStatus: 'process',
      stepTwoStatus: 'process',
      stepOneSubTitle:'Step 1',
      addressOpen:false,
      resExp:null,
      startDate: null,
      endDate:  null,
      nights: 0,
      focusedInput: moment(),
      focusedInput_2: moment(),
      selectedRooms:  roomOptions[0],
      selectedGuests: guestOptions[0],
      guestsLeft:guestOptions[0].value,
      guestOptions:guestOptions,
      guestOptions_1:guestOptions_3,
      guestOptions_2:guestOptions_3,
      guestOptions_3:guestOptions_3,
      guestOptions_4:guestOptions_3,
      selectedGuests_1:guestOptions_3[0],
      selectedGuests_2:guestOptions_3[0],
      selectedGuests_3:guestOptions_3[0],
      selectedGuests_4:guestOptions_3[0],

      totalStudioGuests:0,
      totalStudioPlusGuests:0,
      totalSuiteGuests:0,

      totalGuests:1,

      gpr_1:0,
      gpr_2:0,
      gpr_3:0,
      gpr_4:0,

      selectedSt: 0,
      selectedStp: 0,
      selectedSu: 0,
      // outsideRange: moment().add(7, 'days')
      suite: 0,
      studio: 0,
      studioPlus: 0,
      allAvailable: 0,
      st_cloudbeds_ids:[],
      stp_cloudbeds_ids:[],
      su_cloudbeds_ids:[],
      displayNoAvailable: 'none',
      displayPleaseSelect: 'block',
      suPrice: standardRates["suite"],
      stPrice: standardRates["studio"],
      stpPrice: standardRates["studio_plus"],


      // *** SPECIALS RATES ***

      breakfastRate:15,
      laundryRate:15,
      spaRate:25,
      bikeRate:12,
      champagneRate:40,
      redWineRate:70,
      whiteWineRate:70,



      firstSelection: [false, false, false],
      secondSelection: [false, false, false],
      thirdSelection: [false, false, false],
      fourthSelection: [false, false, false],
      currentSelected: 0,
      stCount: 0,
      stpCount: 0,
      suCount: 0,

      open:false,
      verifyOpen:false,
      paymentOpen:false,
      openTwo:false,
      openLogin:false,
      openVerify:false,

      sheetOpen:false,
      isBefore:false,

      rotation_1: 180,
      rotation_2: 180,
      rotation_3: 180,
      rotation_4: 180,

      firstBlockClosed:false,
      secondBlockClosed:false,
      thirdBlockClosed:false,
      fourthBlockClosed:false,

      firstCheck:false,
      secondCheck:false,
      thirdCheck:false,
      fourthCheck:false,

      guestsPerRoom1:1,
      guestsPerRoom2:1,
      guestsPerRoom3:1,
      guestsPerRoom4:1,
      maxValue1:3,
      maxValue2:3,
      maxValue3:3,
      maxValue4:3,

      bedOptions_1:bed_options_3,
      bedOptions_2:bed_options_3,
      bedOptions_3:bed_options_3,
      bedOptions_4:bed_options_3,

      selectedBeds_1:bed_options_3[0],
      selectedBeds_2:bed_options_3[0],
      selectedBeds_3:bed_options_3[0],
      selectedBeds_4:bed_options_3[0],

      selectText_1: 'Select Room',
      selectText_2: 'Select Room 2',
      selectText_3: 'Select Room 3',
      selectText_4: 'Select Room 4',

      freeBreakfast:0,
      selectedBreakfast:0,
      selectedBikes:0,
      selectedLaundry:0,
      selectedSpa:0,
      selectedChampagne:0,
      selectedRedWine:0,
      selectedWhiteWine:0,
      selectedBreakfastGuests:specialsGuestOptions[0],
      selectedBreakfastDays:specialsDaysOptions[0],
      selectedBikeGuests:specialsGuestOptions[0],
      selectedBikeDays:specialsDaysOptions[0],
      selectedLaundryFillings:specialsDaysOptions[0], // max = nights
      selectedChampagneBottles:specialsDaysOptions[0], // max = nights
      selectedWhiteWineBottles:specialsDaysOptions[0], // max = nights
      selectedRedWineBottles:specialsDaysOptions[0], // max = nights
      selectedSpaTours:specialsDaysOptions[0], // max = nights


      breakfastSelected: false,
      bikesSelected: false,
      laundrySelected: false,
      champagneSelected: false,
      spaSelected: false,
      whiteWineSelected: false,
      redWineSelected: false,
      notes: '',

      specialsGuestOptions: specialsGuestOptions,
      specialsDaysOptions: specialsDaysOptions,

      showSpinner:false,


      finalStRate5:0,
      finalStpRate5:0,
      finalSuRate5:0,
      finalStRate7:0,
      finalStpRate7:0,
      finalSuRate7:0,
      finalStRate15:0,
      finalStpRate15:0,
      finalSuRate15:0,

      finalSuPrice5: 0,
      finalStPrice5: 0,
      finalStpPrice5: 0,
      finalSuPrice7: 0,
      finalStPrice7: 0,
      finalStpPrice7: 0,
      finalSuPrice15: 0,
      finalStPrice15: 0,
      finalStpPrice15: 0,


      finalSuPrice: 0,
      finalStPrice: 0,
      finalStpPrice: 0,
      totalPrice: 0,


      totalPrice5: 0,
      totalPrice7: 0,
      totalPrice15: 0,
      amountToPay:0,
      amountToPay5:0,
      amountToPay7:0,
      amountToPay15:0,
      selectedPaymentMethod: 1,
      paymentMethods:paymentMethods,
      selectedPayOption:'totalAmount',
      selectedPaymentOption:paymentOptions[0],

      payTotal: false,
      payHalf: true,
      payDuringStay: false,
      roomRateID:roomRateIDs[0],

      paypal:false,
      paySepa:false,
      payCreditCard:true,
      payKlarna:false,
      payGiropay:false,
      payBankTransfer:false,

      emailVerified:false,

      discount15:0,
      discount7:0,
      discount5:0,

      discount: 0,
      loyaltyDiscount:0,

      stRate15:0,
      stpRate15:0,
      suRate15:0,
      stRate7:0,
      stpRate7:0,
      suRate7:0,
      stRate5:0,
      stpRate5:0,
      suRate5:0,

      stPrice15:0,
      stpPrice15:0,
      suPrice15:0,
      stPrice7:0,
      stpPrice7:0,
      suPrice7:0,
      stPrice5:0,
      stpPrice5:0,
      suPrice5:0,

      guestEmail:'',
      guestCompany:'',
      guestFirstName:'',
      guestLastName:'',
      guestAddress1:'',
      guestCity:'',
      guestCountry:'DE',
      guestZipCode:''



    };
  this.handleRoomSelection(this.state.selectedRooms);
    this.openModal = this.openModal.bind(this);
    this.openPaymentModal = this.openPaymentModal.bind(this);
    this.openVerifyModal = this.openVerifyModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.closePaymentModal = this.closePaymentModal.bind(this)
    this.closeVerifyModal = this.closeVerifyModal.bind(this)
    this.closeLogin = this.closeLogin.bind(this)
    this.closeVerify = this.closeVerify.bind(this)
    this.openLogin = this.openLogin.bind(this)
    this.openVerify = this.openVerify.bind(this)
    this.calculateFinalPrice = this.calculateFinalPrice.bind(this)
this.calculateFinalPrice(this.state.totalGuests, this.state.firstSelection, this.state.secondSelection, this.state.thirdSelection, this.state.fourthSelection)
    this.rotate_1 = this.rotate_1.bind(this);
    this.rotate_2 = this.rotate_2.bind(this);
    this.rotate_3 = this.rotate_3.bind(this);
    this.rotate_4 = this.rotate_4.bind(this);
    this.getFormattedDate = this.getFormattedDate.bind(this);
    this.handlePaypal = this.handlePaypal.bind(this)
    this.handleSepa = this.handleSepa.bind(this)
    this.handleCreditCard = this.handleCreditCard.bind(this)
    this.handleKlarna = this.handleKlarna.bind(this)
    this.handleGiropay = this.handleGiropay.bind(this)
    this.handlePayDuringStay = this.handlePayDuringStay.bind(this)
    this.handlePayHalfAmount = this.handlePayHalfAmount.bind(this)
    this.handlePayTotalAmount = this.handlePayTotalAmount.bind(this)
    this.handleCreditCard = this.handleCreditCard.bind(this)
    this.togglePayOption = this.togglePayOption.bind(this)
    this.togglePayMethod = this.togglePayMethod.bind(this)
    this.getGuest = this.getGuest.bind(this)
    this.getRoomsObj = this.getRoomsObj.bind(this)
    this.getAdults = this.getAdults.bind(this)
    this.getChildren = this.getChildren.bind(this)
    this.handleFirstNameChange = this.handleFirstNameChange.bind(this)
    this.handleLastNameChange = this.handleLastNameChange.bind(this)
    this.handleZipCodeChange = this.handleZipCodeChange.bind(this)
    this.handleCountryChange = this.handleCountryChange.bind(this)
    this.postBooking=this.postBooking.bind(this)
    this.getItems=this.getItems.bind(this)
    this.closeBottomSheet=this.closeBottomSheet.bind(this)
this.handleGuestEmailChange = this.handleGuestEmailChange.bind(this)
    this.handleGuestCompanyChange = this.handleGuestCompanyChange.bind(this)
    this.getBillingPlan=this.getBillingPlan.bind(this)
    this.handleGuestAddress1Change=this.handleGuestAddress1Change.bind(this)
    this.handleGuestCityChange = this.handleGuestCityChange.bind(this)
    this.openBookingDetails = this.openBookingDetails.bind(this)
    this.getDatoCmsImages = this.getDatoCmsImages.bind(this)
    //  this.getSetRatePlans = this.getSetRatePlans.bind(this)

  }

  handleGuestAddress1Change(event) {
    this.setState({guestAddress1: event.target.value});
  }
  handleGuestCityChange(event) {
    this.setState({guestCity: event.target.value});
  }

  handleGuestCompanyChange(event) {
    this.setState({guestCompany: event.target.value});
  }


  handleGuestEmailChange(event) {
    this.setState({guestEmail: event.target.value});
  }

  handleFirstNameChange(event) {
    this.setState({guestFirstName: event.target.value});
  }
  handleLastNameChange(event) {
    this.setState({guestLastName: event.target.value});
  }

  handleZipCodeChange(event) {
    this.setState({guestZipCode: event.target.value});
  }

  handleCountryChange(countryCode) {
    //console.log(countryCode)
    this.setState({guestCountry: countryCode});
  }


  getSelectedRoomTypeID(selection){
    if(selection[0]){
      return roomTypeIDs[0].id
    }
    if(selection[1]){
      return roomTypeIDs[1].id
    }
    if(selection[2]){
      return roomTypeIDs[2].id
    }

    return null

  }

  //todo: wtf?
//get Guest obj for reservation
  getGuest(){



    let guest = {
      firstName: this.state.guestFirstName,
      lastName: this.state.guestLastName,
      country: this.state.guestCountry,
      zipCode: this.state.guestZipCode,
      email: this.state.guestEmail,
      address1:this.state.guestAddress1,
      city:this.state.guestCity,
      company:this.state.guestCompany
    }

    return guest;
  }

  //todo: wtf?
  //get adults obj for reservation
  getAdults(){
    let adults = [];
    if(this.state.totalStudioGuests!=0){
      adults.push({roomTypeID:roomTypeIDs[0].id, quantity:this.state.totalStudioGuests})
    }

    if(this.state.totalStudioPlusGuests!=0){
      adults.push({roomTypeID:roomTypeIDs[1].id, quantity:this.state.totalStudioPlusGuests})
    }

    if(this.state.totalSuiteGuests!=0){
      adults.push({roomTypeID:roomTypeIDs[2].id, quantity:this.state.totalSuiteGuests})
    }
    return adults;

  }

 getChildren(){
    let children = [];
    if(this.state.totalStudioGuests!=0){
      children.push({roomTypeID:roomTypeIDs[0].id, quantity:0})
    }

    if(this.state.totalStudioPlusGuests!=0){
      children.push({roomTypeID:roomTypeIDs[1].id, quantity:0})
    }

    if(this.state.totalSuiteGuests!=0){
      children.push({roomTypeID:roomTypeIDs[2].id, quantity:0})
    }
    return children;

  }

  //todo: add room type ids
  //get rooms obj for reservation
  getRoomsObj(){
    let rooms = []
    let stRoomRate;
    let stpRoomRate;
    let suRoomRate;
    if(this.state.payTotal){
      stRoomRate=roomRateIDs[0].id;
      stpRoomRate=roomRateIDs[1].id;
      suRoomRate=roomRateIDs[2].id
    }
    if(this.state.payHalf){
      stRoomRate=roomRateIDs[3].id;
      stpRoomRate=roomRateIDs[4].id;
      suRoomRate=roomRateIDs[5].id    }
    if(this.state.payDuringStay){
      stRoomRate=roomRateIDs[6].id;
      stpRoomRate=roomRateIDs[7].id;
      suRoomRate=roomRateIDs[8].id;    }


    if(this.state.stCount!=0){
      rooms.push({roomTypeID:roomTypeIDs[0].id, quantity:this.state.stCount, roomRateID:stRoomRate})
    }

    if(this.state.stpCount!=0){
      rooms.push({roomTypeID:roomTypeIDs[1].id, quantity:this.state.stpCount, roomRateID:stpRoomRate})
    }

    if(this.state.suCount!=0){
      rooms.push({roomTypeID:roomTypeIDs[2].id, quantity:this.state.suCount, roomRateID:suRoomRate})
    }
    return rooms;
  }

// todo: add notes to localstorage
  getNotes(){
    return this.state.notes;
  }

  getItems(){
    let items=[
      {itemID: 364969, itemQuantity: this.state.selectedBreakfast},
      {itemID: 364968, itemQuantity: this.state.selectedBikes},
      {itemID: 364967, itemQuantity: this.state.selectedLaundry},
      {itemID: 'id', itemQuantity: this.state.selectedSpa},
      {itemID: 'id', itemQuantity: this.state.selectedWhiteWine},
      {itemID: 'id', itemQuantity: this.state.selectedRedWine},
      {itemID: 'id', itemQuantity: this.state.selectedChampagne}

    ];


    return items;
  }

  getBillingPlan(){

    let billingPlan = 'Non-refundable (-15%)'
    if (this.state.payHalf) {
      billingPlan = 'Anzahlung (-7%)'
    }

    if (this.state.payDuringStay) {
      billingPlan = 'Vorort bezahlen (-5%)'
    }

    return billingPlan

  }



// post booking to cloudbeds description, stripe_customer_id, transaction_id
  async postBooking(descr, cus_id, tr_id) {
    const token = await getAccessToken();
    let guest = await this.getGuest();
    let rooms = await this.getRoomsObj();
    let adults = await this.getAdults();
    let children = await this.getChildren(); //empty
    const startDate = await this.state.startDate;
    const endDate = await this.state.endDate;
    const firstName = guest.firstName;
    const lastName = guest.lastName;
    const country = guest.country;
    const zipCode = guest.zipCode;
    const email = guest.email;
    const company = guest.company;
    const address1 = guest.address1;
    const city = guest.city
   // const customFields = guest.customFields;
    //let roomRateID = this.state.roomRateID;


    let billingPlan = 'Non-refundable (-15%)'
    let payMethod = 'StripeCreditCard'
    if (this.state.payHalf) {
      billingPlan = 'Anzahlung (-7%)'
    }

    if (this.state.payDuringStay) {
      billingPlan = 'Vorort bezahlen (-5%)'
    }

    if (this.state.payKlarna) {
      payMethod = 'StripeKlarna'
    }
    if (this.state.payGiropay) {
      payMethod = 'StripeGiropay'
    }
    if (this.state.paypal) {
      payMethod = 'StripePaypal'
    }

    if (this.state.paySepa) {
      payMethod = 'StripeBankTransfer'
    }
   // let now = moment().format('MMMM Do YYYY, h:mm:ss a');

    let req = {
      startDate: startDate,
      endDate: endDate,
      guestFirstName: firstName,
      guestLastName: lastName,
      guestCountry: country,
      guestZipCode: zipCode,
      guestEmail: email,
      rooms: rooms,
      adults: adults,
      children: children,
      paymentMethod: payMethod,
      billingPlan: billingPlan,
      stripe_customer_id: cus_id,
      company:company,
      address1:address1,
      city:city

    };
    //console.log('ready to post reservation')
    //console.log(await req)
    //console.log(await JSON.parse(token.body))
    const req_await = await req;
    const tok_await = await JSON.parse(token.body);
    const booking = await postReservation(req_await, tok_await);
    const resBooking = await JSON.parse(booking.body);

   //console.log(resBooking);

    await sleep(1000);


    if (resBooking.success===true) {



// UPDATE: write reservationID as metadata to stripe paymentIntent/charge
if(tr_id.startsWith('pi')) {
  await updatePaymentIntent(tr_id, await resBooking.reservationID, this.state.guestEmail, this.state.guestFirstName + ' ' +this.state.guestLastName)
  //console.log(await updateResponse)
}

if(tr_id.startsWith('ch')) {
  await updateCharge(tr_id, await resBooking.reservationID)
  //console.log(await updateResponse)
}

// post items to cloudbeds reservation
      const items = await this.getItems();

       for(let i of items) {

         if (i.itemQuantity != 0 && i.itemID != 'id') {
           await sleep(1000);
           const itemToken = await getAccessToken();
           const postItemResponse = await postReservationItem(i, await resBooking.reservationID, await JSON.parse(itemToken.body));
           const parsedItemResponse = await JSON.parse(postItemResponse.body);
           if (!parsedItemResponse.success) {
             //todo: send error mail with [ACTION REQUIRED] Item {itemid} failed to post to reservation {reservation id}

           }


           //console.log(await parsedItemResponse)
         }
       }

//post note bank transfer
      await sleep(1000);

      if (this.state.paySepa
      ) {
        const notesToken = await getAccessToken();
        const postNoteResponse = await postReservationNotes('Banküberweisung wird in den nächsten Werktagen erwartet.', await resBooking.reservationID, await JSON.parse(notesToken.body));
        const parsedNoteResponse = await JSON.parse(postNoteResponse.body);
        if(!parsedNoteResponse.success){
          //todo: send error mail with [ACTION REQUIRED] Note: {notes} failed to post to reservation {reservation id}

        }
      }


       //post notes to cloudbeds reservation
      let notes = await this.getNotes();

      if (notes != '') {
        let finalNotes = notes;
        const notesToken = await getAccessToken();
        const postNoteResponse = await postReservationNotes(await finalNotes, await resBooking.reservationID, await JSON.parse(notesToken.body));
        const parsedNoteResponse = await JSON.parse(postNoteResponse.body);
        if(!parsedNoteResponse.success){
          //todo: send error mail with [ACTION REQUIRED] Note: {notes} failed to post to reservation {reservation id}

        }
        //console.log(await postNoteResponse)
      }

      let amount = 0;
      if (this.state.payTotal) {
        amount = this.state.totalPrice15
      }

      if (this.state.payHalf) {
        amount = Number((this.state.totalPrice7/2).toFixed(2))
      }

      if (this.state.payDuringStay) {
        amount = 0
      }

      if (amount != 0) {
        const paymentObj = {
          reservationID: await resBooking.reservationID,
          type: payMethod,
          amount: amount,
          description: descr,

        };


        await sleep(1000)

//post payment to cloudbeds reservation, if neccessary
        if ((this.state.paypal | this.state.payCreditCard) && (this.state.payTotal | this.state.payHalf) ) {
          const paymentToken = await getAccessToken()
          const paymentResponse = await postPayment(await paymentObj, await JSON.parse(paymentToken.body))
          const parsedPayment = await JSON.parse(paymentResponse.body)
          if (!parsedPayment.success) {
            //todo: send error mail with [ACTION REQUIRED] Payment: {} failed to post payment (amount: {amount} to reservation {reservation id} of Stripe Customer {stripe_customer_id}

          }
          //console.log(await paymentResponse)
        }

        const data = {
            name: await resBooking.guestFirstName + ' ' + await resBooking.guestLastName,
            guestID: await resBooking.guestID
        };

      //  await updateCustomer(cus_id,await data)
        //console.log(await updateCusRes);


      }
return await resBooking.reservationID
    }
    else{
      return null;
      //todo: send error mail with [ACTION REQUIRED] BookingData: {req} failed to post a reservation {reservation id} after successful booking.
      // Stripe Customer ID:
    }
  }

  handlePayTotalAmount(){
    this.setState({
      payTotal: true,
      payHalf: false,
      payDuringStay: false,
      amountToPay:this.state.totalPrice15,
      payOptionText:'Pay total amount',
      payOptionClosed:true,
      roomRateID:roomRateIDs[0]



    });
    this.rotatePayOption();
    this.calculateFinalPrice(this.state.selectedGuests.value, this.state.firstSelection, this.state.secondSelection, this.state.thirdSelection, this.state.fourthSelection)


  }

  handlePayHalfAmount(){

    this.setState({
      payTotal: false,
      payHalf: true,
      payDuringStay: false,
      amountToPay:Number(((this.state.totalPrice7*50)/100).toFixed(2)),
      payOptionText:'Pay deposit',
      payOptionClosed:true,
      roomRateID:roomRateIDs[1]


    });
    this.rotatePayOption();
    this.calculateFinalPrice(this.state.selectedGuests.value, this.state.firstSelection, this.state.secondSelection, this.state.thirdSelection, this.state.fourthSelection)

    this.setState({
      amountToPay:Number(((this.state.totalPrice7*50)/100).toFixed(2))


    })
  }

  handlePayDuringStay(){
    this.setState({
      payTotal: false,
      payHalf: false,
      payDuringStay: true,
      paypal: false,
      paySepa: false,
      payCreditCard: true,
      amountToPay:this.state.totalPrice5,
      payOptionText:'Pay during stay',
      payOptionClosed:true,
      payMethodText:'Credit Card',
      roomRateID:roomRateIDs[2]






    })
    this.rotatePayOption();
    this.calculateFinalPrice(this.state.selectedGuests.value, this.state.firstSelection, this.state.secondSelection, this.state.thirdSelection, this.state.fourthSelection)


  }




  handlePaypal(){
    this.setState({
      paypal: true,
      paySepa: false,
      payKlarna: false,
      payGiropay: false,
      payCreditCard: false,
      payMethodText:'PayPal'


    })

  }

  handleSepa(){
    this.setState({
      paypal: false,
      paySepa: true,
      payGiropay: false,
      payCreditCard: false,
      payKlarna: false,
      payMethodText:'SEPA Direct Debit'



    })

  }

  handleCreditCard(){
    this.setState({
      paypal: false,
      paySepa: false,
      payKlarna: false,
      payGiropay: false,
      payCreditCard: true,
      payMethodText:'Credit Card'



    })

  }

  handleKlarna(){
    this.setState({
      paypal: false,
      paySepa: false,
      payKlarna: true,
      payGiropay: false,
      payCreditCard: false,
      payMethodText:'Klarna'



    })

  }

  handleGiropay(){
    this.setState({
      paypal: false,
      paySepa: false,
      payKlarna: false,
      payGiropay: true,
      payCreditCard: false,
      payMethodText:'Giropay'



    })

  }

  handleCurrencySelection = (selectedCurrency) => {
    this.setState({selectedCurrency: selectedCurrency});
    // this.calculateFinalPrice(this.state.payTotal, selectedGuests.value, this.state.firstSelection, this.state.secondSelection, this.state.thirdSelection, this.state.fourthSelection)


  }

  handlePayTotal() {
    this.setState({selectedPaymentOption: paymentOptions[0]});
    this.handlePayTotalAmount();
    this.setState({ paymentMethods:paymentMethods});

  }

  handlePayHalf(){
    this.setState({selectedPaymentOption: paymentOptions[1]});

    this.handlePayHalfAmount();
    this.setState({ paymentMethods:paymentMethods});


  }

  handleDuringStay(){
    this.setState({selectedPaymentOption: paymentOptions[2]});
    this.handlePayDuringStay();
    this.setState({selectedPaymentMethod: paymentMethods_2[0].value, paymentMethods:paymentMethods_2});
    this.handleCreditCard()
  }

  handlePaymentOptionSelection = (selectedPaymentOption) => {
    this.setState({selectedPaymentOption: selectedPaymentOption});
    if(selectedPaymentOption.value===1){
      this.handlePayTotalAmount();
      this.setState({ paymentMethods:paymentMethods});

    }
    if(selectedPaymentOption.value===2){
      this.handlePayHalfAmount();
      this.setState({ paymentMethods:paymentMethods});

    }

    if(selectedPaymentOption.value===3){
      this.handlePayDuringStay()
      this.setState({selectedPaymentMethod: paymentMethods_2[0].value, paymentMethods:paymentMethods_2});
      this.handleCreditCard()

    }

    // this.calculateFinalPrice(this.state.payTotal, selectedGuests.value, this.state.firstSelection, this.state.secondSelection, this.state.thirdSelection, this.state.fourthSelection)


  }

  handlePaymentMethodSelection = (selectedPaymentMethod) => {
    this.setState({selectedPaymentMethod: selectedPaymentMethod.value});
    //console.log(selectedPaymentMethod.value)
    if(selectedPaymentMethod.value===1){
      this.handleCreditCard()
    }
    if(selectedPaymentMethod.value===2){
      this.handlePaypal()   }

    if(selectedPaymentMethod.value===3){
      this.handleKlarna()
    }
    if(selectedPaymentMethod.value===4){
      this.handleGiropay()
    }
    if(selectedPaymentMethod.value===5){
      this.handleSepa()

    }
    if(selectedPaymentMethod.value===6){
    }

    if(selectedPaymentMethod.value===7){
    }

    // this.calculateFinalPrice(this.state.payTotal, selectedGuests.value, this.state.firstSelection, this.state.secondSelection, this.state.thirdSelection, this.state.fourthSelection)


  }

  handleRadioChange = (currSelection) => {
    this.setState({selectedPayOption: currSelection});

  }

  togglePayOption () {
    this.setState({payOptionClosed: !this.state.payOptionClosed});
    this.rotatePayOption();
  }

  togglePayMethod () {
    this.setState({payMethodClosed: !this.state.payMethodClosed});
    this.rotatePayMethod();
  }

  rotatePayOption(){
    let newRotation = this.state.payOptionRotation;
    if(newRotation === 180){
      newRotation -= 180;
    }
    else
    if(newRotation === 0){
      newRotation += 180;
    }
    this.setState({
      payOptionRotation: newRotation,
    })


  }

  rotatePayMethod(){
    let newRotation = this.state.payMethodRotation;
    if(newRotation === 180){
      newRotation -= 180;
    }
    else
    if(newRotation === 0){
      newRotation += 180;
    }
    this.setState({
      payMethodRotation: newRotation,
    })


  }




  onStepChange = current => {

  //  console.log('onChange:', current);
    if(current===0){

        this.setState({
          stepOneStatus: 'process',
          stepTwoStatus: 'wait',
          stepOneSubTitle: 'Step 1'

        });
      this.setState({ current:current });


    }

    if(current===1){

      let moreRooms = this.state.selectedRooms.value - this.state.currentSelected



      if (moreRooms===0){
        this.setState({
          stepOneStatus: 'finish',
          stepTwoStatus: 'process',
          stepOneSubTitle: <StyledSmallCheck/>

        });
     //   console.log('hello from here')
        this.setState({ current });

      }





    }
  };



  changeGuestPerRoom1 = (currentSelectedGuests) => {
let newTotalGuests = this.state.totalGuests + currentSelectedGuests.value;
    this.setState({
      totalGuests: newTotalGuests,
      selectedGuests_1: currentSelectedGuests

    });

  }

  changeGuestPerRoom2 = (newValue) => {
    this.setState({ guestsPerRoom2: newValue });
  }
  changeGuestPerRoom3 = (newValue) => {
    this.setState({ guestsPerRoom3: newValue });
  }

  changeGuestPerRoom4 = (newValue) => {
    this.setState({ guestsPerRoom4: newValue });
  }

  handleGuestSelection_1 = (currentSelectedGuests) => {
    let sel_2 = this.state.selectedGuests_2.value;
    let sel_3 = this.state.selectedGuests_3.value;
    let sel_4 = this.state.selectedGuests_4.value;
    let totalGuests = 0;
    if(this.state.firstSelection[0]===true && currentSelectedGuests.value>2) {

      this.setState({
        firstSelection: [false,false,false],
        firstCheck:false,
        firstBlockClosed:false,
        rotation_1: 180

      });

    }

    this.setState({selectedGuests_1: currentSelectedGuests});

    if(this.state.selectedRooms.value===1) {
      this.setState({totalGuests: currentSelectedGuests.value});
      totalGuests=currentSelectedGuests.value

    }
      if(this.state.selectedRooms.value===2) {
        this.setState({totalGuests: currentSelectedGuests.value + sel_2});
        totalGuests=currentSelectedGuests.value + sel_2
      }

      if(this.state.selectedRooms.value===3){
      this.setState({totalGuests: currentSelectedGuests.value+sel_2+sel_3
      });
      totalGuests=currentSelectedGuests.value+sel_2+sel_3
    }
    if(this.state.selectedRooms.value===4){
      this.setState({
        totalGuests: currentSelectedGuests.value+sel_2+sel_3+sel_4

      });
      totalGuests=currentSelectedGuests.value+sel_2+sel_3+sel_4
    }

    this.setState({specialsGuestOptions: specialsGuestOptions.slice(0,totalGuests+1)
    });
    this.calculateFinalPrice(totalGuests, this.state.firstSelection, this.state.secondSelection, this.state.thirdSelection, this.state.fourthSelection)


  };

  handleGuestSelection_2 = (currentSelectedGuests) => {
    let sel_1 = this.state.selectedGuests_1.value;
    let sel_3 = this.state.selectedGuests_3.value;
    let sel_4 = this.state.selectedGuests_4.value;
    let totalGuests = 0;

    if(this.state.secondSelection[0]===true && currentSelectedGuests.value>2) {

      this.setState({
       secondSelection: [false,false,false],
        secondCheck:false,
        secondBlockClosed:false,
        rotation_2: 180

      });

    }
    this.setState({selectedGuests_2: currentSelectedGuests});

    if(this.state.selectedRooms.value===2){
      this.setState({totalGuests: currentSelectedGuests.value+sel_1
      });
      totalGuests=currentSelectedGuests.value+sel_1;
    }

    if(this.state.selectedRooms.value===3){
      this.setState({totalGuests: currentSelectedGuests.value+sel_1+sel_3
      });
      totalGuests=currentSelectedGuests.value+sel_1+sel_3;
    }
    if(this.state.selectedRooms.value===4){
      this.setState({totalGuests: currentSelectedGuests.value+sel_1+sel_3+sel_4
      });
      totalGuests=currentSelectedGuests.value+sel_1+sel_3+sel_4;
    }

    this.setState({specialsGuestOptions: specialsGuestOptions.slice(0,totalGuests+1)
    });
    this.calculateFinalPrice(totalGuests, this.state.firstSelection, this.state.secondSelection, this.state.thirdSelection, this.state.fourthSelection)

  }

  handleGuestSelection_3 = (currentSelectedGuests) => {
    let sel_1 = this.state.selectedGuests_1.value;
    let sel_2 = this.state.selectedGuests_2.value;
    let sel_4 = this.state.selectedGuests_4.value;
    let totalGuests=0;

    if(this.state.thirdSelection[0]===true && currentSelectedGuests.value>2) {

      this.setState({
        thirdSelection: [false,false,false],
        thirdCheck:false,
        thirdBlockClosed:false,
        rotation_3: 180

      });

    }
    this.setState({selectedGuests_3: currentSelectedGuests});


    if(this.state.selectedRooms.value===3){
      this.setState({totalGuests: currentSelectedGuests.value+sel_1+sel_2,

      });
      totalGuests=currentSelectedGuests.value+sel_1+sel_2
    }

    if(this.state.selectedRooms.value===4){
      this.setState({totalGuests: currentSelectedGuests.value+sel_1+sel_2+sel_4
      });
      totalGuests=currentSelectedGuests.value+sel_1+sel_2+sel_4
    }

    this.setState({specialsGuestOptions: specialsGuestOptions.slice(0,totalGuests+1)
    });
    this.calculateFinalPrice(totalGuests, this.state.firstSelection, this.state.secondSelection, this.state.thirdSelection, this.state.fourthSelection)


  }

  handleGuestSelection_4 = (currentSelectedGuests) => {
    let sel_1 = this.state.selectedGuests_1.value;
    let sel_2 = this.state.selectedGuests_2.value;
    let sel_3 = this.state.selectedGuests_3.value;
    let totalGuests=0;

    if(this.state.fourthSelection[0]===true && currentSelectedGuests.value>2) {

      this.setState({
        fourthSelection: [false,false,false],
        fourthCheck:false,
        fourthBlockClosed:false,
        rotation_4: 180

      });

    }
    this.setState({selectedGuests_4: currentSelectedGuests});

    if(this.state.selectedRooms.value===4){
      this.setState({totalGuests: currentSelectedGuests.value+sel_1+sel_2+sel_3
      });
      totalGuests=currentSelectedGuests.value+sel_1+sel_2+sel_3;
    }

    this.setState({specialsGuestOptions: specialsGuestOptions.slice(0,totalGuests+1)
    });
    this.calculateFinalPrice(totalGuests, this.state.firstSelection, this.state.secondSelection, this.state.thirdSelection, this.state.fourthSelection)


  }

  rotate_1(){
    let newRotation = this.state.rotation_1;
    if(newRotation === 180){
      newRotation -= 180;
    }
    else
    if(newRotation === 0){
      newRotation += 180;
    }
    this.setState({
      rotation_1: newRotation,
    })
  }
  rotate_2(){
    let newRotation = this.state.rotation_2;
    if(newRotation === 180){
      newRotation -= 180;
    }
    else
    if(newRotation === 0){
      newRotation += 180;
    }
    this.setState({
      rotation_2: newRotation,
    })
  }

  rotate_3(){
    let newRotation = this.state.rotation_3;
    if(newRotation === 180){
      newRotation -= 180;
    }
    else
    if(newRotation === 0){
      newRotation += 180;
    }
    this.setState({
      rotation_3: newRotation,
    })
  }

  rotate_4(){
    let newRotation = this.state.rotation_4;
    if(newRotation === 180){
      newRotation -= 180;
    }
    else
    if(newRotation === 0){
      newRotation += 180;
    }
    this.setState({
      rotation_4: newRotation,
    })
  }

  toggleSelect_1 () {
    this.setState({firstBlockClosed: !this.state.firstBlockClosed});
    this.rotate_1();
  }
  toggleSelect_2 () {
    this.setState({secondBlockClosed: !this.state.secondBlockClosed});
    this.rotate_2();
  }
  toggleSelect_3 () {
    this.setState({thirdBlockClosed: !this.state.thirdBlockClosed});
    this.rotate_3();
  }
  toggleSelect_4 () {
    this.setState({fourthBlockClosed: !this.state.fourthBlockClosed});
    this.rotate_4();
  }


  openBottomSheet(sheetOpen){
    this.setState({ sheetOpen: sheetOpen });

    if(this.state.guestFirstName==='' || this.state.guestLastName==='' || this.state.guestZipCode==='' || this.state.guestEmail==='') {
    scroll.scrollToTop();
    }

    if(this.state.selectedRooms.value> this.state.currentSelected){
      scroll.scrollToTop();

    }

    };

  openBookingDetails(){
    this.setState({
      sheetOpen: true,
      stepOneStatus: 'process',
      stepTwoStatus: 'wait',
      stepOneSubTitle: 'Step 1',
      current:0
    });

    if(this.state.guestFirstName==='' || this.state.guestLastName==='' || this.state.guestZipCode==='' || this.state.guestEmail==='') {
    scroll.scrollToTop();
    }

    if(this.state.selectedRooms.value> this.state.currentSelected){
      scroll.scrollToTop();

    }

    };

  openBottom(){
    this.setState({ sheetOpen: true });

    if(this.state.guestFirstName==='' || this.state.guestLastName==='' || this.state.guestZipCode==='' || this.state.guestEmail==='') {
    scroll.scrollToTop();
    }

    if(this.state.selectedRooms.value> this.state.currentSelected){
      scroll.scrollToTop();

    }

    };

  toggleBottomSheetIfClosed(){
  if(!this.state.sheetOpen) {
    this.openBottomSheet(!this.state.sheetOpen);
  }

    if(this.state.guestFirstName==='' || this.state.guestLastName==='' || this.state.guestZipCode==='' || this.state.guestEmail==='') {
      scroll.scrollToTop();
    }

    if(this.state.selectedRooms.value> this.state.currentSelected){
      scroll.scrollToTop();

    }
  };


  toggleBottomSheet(){
    this.setState({ sheetOpen: !this.state.sheetOpen });

  }

  closeBottomSheet(){
    this.setState({ sheetOpen: false });

  }

  openModal (){

    this.setState({ open: false, openLogin: false, openVerify:false,sheetOpen:false});
    this.setStepTwo()



  }

  openPaymentModal (){

    this.setState({ paymentOpen:true,sheetOpen:false})
      this.closeBottomSheet.bind(this)




  }

  openVerifyModal (){

    this.setState({ verifyOpen: true, openLogin: false, open:false, sheetOpen:false})
    this.closeBottomSheet.bind(this)



  }


  getFormattedDate(date){
    if(date!== null && date!== undefined){
      return date.format('DD.MM.YYYY')
    }
    return ''

  }

  openLogin (){

    this.setState({ openLogin: true, open:false, openVerify:false })


  }

  openVerify (){
    if(this.state.isBefore){
      //todo: set step2Status etc.
    }
    this.setState({ openVerify: true, open:false, openLogin:false })


  }




  closeModal () {
    this.setState({ open: false, openLogin: false, openVerify:false,sheetOpen:false})


  }

  closePaymentModal () {
    this.setState({ paymentOpen: false, sheetOpen:false })

  }

  closeVerifyModal () {
    this.setState({ verifyOpen: false, sheetOpen:false })
    this.closeBottomSheet()

  }

  closeLogin () {
    this.setState({ openLogin: false, sheetOpen:false })
    scroll.scrollToTop();
  }

  closeVerify () {
    this.setState({ openVerify: false, sheetOpen:false })
  }

  async componentDidMount() {



    const isBefore = () => {
      if (window.localStorage.getItem('expires_at') != undefined) {
        let now = moment().toISOString()
        return moment(now).isBefore(window.localStorage.getItem('expires_at')); // true
      }
      return false;
    };

    const isItem = (item) => {
      if (window.localStorage.getItem(item) != undefined) {
        return true
      }
      return false

    };


    const returnRoomState = () => {
      if (window.localStorage.getItem('selectedRooms') != undefined) {
        return JSON.parse(window.localStorage.selectedRooms)
      }
      return roomOptions[0]

    };

    const returnGuestState = () => {
      if (window.localStorage.getItem('selectedGuests') != undefined) {
        return JSON.parse(window.localStorage.selectedGuests)
      }
      return guestOptions[0]

    };

    const returnGuestState_1 = () => {
      if (window.localStorage.getItem('selectedGuests_1') != undefined) {
        return JSON.parse(window.localStorage.selectedGuests_1)
      }
      return guestOptions_3[0]

    };
    const returnGuestState_2 = () => {
      if (window.localStorage.getItem('selectedGuests_2') != undefined) {
        return JSON.parse(window.localStorage.selectedGuests_2)
      }
      return guestOptions_3[0]

    };
    const returnGuestState_3 = () => {
      if (window.localStorage.getItem('selectedGuests_3') != undefined) {
        return JSON.parse(window.localStorage.selectedGuests_3)
      }
      return guestOptions_3[0]

    };

    const returnGuestState_4 = () => {
      if (window.localStorage.getItem('selectedGuests_4') != undefined) {
        return JSON.parse(window.localStorage.selectedGuests_4)
      }
      return guestOptions_3[0]

    };


    const returnBreakfastGuests = () => {
      if (window.localStorage.getItem('selectedBreakfastGuests') != undefined) {
        return JSON.parse(window.localStorage.selectedBreakfastGuests)
      }
      return specialsGuestOptions[0]

    };

    const returnBikeGuests = () => {
      if (window.localStorage.getItem('selectedBikeGuests') != undefined) {
        return JSON.parse(window.localStorage.selectedBikeGuests)
      }
      return specialsGuestOptions[0]

    };

    const returnBikeDays = () => {
      if (window.localStorage.getItem('selectedBikeDays') != undefined) {
        return JSON.parse(window.localStorage.selectedBikeDays)
      }
      return specialsGuestOptions[0]

    };
    const returnLaundryFillings = () => {
      if (window.localStorage.getItem('selectedLaundryFillings') != undefined) {
        return JSON.parse(window.localStorage.selectedLaundryFillings)
      }
      return specialsGuestOptions[0]

    };

    const returnChampagneBottles = () => {
      if (window.localStorage.getItem('selectedChampagneBottles') != undefined) {
        return JSON.parse(window.localStorage.selectedChampagneBottles)
      }
      return specialsGuestOptions[0]

    };

    const returnWhiteWineBottles= () => {
      if (window.localStorage.getItem('selectedWhiteWineBottles') != undefined) {
        return JSON.parse(window.localStorage.selectedWhiteWineBottles)
      }
      return specialsGuestOptions[0]

    };

    const returnRedWineBottles= () => {
      if (window.localStorage.getItem('selectedRedWineBottles') != undefined) {
        return JSON.parse(window.localStorage.selectedRedWineBottles)
      }
      return specialsGuestOptions[0]

    };

    const returnSpaTours= () => {
      if (window.localStorage.getItem('selectedSpaTours') != undefined) {
        return JSON.parse(window.localStorage.selectedSpaTours)
      }
      return specialsGuestOptions[0]

    };

    const returnSelectedPaymentOption = () => {
      if (window.localStorage.getItem('selectedPaymentOption') != undefined) {
        return JSON.parse(window.localStorage.selectedPaymentOption)
      }
      return paymentOptions[1]

    };

    const returnBreakfastDays = () => {
      if (window.localStorage.getItem('selectedBreakfastDays') != undefined) {
        return JSON.parse(window.localStorage.selectedBreakfastDays)
      }
      return specialsDaysOptions[0]

    };

    await this.setState({
      current:isItem('current') ? Number(window.localStorage.current) : 0,
      stepOneStatus:isItem('stepOneStatus') ? window.localStorage.stepOneStatus : 'process',
      stepTwoStatus:isItem('stepTwoStatus') ? window.localStorage.stepTwoStatus : 'wait',
      guestEmail: isItem('profile') ? JSON.parse(window.localStorage.profile).email : null,
      resExp: isItem('resExp') ? moment(window.localStorage.resExp) : null,
      startDate: isItem('startDate') ? moment(window.localStorage.startDate) : null,
      endDate: isItem('endDate') ? moment(window.localStorage.endDate) : null,
      nights: isItem('nights') ? Number(window.localStorage.nights) : 0,
      selectedRooms: returnRoomState(),
      selectedGuests: returnGuestState(),
     // guestOptions: isItem('guestOptions') ? JSON.parse(window.localStorage.guestOptions) : guestOptions,

      // outsideRange: moment().add(7, 'days')
      suite: isItem('suite') ? Number(window.localStorage.suite) : 0,
      studio: isItem('studio') ? Number(window.localStorage.studio) : 0,
      studioPlus: isItem('studioPlus') ? Number(window.localStorage.studioPlus) : 0,
      allAvailable: isItem('allAvailable') ? Number(window.localStorage.allAvailable) : 0,
      displayNoAvailable: isItem('displayNoAvailable') ? window.localStorage.displayNoAvailable : 'none',
      displayPleaseSelect: isItem('displayNoAvailable') ? window.localStorage.displayPleaseSelect : 'block',
      firstSelection: isItem('firstSelection') ? JSON.parse("[" + window.localStorage.firstSelection + "]") : [false, false, false],
      secondSelection: isItem('secondSelection') ? JSON.parse("[" + window.localStorage.secondSelection + "]") : [false, false, false],
      thirdSelection: isItem('thirdSelection') ? JSON.parse("[" + window.localStorage.thirdSelection + "]") : [false, false, false],
      fourthSelection: isItem('fourthSelection') ? JSON.parse("[" + window.localStorage.fourthSelection + "]") : [false, false, false],
      currentSelected: isItem('currentSelected') ? Number(window.localStorage.currentSelected) : 0,
      stCount: isItem('stCount') ? Number(window.localStorage.stCount) : 0,
      stpCount: isItem('stpCount') ? Number(window.localStorage.stpCount) : 0,
      suCount: isItem('suCount') ? Number(window.localStorage.suCount) : 0,
      isBefore: isBefore(),
      rotation_1: isItem('rotation_1') ? Number(window.localStorage.rotation_1) : 180,
      rotation_2: isItem('rotation_2') ? Number(window.localStorage.rotation_2) : 180,
      rotation_3: isItem('rotation_3') ? Number(window.localStorage.rotation_3) : 180,
      rotation_4: isItem('rotation_4') ? Number(window.localStorage.rotation_4) : 180,

      firstBlockClosed: isItem('firstBlockClosed') ? JSON.parse(window.localStorage.firstBlockClosed) : false,
      secondBlockClosed: isItem('secondBlockClosed') ? JSON.parse(window.localStorage.secondBlockClosed) : false,
      thirdBlockClosed: isItem('thirdBlockClosed') ? JSON.parse(window.localStorage.thirdBlockClosed) : false,
      fourthBlockClosed: isItem('fourthBlockClosed') ? JSON.parse(window.localStorage.fourthBlockClosed) : false,

      firstCheck: isItem('firstCheck') ? JSON.parse(window.localStorage.firstCheck) : false,
      secondCheck: isItem('secondCheck') ? JSON.parse(window.localStorage.secondCheck) : false,
      thirdCheck: isItem('thirdCheck') ? JSON.parse(window.localStorage.thirdCheck) : false,
      fourthCheck: isItem('fourthCheck') ? JSON.parse(window.localStorage.fourthCheck) : false,

      selectedBikes: isItem('selectedBikes') ? Number(window.localStorage.selectedBikes) : 0,
      selectedBreakfast: isItem('selectedBreakfast') ? Number(window.localStorage.selectedBreakfast) : 0,
      selectedLaundry: isItem('selectedLaundry') ? Number(window.localStorage.selectedLaundry) : 0,
      selectedSpa: isItem('selectedBikes') ? Number(window.localStorage.selectedSpa) : 0,
      selectedWhiteWine: isItem('selectedWhiteWine') ? Number(window.localStorage.selectedWhiteWine) : 0,
      selectedRedWine: isItem('selectedRedWine') ? Number(window.localStorage.selectedRedWine) : 0,
      selectedChampagne: isItem('selectedChampagne') ? Number(window.localStorage.selectedChampagne) : 0,

      selectedBreakfastGuests: returnBreakfastGuests(),
      selectedBreakfastDays: returnBreakfastDays(),
      selectedBikeGuests: returnBikeGuests(),
      selectedBikeDays: returnBikeDays(),
      selectedLaundryFillings: returnLaundryFillings(), // max = nights
      selectedChampagneBottles: returnChampagneBottles(), // max = nights
      selectedWhiteWineBottles: returnWhiteWineBottles(), // max = nights
      selectedRedWineBottles: returnRedWineBottles(), // max = nights
      selectedSpaTours: returnSpaTours(), // max = nights

      breakfastSelected: isItem('breakfastSelected') ? JSON.parse(window.localStorage.breakfastSelected) : false,
      bikesSelected: isItem('bikesSelected') ? JSON.parse(window.localStorage.bikesSelected) : false,
      spaSelected: isItem('spaSelected') ? JSON.parse(window.localStorage.spaSelected) : false,
      laundrySelected: isItem('laundrySelected') ? JSON.parse(window.localStorage.laundrySelected) : false,
      champagneSelected: isItem('champagneSelected') ? JSON.parse(window.localStorage.champagneSelected) : false,
      whiteWineSelected: isItem('whiteWineSelected') ? JSON.parse(window.localStorage.whiteWineSelected) : false,
      redWineSelected: isItem('redWineSelected') ? JSON.parse(window.localStorage.redWineSelected) : false,
      notes: isItem('notes') ? window.localStorage.notes : '',


      guestOptions_1: isItem('guestOptions_1') ? JSON.parse(window.localStorage.guestOptions_1) : guestOptions_3,
      guestOptions_2: isItem('guestOptions_2') ? JSON.parse(window.localStorage.guestOptions_2) : guestOptions_3,
      guestOptions_3: isItem('guestOptions_3') ? JSON.parse(window.localStorage.guestOptions_3) : guestOptions_3,
      guestOptions_4: isItem('guestOptions_4') ? JSON.parse(window.localStorage.guestOptions_4) : guestOptions_3,
      selectedGuests_1: returnGuestState_1(),
      selectedGuests_2: returnGuestState_2(),
      selectedGuests_3: returnGuestState_3(),
      selectedGuests_4: returnGuestState_4(),

      payTotal: isItem('payTotal') ? JSON.parse(window.localStorage.payTotal) : false,
      payHalf: isItem('payHalf') ? JSON.parse(window.localStorage.payHalf) : true,
      payDuringStay: isItem('payDuringStay') ? JSON.parse(window.localStorage.payDuringStay) : false,
      paypal: isItem('paypal') ? JSON.parse(window.localStorage.paypal) : false,
      paySepa: isItem('paySepa') ? JSON.parse(window.localStorage.paySepa) : false,
      payCreditCard: isItem('payCreditCard') ? JSON.parse(window.localStorage.payCreditCard) : true,
      payKlarna: isItem('payKlarna') ? JSON.parse(window.localStorage.payKlarna) : false,
      payGiropay: isItem('payGiropay') ? JSON.parse(window.localStorage.payGiropay) : false,
      payBankTransfer: isItem('payBankTransfer') ? JSON.parse(window.localStorage.payBankTransfer) : false,
      selectedPaymentOption: returnSelectedPaymentOption(),



    })

    const setState = () => {

      this.setState({
        current:isItem('current') ? JSON.parse(window.localStorage.current) : 0,
        stepOneStatus:isItem('stepOneStatus') ? window.localStorage.stepOneStatus : 'process',
        stepTwoStatus:isItem('stepTwoStatus') ? window.localStorage.stepTwoStatus : 'wait',
        resExp: isItem('resExp') ? moment(window.localStorage.resExp) : null,
        startDate: isItem('startDate') ? moment(window.localStorage.startDate) : null,
        endDate: isItem('endDate') ? moment(window.localStorage.endDate) : null,
        nights: isItem('nights') ? Number(window.localStorage.nights) : 0,
        selectedRooms: returnRoomState(),
        selectedGuests: returnGuestState(),
       // guestOptions: isItem('guestOptions') ? JSON.parse(window.localStorage.guestOptions) : guestOptions,

        // outsideRange: moment().add(7, 'days')
        suite: isItem('suite') ? Number(window.localStorage.suite) : 0,
        studio: isItem('studio') ? Number(window.localStorage.studio) : 0,
        studioPlus: isItem('studioPlus') ? Number(window.localStorage.studioPlus) : 0,
        allAvailable: isItem('allAvailable') ? Number(window.localStorage.allAvailable) : 0,
        displayNoAvailable: isItem('displayNoAvailable') ? window.localStorage.displayNoAvailable : 'none',
        displayPleaseSelect: isItem('displayNoAvailable') ? window.localStorage.displayPleaseSelect : 'block',
        firstSelection: isItem('firstSelection') ? JSON.parse("[" + window.localStorage.firstSelection + "]") : [false, false, false],
        secondSelection: isItem('secondSelection') ? JSON.parse("[" + window.localStorage.secondSelection + "]") : [false, false, false],
        thirdSelection: isItem('thirdSelection') ? JSON.parse("[" + window.localStorage.thirdSelection + "]") : [false, false, false],
        fourthSelection: isItem('fourthSelection') ? JSON.parse("[" + window.localStorage.fourthSelection + "]") : [false, false, false],
        currentSelected: isItem('currentSelected') ? Number(window.localStorage.currentSelected) : 0,
        stCount: isItem('stCount') ? Number(window.localStorage.stCount) : 0,
        stpCount: isItem('stpCount') ? Number(window.localStorage.stpCount) : 0,
        suCount: isItem('suCount') ? Number(window.localStorage.suCount) : 0,
        rotation_1: isItem('rotation_1') ? Number(window.localStorage.rotation_1) : 180,
        rotation_2: isItem('rotation_2') ? Number(window.localStorage.rotation_2) : 180,
        rotation_3: isItem('rotation_3') ? Number(window.localStorage.rotation_3) : 180,
        rotation_4: isItem('rotation_4') ? Number(window.localStorage.rotation_4) : 180,

        firstBlockClosed: isItem('firstBlockClosed') ? JSON.parse(window.localStorage.firstBlockClosed) : false,
        secondBlockClosed: isItem('secondBlockClosed') ? JSON.parse(window.localStorage.secondBlockClosed) : false,
        thirdBlockClosed: isItem('thirdBlockClosed') ? JSON.parse(window.localStorage.thirdBlockClosed) : false,
        fourthBlockClosed: isItem('fourthBlockClosed') ? JSON.parse(window.localStorage.fourthBlockClosed) : false,

        firstCheck: isItem('firstCheck') ? JSON.parse(window.localStorage.firstCheck) : false,
        secondCheck: isItem('secondCheck') ? JSON.parse(window.localStorage.secondCheck) : false,
        thirdCheck: isItem('thirdCheck') ? JSON.parse(window.localStorage.thirdCheck) : false,
        fourthCheck: isItem('fourthCheck') ? JSON.parse(window.localStorage.fourthCheck) : false,


        selectedBikes: isItem('selectedBikes') ? Number(window.localStorage.selectedBikes) : 0,
        selectedBreakfast: isItem('selectedBreakfast') ? Number(window.localStorage.selectedBreakfast) : 0,
        selectedLaundry: isItem('selectedLaundry') ? Number(window.localStorage.selectedLaundry) : 0,
        selectedSpa: isItem('selectedBikes') ? Number(window.localStorage.selectedSpa) : 0,
        selectedWhiteWine: isItem('selectedWhiteWine') ? Number(window.localStorage.selectedWhiteWine) : 0,
        selectedRedWine: isItem('selectedRedWine') ? Number(window.localStorage.selectedRedWine) : 0,
        selectedChampagne: isItem('selectedChampagne') ? Number(window.localStorage.selectedChampagne) : 0,

        selectedBreakfastGuests: returnBreakfastGuests(),
        selectedBreakfastDays: returnBreakfastDays(),
        selectedBikeGuests: returnBikeGuests(),
        selectedBikeDays: returnBikeDays(),
        selectedLaundryFillings: returnLaundryFillings(), // max = nights
        selectedChampagneBottles: returnChampagneBottles(), // max = nights
        selectedWhiteWineBottles: returnWhiteWineBottles(), // max = nights
        selectedRedWineBottles: returnRedWineBottles(), // max = nights
        selectedSpaTours: returnSpaTours(), // max = nights

        breakfastSelected: isItem('breakfastSelected') ? JSON.parse(window.localStorage.breakfastSelected) : false,
        bikesSelected: isItem('bikesSelected') ? JSON.parse(window.localStorage.bikesSelected) : false,
        spaSelected: isItem('spaSelected') ? JSON.parse(window.localStorage.spaSelected) : false,
        laundrySelected: isItem('laundrySelected') ? JSON.parse(window.localStorage.laundrySelected) : false,
        champagneSelected: isItem('champagneSelected') ? JSON.parse(window.localStorage.champagneSelected) : false,
        whiteWineSelected: isItem('whiteWineSelected') ? JSON.parse(window.localStorage.whiteWineSelected) : false,
        redWineSelected: isItem('redWineSelected') ? JSON.parse(window.localStorage.redWineSelected) : false,
        notes: isItem('notes') ? window.localStorage.notes : '',

        guestOptions_1: isItem('guestOptions_1') ? JSON.parse(window.localStorage.guestOptions_1) : guestOptions_3,
        guestOptions_2: isItem('guestOptions_2') ? JSON.parse(window.localStorage.guestOptions_2) : guestOptions_3,
        guestOptions_3: isItem('guestOptions_3') ? JSON.parse(window.localStorage.guestOptions_3) : guestOptions_3,
        guestOptions_4: isItem('guestOptions_4') ? JSON.parse(window.localStorage.guestOptions_4) : guestOptions_3,
        selectedGuests_1: returnGuestState_1(),
        selectedGuests_2: returnGuestState_2(),
        selectedGuests_3: returnGuestState_3(),
        selectedGuests_4: returnGuestState_4(),

        payTotal: isItem('payTotal') ? JSON.parse(window.localStorage.payTotal) : false,
        payHalf: isItem('payHalf') ? JSON.parse(window.localStorage.payHalf) : true,
        payDuringStay: isItem('payDuringStay') ? JSON.parse(window.localStorage.payDuringStay) : false,
        paypal: isItem('paypal') ? JSON.parse(window.localStorage.paypal) : false,
        paySepa: isItem('paySepa') ? JSON.parse(window.localStorage.paySepa) : false,
        payCreditCard: isItem('payCreditCard') ? JSON.parse(window.localStorage.payCreditCard) : true,
        payKlarna: isItem('payKlarna') ? JSON.parse(window.localStorage.payKlarna) : false,
        payGiropay: isItem('payGiropay') ? JSON.parse(window.localStorage.payGiropay) : false,
        payBankTransfer: isItem('payBankTransfer') ? JSON.parse(window.localStorage.payBankTransfer) : false,

        selectedPaymentOption: returnSelectedPaymentOption(),



      })
    //  let totalGuests = returnGuestState_1().value + returnGuestState_2().value + returnGuestState_3().value + returnGuestState_4().value
      //   this.checkAvailability(this.state.startDate, this.state.endDate)


    }


    if(this.state.payTotal){
      this.handlePayTotal()
    }

    if(this.state.payHalf){
      this.handlePayHalf()

    }
    if(this.state.payDuringStay){
      this.handlePayDuringStay()
    }

    window.addEventListener('unload', function (event) {

      if(this.state.payTotal){
        this.handlePayTotal()
      }

      if(this.state.payHalf){
        this.handlePayHalf()

      }
      if(this.state.payDuringStay){
        this.handlePayDuringStay()
      }

      //console.log('Hello')
      setState();

    }.bind(this));
    let totalGuests = returnGuestState_1().value + returnGuestState_2().value + returnGuestState_3().value + returnGuestState_4().value
    await this.checkAvailabilityInMount(this.state.startDate, this.state.endDate);
      this.calculateFinalPrice(totalGuests, isItem('firstSelection') ? JSON.parse("[" + window.localStorage.firstSelection + "]") : [false, false, false],
        isItem('secondSelection') ? JSON.parse("[" + window.localStorage.secondSelection + "]") : [false, false, false],
        isItem('thirdSelection') ? JSON.parse("[" + window.localStorage.thirdSelection + "]") : [false, false, false],
        isItem('fourthSelection') ? JSON.parse("[" + window.localStorage.fourthSelection + "]") : [false, false, false])



    if(this.state.payTotal){
        this.handlePayTotal()
    }

    if(this.state.payHalf){
      this.handlePayHalf()

    }
    if(this.state.payDuringStay){
        this.handlePayDuringStay()
    }
  }





  // getRatePlans and set state rates

  getSetRatePlans(startDate, endDate, token){
    let ratePlans = getRatePlans(startDate, endDate, token)
    ratePlans.then(function (r) {
      let rp = JSON.parse(r.body);
      //console.log(rp)
      if (rp.success === true) {
        const data = rp.data;
        let availableStudios = 0;
        let availableStudioPlus = 0;
        let availableSuites = 0;
        for (let d = 0; d < data.length; d++) {

  //set base rates and availability
          if (data[d].rateID === ratePlanIDs[9].id && data[d].roomTypeID === roomTypeIDs[0].id) {
            availableStudios = data[d].roomsAvailable;
            this.setState({
              stRate: data[d].roomRate,
              studio: availableStudios

            })
          }

          if (data[d].rateID === ratePlanIDs[10].id && data[d].roomTypeID === roomTypeIDs[1].id) {
            availableStudioPlus = data[d].roomsAvailable;
            this.setState({
              stpRate: data[d].roomRate,
              studioPlus: availableStudioPlus

            })
          }

          if (data[d].rateID === ratePlanIDs[11].id && data[d].roomTypeID === roomTypeIDs[2].id) {
            availableSuites = data[d].roomsAvailable;
            this.setState({
              suRate: data[d].roomRate,
              suite: availableSuites

            })
          }



//studios
         if (data[d].rateID === ratePlanIDs[0].id && data[d].roomTypeID === roomTypeIDs[0].id) {
            this.setState({
              stRate15: data[d].roomRate,

            })
          }
          if (data[d].rateID === ratePlanIDs[3].id && data[d].roomTypeID === roomTypeIDs[0].id) {
            this.setState({
              stRate7: data[d].roomRate,

            })
          }

          if (data[d].rateID === ratePlanIDs[6].id && data[d].roomTypeID === roomTypeIDs[0].id) {
            this.setState({
              stRate5: data[d].roomRate,

            })
          }

//studio plus
          if (data[d].rateID === ratePlanIDs[1].id && data[d].roomTypeID === roomTypeIDs[1].id) {
            this.setState({
              stpRate15: data[d].roomRate,

            })
          }
          if (data[d].rateID === ratePlanIDs[4].id && data[d].roomTypeID === roomTypeIDs[1].id) {
            this.setState({
              stpRate7: data[d].roomRate,

            })
          }

          if (data[d].rateID === ratePlanIDs[7].id && data[d].roomTypeID === roomTypeIDs[1].id) {
            this.setState({
              stpRate5: data[d].roomRate,

            })
          }

//suites
          if (data[d].rateID === ratePlanIDs[2].id && data[d].roomTypeID === roomTypeIDs[2].id) {
            this.setState({
              suRate15: data[d].roomRate,

            })
          }
          if (data[d].rateID === ratePlanIDs[5].id && data[d].roomTypeID === roomTypeIDs[2].id) {
            this.setState({
              suRate7: data[d].roomRate,

            })
          }

          if (data[d].rateID === ratePlanIDs[8].id && data[d].roomTypeID === roomTypeIDs[2].id) {
            this.setState({
              suRate5: data[d].roomRate,

            })
          }


        }
        this.setState({
          allAvailable: availableStudios + availableStudioPlus + availableSuites,
          showSpinner:false,
          resExp:moment().add(3600, 'seconds')

        })
      }

      else {
        //todo: show loading error

      }


    });
  }

//  to compare selected dates with ical_data of residences
 async checkAvailability(startDate, endDate) {


   // console.log(window.localStorage.selectedGuests)

   //// console.log(window.localStorage)
    this.setState({startDate, endDate});
    if (startDate != null && endDate != null) {
      this.setState({
        showSpinner: true,
        displayPleaseSelect:'none'
      })
      var dates = [],
        currentDate = startDate["_d"],
        addDays = function (days) {
          var date = new Date(this.valueOf());
          date.setDate(date.getDate() + days);
          return date;
        };

      while (currentDate <= endDate["_d"]) {
        dates.push(currentDate);
        currentDate = addDays.call(currentDate, 1);
      }


      //let new_dates;
      //new_dates = dates.splice(0).splice(dates.length-1);
      let nights = dates.length - 1;
      this.setState({
        nights: nights,

      })

      if (dates.length > 2) {

      }
      //console.log(dates)


      let all = 13;
      //check availability regExp
     // let mom =  moment().toISOString()




          const token = await getAccessToken();
          let rp = await getRatePlans(startDate, endDate, JSON.parse(token.body));
          let ratePlans = JSON.parse(rp.body);
          //console.log(ratePlans)
      let availableStudios = 0;
      let availableStudioPlus = 0;
      let availableSuites = 0;
          if (ratePlans.success === true) {
            const data = ratePlans.data;

            for (let d = 0; d < data.length; d++) {

              //set base rates and availability
              if (data[d].rateID === ratePlanIDs[9].id && data[d].roomTypeID === roomTypeIDs[0].id) {
                availableStudios = data[d].roomsAvailable;
                this.setState({
                  stRate: data[d].roomRate,
                  studio: availableStudios

                })
              }

              if (data[d].rateID === ratePlanIDs[10].id && data[d].roomTypeID === roomTypeIDs[1].id) {
                availableStudioPlus = data[d].roomsAvailable;
                this.setState({
                  stpRate: data[d].roomRate,
                  studioPlus: availableStudioPlus

                })
              }

              if (data[d].rateID === ratePlanIDs[11].id && data[d].roomTypeID === roomTypeIDs[2].id) {
                availableSuites = data[d].roomsAvailable;
                this.setState({
                  suRate: data[d].roomRate,
                  suite: availableSuites

                })
              }



              // studios

              if (data[d].rateID === ratePlanIDs[0].id && data[d].roomTypeID === roomTypeIDs[0].id) {
                this.setState({
                  stRate15: data[d].roomRate,

                })
              }
              if (data[d].rateID === ratePlanIDs[3].id && data[d].roomTypeID === roomTypeIDs[0].id) {
                this.setState({
                  stRate7: data[d].roomRate,

                })
              }

              if (data[d].rateID === ratePlanIDs[6].id && data[d].roomTypeID === roomTypeIDs[0].id) {
                this.setState({
                  stRate5: data[d].roomRate,

                })
              }

//studio plus
              if (data[d].rateID === ratePlanIDs[1].id && data[d].roomTypeID === roomTypeIDs[1].id) {
                this.setState({
                  stpRate15: data[d].roomRate,

                })
              }
              if (data[d].rateID === ratePlanIDs[4].id && data[d].roomTypeID === roomTypeIDs[1].id) {
                this.setState({
                  stpRate7: data[d].roomRate,

                })
              }

              if (data[d].rateID === ratePlanIDs[7].id && data[d].roomTypeID === roomTypeIDs[1].id) {
                this.setState({
                  stpRate5: data[d].roomRate,

                })
              }

//suites
              if (data[d].rateID === ratePlanIDs[2].id && data[d].roomTypeID === roomTypeIDs[2].id) {
                this.setState({
                  suRate15: data[d].roomRate,

                })
              }
              if (data[d].rateID === ratePlanIDs[5].id && data[d].roomTypeID === roomTypeIDs[2].id) {
                this.setState({
                  suRate7: data[d].roomRate,

                })
              }

              if (data[d].rateID === ratePlanIDs[8].id && data[d].roomTypeID === roomTypeIDs[2].id) {
                this.setState({
                  suRate5: data[d].roomRate,

                })
              }


            }
            this.setState({
              allAvailable: availableStudios + availableStudioPlus + availableSuites,
              showSpinner: false

            })

            if((availableStudios + availableStudioPlus + availableSuites)===0) {

            }
          }

          else {
            //todo: show loading error

          }



      //wipe all past selections due to new selected dates (also if start/end date is not selected
      this.setState({
        displayPleaseSelect: 'none',
        finalStPrice: 0,
        finalStpPrice: 0,
        finalSuPrice: 0,
        finalStPrice5: 0,
        finalStpPrice5: 0,
        finalSuPrice5: 0,
        finalStPrice7: 0,
        finalStpPrice7: 0,
        finalSuPrice7: 0,
        finalStPrice15: 0,
        finalStpPrice15: 0,
        finalSuPrice15: 0,
        totalPrice: 0,
        totalPrice5: 0,
        totalPrice7: 0,
        totalPrice15: 0,
        discount: 0,
        discount5: 0,
        discount7: 0,
        discount8: 0,
        discount15: 0,
        stCount: 0,
        stpCount: 0,
        suCount: 0,
        firstSelection: [false, false, false],
        secondSelection: [false, false, false],
        thirdSelection: [false, false, false],
        fourthSelection: [false, false, false],
        sheetOpen:false,
        rotation_1: 180,
        rotation_2: 180,
        rotation_3: 180,
        rotation_4: 180,

        firstBlockClosed:false,
        secondBlockClosed:false,
        thirdBlockClosed:false,
        fourthBlockClosed:false,

        firstCheck:false,
        secondCheck:false,
        thirdCheck:false,
        fourthCheck:false

      })

      if ((availableStudios + availableStudioPlus + availableSuites) < this.state.selectedRooms.value) {
        this.setState({
          displayNoAvailable: 'block',


        })
      }
      else {
        this.setState({
          displayNoAvailable: 'none'

        })
      }

      this.setState({
        specialsDaysOptions: specialsDaysOptions.slice(0,nights+1)

      })
    }
    else {
      this.setState({
        resExp:null,
        allAvailable: 0,
        studio: 0,
        studioPlus: 0,
        suite: 0,
        displayNoAvailable: 'none',
        displayPleaseSelect: 'block',
        nights: 0,
        finalStPrice: 0,
        finalStpPrice: 0,
        finalSuPrice: 0,
        finalStPrice5: 0,
        finalStpPrice5: 0,
        finalSuPrice5: 0,
        finalStPrice7: 0,
        finalStpPrice7: 0,
        finalSuPrice7: 0,
        finalStPrice15: 0,
        finalStpPrice15: 0,
        finalSuPrice15: 0,
        totalPrice: 0,
        totalPrice5: 0,
        totalPrice7: 0,
        totalPrice15: 0,
        discount: 0,
        discount5: 0,
        discount7: 0,
        discount8: 0,
        discount15: 0,
        stCount: 0,
        stpCount: 0,
        suCount: 0,
        firstSelection: [false, false, false],
        secondSelection: [false, false, false],
        thirdSelection: [false, false, false],
        fourthSelection: [false, false, false],
        currentSelected: 0,
        specialsDaysOptions: specialsDaysOptions.slice(0,1),

      })
    }


  }

//  to compare selected dates with ical_data of residences
 async checkAvailabilityInMount(startDate, endDate) {


   // console.log(window.localStorage.selectedGuests)

   //// console.log(window.localStorage)
    this.setState({startDate, endDate});
    if (startDate != null && endDate != null) {
      this.setState({
        showSpinner: true,
        displayPleaseSelect:'none'

      })
      var dates = [],
        currentDate = startDate["_d"],
        addDays = function (days) {
          var date = new Date(this.valueOf());
          date.setDate(date.getDate() + days);
          return date;
        };

      while (currentDate <= endDate["_d"]) {
        dates.push(currentDate);
        currentDate = addDays.call(currentDate, 1);
      }


      //let new_dates;
      //new_dates = dates.splice(0).splice(dates.length-1);
      let nights = dates.length - 1;
      this.setState({
        nights: nights,

      });

      if (dates.length > 2) {

      }
      //console.log(dates)


      let all = 13;
      //check availability regExp
      //let mom =  moment().toISOString();




          const token = await getAccessToken()
    //  console.log(token);
          let rp = await getRatePlans(startDate, endDate, JSON.parse(token.body));
          let ratePlans = JSON.parse(rp.body);
          //console.log(ratePlans)
      let availableStudios = 0;
      let availableStudioPlus = 0;
      let availableSuites = 0;
          if (ratePlans.success === true) {
            const data = ratePlans.data;

            for (let d = 0; d < data.length; d++) {

              //set base rates and availability
              if (data[d].rateID === ratePlanIDs[9].id && data[d].roomTypeID === roomTypeIDs[0].id) {
                availableStudios = data[d].roomsAvailable;
                this.setState({
                  stRate: data[d].roomRate,
                  studio: availableStudios

                })
              }

              if (data[d].rateID === ratePlanIDs[10].id && data[d].roomTypeID === roomTypeIDs[1].id) {
                availableStudioPlus = data[d].roomsAvailable;
                this.setState({
                  stpRate: data[d].roomRate,
                  studioPlus: availableStudioPlus

                })
              }

              if (data[d].rateID === ratePlanIDs[11].id && data[d].roomTypeID === roomTypeIDs[2].id) {
                availableSuites = data[d].roomsAvailable;
                this.setState({
                  suRate: data[d].roomRate,
                  suite: availableSuites

                })
              }


              // studios

              if (data[d].rateID === ratePlanIDs[0].id && data[d].roomTypeID === roomTypeIDs[0].id) {
                this.setState({
                  stRate15: data[d].roomRate,

                })
              }
              if (data[d].rateID === ratePlanIDs[3].id && data[d].roomTypeID === roomTypeIDs[0].id) {
                this.setState({
                  stRate7: data[d].roomRate,

                })
              }

              if (data[d].rateID === ratePlanIDs[6].id && data[d].roomTypeID === roomTypeIDs[0].id) {
                this.setState({
                  stRate5: data[d].roomRate,

                })
              }

//studio plus
              if (data[d].rateID === ratePlanIDs[1].id && data[d].roomTypeID === roomTypeIDs[1].id) {
                this.setState({
                  stpRate15: data[d].roomRate,

                })
              }
              if (data[d].rateID === ratePlanIDs[4].id && data[d].roomTypeID === roomTypeIDs[1].id) {
                this.setState({
                  stpRate7: data[d].roomRate,

                })
              }

              if (data[d].rateID === ratePlanIDs[7].id && data[d].roomTypeID === roomTypeIDs[1].id) {
                this.setState({
                  stpRate5: data[d].roomRate,

                })
              }

//suites
              if (data[d].rateID === ratePlanIDs[2].id && data[d].roomTypeID === roomTypeIDs[2].id) {
                this.setState({
                  suRate15: data[d].roomRate,

                })
              }
              if (data[d].rateID === ratePlanIDs[5].id && data[d].roomTypeID === roomTypeIDs[2].id) {
                this.setState({
                  suRate7: data[d].roomRate,

                })
              }

              if (data[d].rateID === ratePlanIDs[8].id && data[d].roomTypeID === roomTypeIDs[2].id) {
                this.setState({
                  suRate5: data[d].roomRate,

                })
              }


            }
            this.setState({
              allAvailable: availableStudios + availableStudioPlus + availableSuites,
              showSpinner: false

            })
          }

          else {
            //todo: show loading error

          }




      if ((availableStudios + availableStudioPlus + availableSuites) < this.state.selectedRooms.value) {
        this.setState({
          displayNoAvailable: 'block',


        })
      }
      else {
        this.setState({
          displayNoAvailable: 'none'

        })
      }

      this.setState({
        specialsDaysOptions: specialsDaysOptions.slice(0,nights+1)

      })
    }
    else {
      this.setState({
        resExp:null,
        allAvailable: 0,
        studio: 0,
        studioPlus: 0,
        suite: 0,
        displayNoAvailable: 'none',
        displayPleaseSelect: 'block',
        nights: 0,
        finalStPrice: 0,
        finalStpPrice: 0,
        finalSuPrice: 0,
        finalStPrice5: 0,
        finalStpPrice5: 0,
        finalSuPrice5: 0,
        finalStPrice7: 0,
        finalStpPrice7: 0,
        finalSuPrice7: 0,
        finalStPrice15: 0,
        finalStpPrice15: 0,
        finalSuPrice15: 0,
        totalPrice: 0,
        totalPrice5: 0,
        totalPrice7: 0,
        totalPrice15: 0,
        discount: 0,
        discount5: 0,
        discount7: 0,
        discount8: 0,
        discount15: 0,
        stCount: 0,
        stpCount: 0,
        suCount: 0,
        firstSelection: [false, false, false],
        secondSelection: [false, false, false],
        thirdSelection: [false, false, false],
        fourthSelection: [false, false, false],
        currentSelected: 0,
        specialsDaysOptions: specialsDaysOptions.slice(0,1),
        sheetOpen:true


      })
    }


  }


  setCategoryState(cat, selectNumber) {
    // let count_suite = this.state.selectedSu
    // let count_studio = this.state.selectedSt
    // let count_studio_plus = this.state.selectedStp
    let firstSelect = this.state.firstSelection;
    let secondSelect = this.state.secondSelection;
    let thirdSelect = this.state.thirdSelection;
    let fourthSelect = this.state.fourthSelection;

    if (selectNumber === 1) {

      //console.log('Item selected in first select_block')
      if (cat === 0) {
        let curr_bool = !firstSelect[0];

        firstSelect[0] = curr_bool;
        if (curr_bool) {
          scroller.scrollTo('selectBlock_1', {
            duration: 1500,
            delay: 100,
            smooth: true,
            containerId: 'selectContainer',

          })
          firstSelect[1] = false;
          firstSelect[2] = false;
        }
        this.setState({
          firstSelection: firstSelect
        })
      }

      if (cat === 1) {
        let curr_bool = !firstSelect[1];

        firstSelect[1] = curr_bool;
        if (curr_bool) {
          scroller.scrollTo('selectBlock_1', {
            duration: 1500,
            delay: 100,
            smooth: true,
            containerId: 'selectContainer',

          })
          firstSelect[0] = false;
          firstSelect[2] = false;
        }
        this.setState({
          firstSelection: firstSelect
        })
      }

      if (cat === 2) {
        let curr_bool = !firstSelect[2];

        firstSelect[2] = curr_bool;
        if (curr_bool) {
          scroller.scrollTo('selectBlock_1', {
            duration: 1500,
            delay: 100,
            smooth: true,
            containerId: 'selectContainer',

          })
          firstSelect[0] = false;
          firstSelect[1] = false;
        }
        this.setState({
          firstSelection: firstSelect
        })
      }

    }

    if (selectNumber === 2) {
      if (cat === 0) {
        let curr_bool = !secondSelect[0];

        secondSelect[0] = curr_bool;
        if (curr_bool) {
          scroller.scrollTo('selectBlock_2', {
            duration: 1500,
            delay: 100,
            smooth: true,
            containerId: 'selectContainer',

          })
          secondSelect[1] = false;
          secondSelect[2] = false;
        }
        this.setState({
          secondSelection: secondSelect
        })
      }

      if (cat === 1) {
        let curr_bool = !secondSelect[1];

        secondSelect[1] = curr_bool;
        if (curr_bool) {
          scroller.scrollTo('selectBlock_2', {
            duration: 1500,
            delay: 100,
            smooth: true,
            containerId: 'selectContainer',

          })
          secondSelect[0] = false;
          secondSelect[2] = false;
        }
        this.setState({
          secondSelection: secondSelect
        })
      }

      if (cat === 2) {
        let curr_bool = !secondSelect[2];

        secondSelect[2] = curr_bool;
        if (curr_bool) {
          scroller.scrollTo('selectBlock_2', {
            duration: 1500,
            delay: 100,
            smooth: true,
            containerId: 'selectContainer',

          })
        }
          secondSelect[0] = false;
          secondSelect[1] = false;

        this.setState({
          secondSelection: secondSelect
        })
      }

    }


    if (selectNumber === 3) {
      if (cat === 0) {
        let curr_bool = !thirdSelect[0];

        thirdSelect[0] = curr_bool;
        if (curr_bool) {
          scroller.scrollTo('selectBlock_3', {
            duration: 1500,
            delay: 100,
            smooth: true,
            containerId: 'selectContainer',

          })
          thirdSelect[1] = false;
          thirdSelect[2] = false;
        }
        this.setState({
          thirdSelection: thirdSelect
        })
      }

      if (cat === 1) {
        let curr_bool = !thirdSelect[1];

        thirdSelect[1] = curr_bool;
        if (curr_bool) {
          scroller.scrollTo('selectBlock_3', {
            duration: 1500,
            delay: 100,
            smooth: true,
            containerId: 'selectContainer',

          })
          thirdSelect[0] = false;
          thirdSelect[2] = false;
        }
        this.setState({
          thirdSelection: thirdSelect
        })
      }

      if (cat === 2) {
        let curr_bool = !thirdSelect[2];

        thirdSelect[2] = curr_bool;
        if (curr_bool) {
          scroller.scrollTo('selectBlock_3', {
            duration: 1500,
            delay: 100,
            smooth: true,
            containerId: 'selectContainer',

          })
          thirdSelect[0] = false;
          thirdSelect[1] = false;
        }
        this.setState({
          thirdSelection: thirdSelect
        })
      }

    }


    if (selectNumber === 4) {
      if (cat === 0) {
        let curr_bool = !fourthSelect[0];

        fourthSelect[0] = curr_bool;
        if (curr_bool) {
          scroller.scrollTo('selectBlock_4', {
            duration: 1500,
            delay: 100,
            smooth: true,
            containerId: 'selectContainer',

          })
          fourthSelect[1] = false;
          fourthSelect[2] = false;
        }
        this.setState({
          fourthSelection: fourthSelect
        })
      }

      if (cat === 1) {
        let curr_bool = !fourthSelect[1];

        fourthSelect[1] = curr_bool;
        if (curr_bool) {
          scroller.scrollTo('selectBlock_4', {
            duration: 1500,
            delay: 100,
            smooth: true,
            containerId: 'selectContainer',

          })
          fourthSelect[0] = false;
          fourthSelect[2] = false;
        }
        this.setState({
          fourthSelection: fourthSelect
        })
      }

      if (cat === 2) {
        let curr_bool = !fourthSelect[2];

        fourthSelect[2] = curr_bool;
        if (curr_bool) {
          scroller.scrollTo('selectBlock_4', {
            duration: 1500,
            delay: 100,
            smooth: true,
            containerId: 'selectContainer',

          })
          fourthSelect[0] = false;
          fourthSelect[1] = false;
        }
        this.setState({
          fourthSelection: fourthSelect
        })
      }

    }
    this.calculateFinalPrice(this.state.totalGuests, this.state.firstSelection, this.state.secondSelection, this.state.thirdSelection, this.state.fourthSelection)

    //console.log(this.state.firstSelection[0])
    //console.log(this.state.firstSelection[1])
    //console.log(this.state.firstSelection[2])
    //console.log(this.state.secondSelection[0])
    //console.log(this.state.secondSelection[1])
    //console.log(this.state.secondSelection[2])
    //console.log(this.state.thirdSelection[0])
    //console.log(this.state.thirdSelection[1])
    //console.log(this.state.thirdSelection[2])

    let counter_1 = 0;
    let counter_2 = 0;
    let counter_3 = 0;
    let counter_4 = 0;

    for(let c=0;c<this.state.firstSelection.length;c++){
      if(this.state.firstSelection[c]===true){
        counter_1++
      }
      if(this.state.secondSelection[c]===true){
        counter_2++
      }

      if(this.state.thirdSelection[c]===true){
        counter_3++
      }

      if(this.state.fourthSelection[c]===true){
        counter_4++
      }
    }

    if(counter_1!=0){
      this.setState({

        firstBlockClosed: true,
        firstCheck:true,
        rotation_1:0

      })
    }
    else{
      this.setState({
        firstCheck:false

      })
      }

    if(counter_2!=0){
      this.setState({
        secondBlockClosed: true,
        secondCheck:true,
        rotation_2:0


      })
    }
    else{
      this.setState({
        secondCheck:false

      })
    }

    if(counter_3!=0){
      this.setState({
        thirdBlockClosed: true,
        thirdCheck:true,
        rotation_3:0


      })
    }
    else{
      this.setState({
        thirdCheck:false

      })
    }
    if(counter_4!=0){
      this.setState({
        fourthBlockClosed: true,
        fourthCheck: true,
        rotation_4:0

      })
    }
    else{
      this.setState({
        fourthCheck:false

      })
    }


    if(this.state.firstSelection[0]){
      this.setState({
        maxValue1:2

      })
    }
    else {
      this.setState({
        maxValue1:3

      })
    }
    if(this.state.secondSelection[0]){
      this.setState({
        maxValue2:2

      })
    }
    else {
      this.setState({
        maxValue2:3

      })
    }
     if(this.state.thirdSelection[0]){
      this.setState({
        maxValue3:2

      })
    }
    else {
      this.setState({
        maxValue3:3

      })
    }
  if(this.state.fourthSelection[0]){
      this.setState({
        maxValue4:2

      })
    }
    else {
      this.setState({
        maxValue4:3

      })
    }

  }


  calculateFinalPrice(selectedGuests, firstSelection, secondSelection, thirdSelection, fourthSelection) {
    this.setState({
      stCount: 0,
      stpCount: 0,
      suCount: 0,
      finalStPrice: 0,
      finalStpPrice: 0,
      finalSuPrice: 0,
      finalStPrice5: 0,
      finalStpPrice5: 0,
      finalSuPrice5: 0,
      finalStPrice7: 0,
      finalStpPrice7: 0,
      finalSuPrice7: 0,
      finalStPrice15: 0,
      finalStpPrice15: 0,
      finalSuPrice15: 0,
      totalPrice: 0,
      totalPrice5: 0,
      totalPrice7: 0,
      totalPrice15: 0,
      discount: 0,
      discount5: 0,
      discount7: 0,
      discount8: 0,
      discount15: 0,
      loyaltyDiscount:0,
      currentSelected: 0,
      totalStudioGuests:0,
      totalStudioPlusGuests:0,
      totalSuiteGuests:0,
    });
    let stCounter = 0;
    let stpCounter = 0;
    let suCounter = 0;
    let studioGuests = 0;
    let studioPlusGuests = 0;
    let suiteGuests = 0;



    if (firstSelection[0]) {
      stCounter++;
      studioGuests+= this.state.selectedGuests_1.value

    }
    if (firstSelection[1]) {
      stpCounter++;
      studioPlusGuests+= this.state.selectedGuests_1.value

    }

    if (firstSelection[2]) {
      suCounter++;
      suiteGuests += this.state.selectedGuests_1.value

    }

    if (secondSelection[0]) {
      stCounter++;
      studioGuests += this.state.selectedGuests_2.value

    }
    if (secondSelection[1]) {
      stpCounter++;
      studioPlusGuests += this.state.selectedGuests_2.value

    }

    if (secondSelection[2]) {
      suCounter++;
      suiteGuests += this.state.selectedGuests_2.value

    }

    if (thirdSelection[0]) {
      stCounter++;
      studioGuests += this.state.selectedGuests_3.value

    }
    if (thirdSelection[1]) {
      stpCounter++;
      studioPlusGuests += this.state.selectedGuests_3.value

    }

    if (thirdSelection[2]) {
      suCounter++;
      suiteGuests += this.state.selectedGuests_3.value

    }

    if (fourthSelection[0]) {
      stCounter++;
      studioGuests += this.state.selectedGuests_4.value

    }
    if (fourthSelection[1]) {
      stpCounter++;
      studioPlusGuests += this.state.selectedGuests_4.value

    }

    if (fourthSelection[2]) {
      suCounter++;
      suiteGuests += this.state.selectedGuests_4.value

    }


    let totalPrice;
    let totalPrice5;
    let totalPrice7;
    let totalPrice15;
    let finalStPrice;
    let finalStpPrice;
    let finalSuPrice;
    let finalStPrice5;
    let finalStpPrice5;
    let finalSuPrice5;
    let finalStPrice7;
    let finalStpPrice7;
    let finalSuPrice7;
    let finalStPrice15;
    let finalStpPrice15;
    let finalSuPrice15;
    let discount5;
    let discount7;
    let discount15;
    let discount8;
    let discount;

    let currentSelected;
    currentSelected = suCounter + stpCounter + stCounter;
    let nights = this.state.nights;
    let guests = selectedGuests;
    let guestFee = 0;
    let studioGuestFee = 0;
    let studioPlusGuestFee = 0;
    let suiteGuestFee = 0;

    if (guests > 1) {
      guestFee = 6 * (guests - 1) * nights;


    }

    if(studioGuests > 1){
      studioGuestFee = (studioGuests-1) * 6 * nights

    }
    if(studioPlusGuests > 1){
      studioPlusGuestFee = (studioPlusGuests-1) * 6 * nights

    }

    if(suiteGuests > 1){
      suiteGuestFee = (suiteGuests-1) * 6 * nights

    }

    finalStPrice = (this.state.stRate * stCounter)+studioGuestFee
    finalStpPrice = (this.state.stpRate * stpCounter)+studioPlusGuestFee
    finalSuPrice = (this.state.suRate * suCounter)+suiteGuestFee

    finalStPrice5 = (this.state.stRate5 * stCounter)+studioGuestFee
    finalStpPrice5 = (this.state.stpRate5 * stpCounter)+studioPlusGuestFee
    finalSuPrice5 = (this.state.suRate5 * suCounter)+suiteGuestFee

    finalStPrice7 = (this.state.stRate7 * stCounter)+studioGuestFee
    finalStpPrice7 = (this.state.stpRate7 * stpCounter)+studioPlusGuestFee
    finalSuPrice7 = (this.state.suRate7 * suCounter)+suiteGuestFee

    finalStPrice15 = (this.state.stRate15 * stCounter)+studioGuestFee
    finalStpPrice15 = (this.state.stpRate15 * stpCounter)+studioPlusGuestFee
    finalSuPrice15 = (this.state.suRate15 * suCounter)+suiteGuestFee


    let total = finalStPrice + finalStpPrice + finalSuPrice; // portale
    let total_5 = finalStPrice5 + finalStpPrice5 + finalSuPrice5;
    let total_7 = finalStPrice7 + finalStpPrice7 + finalSuPrice7;
    let total_15 = finalStPrice15 + finalStpPrice15 + finalSuPrice15;

    //specials

    let breakfast = (this.state.selectedBreakfastDays.value*this.state.selectedBreakfastGuests.value)*this.state.breakfastRate
    let laundry = this.state.selectedLaundryFillings.value*this.state.laundryRate
    let bikes = (this.state.selectedBikeDays.value*this.state.selectedBikeGuests.value)*this.state.bikeRate
    let spa = this.state.selectedSpaTours.value*this.state.spaRate
    let champagne = this.state.selectedChampagneBottles.value*this.state.champagneRate
   // let whiteWine = this.state.selectedWhiteWine*this.state.whiteWineRate
   // let redWine = this.state.selectedRedWine*this.state.redWineRate
    let specialsTotal = breakfast+laundry+bikes+spa+champagne

    //console.log(specialsTotal)
    totalPrice= total + specialsTotal ;
    totalPrice5 = total_5 + specialsTotal ;
    totalPrice7 = total_7+ specialsTotal  ;
    totalPrice15 = total_15 + specialsTotal;

    discount5 = totalPrice-totalPrice5;
    discount = totalPrice-totalPrice7;
    discount7 = totalPrice-totalPrice7;
    discount8 = totalPrice15-totalPrice7;
    discount15 = totalPrice-totalPrice15;
    let loyaltyDiscount = totalPrice15-totalPrice7;



    //console.log(discount7)
    //console.log(totalPrice7)
    //console.log(totalPrice5)


    this.setState({
      stCount: stCounter,
      stpCount: stpCounter,
      suCount: suCounter,
      finalStPrice: finalStPrice,
      finalStpPrice: finalStpPrice,
      finalSuPrice: finalSuPrice,
      finalStPrice5: finalStPrice5,
      finalStpPrice5: finalStpPrice5,
      finalSuPrice5: finalSuPrice5,
      finalStPrice7: finalStPrice7,
      finalStpPrice7: finalStpPrice7,
      finalSuPrice7: finalSuPrice7,
      finalStPrice15: finalStPrice7,
      finalStpPrice15: finalStpPrice7,
      finalSuPrice15: finalSuPrice7,
      totalPrice: totalPrice,
      totalPrice5: totalPrice5,
      totalPrice7: totalPrice7,
      totalPrice15: totalPrice15,
      discount: discount,
      discount5: discount5,
      discount7: discount7,
      discount8: discount8,
      discount15: discount15,
      loyaltyDiscount:loyaltyDiscount,
      currentSelected: currentSelected,
      totalStudioGuests:studioGuests,
      totalStudioPlusGuests:studioPlusGuests,
      totalSuiteGuests:suiteGuests,
    })
    if(this.state.payDuringStay){
      //console.log(totalPrice5)
      this.setState({
        amountToPay:totalPrice5
      })
    }
    if(this.state.payHalf){
    //  console.log(totalPrice7)


      this.setState({
        amountToPay: Number((totalPrice7/2).toFixed(2))
      })
    }
    if(this.state.payTotal){
    //  console.log(totalPrice15)

      this.setState({
        amountToPay:totalPrice15
      })
    }

//console.log(this.state.amountToPay)
  /*
    if(currentSelected === this.state.selectedRooms.value ){
      if( (this.state.selectedRooms.value===1 && this.state.firstBlockClosed===false) ||
        (this.state.selectedRooms.value===2 && (this.state.firstBlockClosed===false || this.state.secondBlockClosed===false)) ||

        (this.state.selectedRooms.value===3 &&
            (this.state.firstBlockClosed===false || this.state.secondBlockClosed===false || this.state.thirdBlockClosed===false)) ||

            (this.state.selectedRooms.value===4 &&
              (this.state.firstBlockClosed===false || this.state.secondBlockClosed===false || this.state.thirdBlockClosed===false
              || this.state.fourthBlockClosed===false)
            )



      ){
        this.setState({
          sheetOpen: false
        })
      }
      else {
        this.setState({
          sheetOpen: true
        })
      }
      */

  }


  handleGuestPerRoomSelection = (currentGpr, selBlockNumber) => {
    let selGuests = this.state.selectedGuests.value;
    let gpr_1 = this.state.gpr_1;
    let gpr_2 = this.state.gpr_2;
    let gpr_3 = this.state.gpr_3;
    let gpr_4 = this.state.gpr_4;
    if (selBlockNumber===1) gpr_1 = currentGpr;
    if (selBlockNumber===2) gpr_2 = currentGpr;
    if (selBlockNumber===3) gpr_3 = currentGpr;
    if (selBlockNumber===4) gpr_4 = currentGpr;

    let gprAll = gpr_1+gpr_2+gpr_3+gpr_4;
  //  let gprWithoutCurrent =  gprAll-currentGpr;



  };


  handleAnnotationsChange = (annotations) => {
//console.log(annotations.target.value)
    this.setState({notes: annotations.target.value});
  };

    //
  handleRoomSelection = (selectedRooms) => {

    //handle guest count

    if(selectedRooms.value===1){
      this.handleGuestSelection_1(this.state.selectedGuests_1)
    }
    if(selectedRooms.value===2){
      this.handleGuestSelection_2(this.state.selectedGuests_2)
    }
    if(selectedRooms.value===3){
      this.handleGuestSelection_3(this.state.selectedGuests_3)
    }
    if(selectedRooms.value===4){
      this.handleGuestSelection_4(this.state.selectedGuests_4)
    }



  //  getInventory();
if(selectedRooms)

        this.calculateFinalPrice(this.state.totalGuests, this.state.firstSelection, this.state.secondSelection, this.state.thirdSelection, this.state.fourthSelection)




    if (selectedRooms.value < this.state.selectedRooms.value) {
      this.setState({
        displayNoAvailable: 'block',
        totalPrice: 0,
        finalStPrice: 0,
        finalStpPrice: 0,
        discount: 0,
        stCount: 0,
        stpCount: 0,
        suCount: 0,
        firstSelection: [false, false, false],
        secondSelection: [false, false, false],
        thirdSelection: [false, false, false],
        fourthSelection: [false, false, false],
        currentSelected: 0,
        rotation_1: 180,
        rotation_2: 180,
        rotation_3: 180,
        rotation_4: 180,

        firstBlockClosed:false,
        secondBlockClosed:false,
        thirdBlockClosed:false,
        fourthBlockClosed:false,

        firstCheck:false,
        secondCheck:false,
        thirdCheck:false,
        fourthCheck:false


      })
    }

    this.setState({selectedRooms: selectedRooms});
    if (selectedRooms.value > this.state.allAvailable && this.state.startDate != undefined && this.state.endDate != undefined) {

      this.setState({
        displayNoAvailable: 'block',
        totalPrice: 0,
        finalStPrice: 0,
        finalStpPrice: 0,
        finalSuPrice: 0,
        firstSelection: [false, false, false],
        secondSelection: [false, false, false],
        thirdSelection: [false, false, false],
        fourthSelection: [false, false, false]


      })


    }
    else {
      this.setState({
        displayNoAvailable: 'none',


      })
    }
    if(this.state.startDate!=null && this.state.endDate!=null){
      this.setState({
        sheetOpen: false,


      })
    }
  };

  handleGuestSelection = (selectedGuests) => {
    if((selectedGuests.value>this.state.selectedGuests.value) && (selectedGuests.value>2)){
      this.setState({
        firstSelection: [false, false, false],
        secondSelection: [false, false, false],
        thirdSelection: [false, false, false],
        fourthSelection: [false, false, false],
        rotation_1: 180,
        rotation_2: 180,
        rotation_3: 180,
        rotation_4: 180,

        firstBlockClosed:false,
        secondBlockClosed:false,
        thirdBlockClosed:false,
        fourthBlockClosed:false,

        firstCheck:false,
        secondCheck:false,
        thirdCheck:false,
        fourthCheck:false,

        gpr_1:0,
        gpr_2:0,
        gpr_3:0,
        gpr_4:0,

        }
      )
    }
    this.setState({selectedGuests: selectedGuests});

    this.calculateFinalPrice(this.state.totalGuests, this.state.firstSelection, this.state.secondSelection, this.state.thirdSelection, this.state.fourthSelection)

    if(this.state.startDate!=null && this.state.endDate!=null && (this.state.currentSelected < this.state.selectedRooms.value)){
      this.setState({
        sheetOpen: false


      })
    }

   // let selRooms= this.state.selectedRooms.value;





  };


  handleGPRSelection_1 = (gpr_1) => {
    this.setState({gpr_1: gpr_1});

  };
  handleGPRSelection_2 = (gpr_2) => {
    this.setState({gpr_2: gpr_2});

  };
  handleGPRSelection_3 = (gpr_3) => {
    this.setState({gpr_3: gpr_3});

  };
  handleGPRSelection_4 = (gpr_4) => {
    this.setState({gpr_4: gpr_4});

  };

  handleBedSelection_1 = (selectedBeds) => {
    this.setState({selectedBeds_1: selectedBeds});

  };
  handleBedSelection_2 = (selectedBeds) => {
    this.setState({selectedBeds_2: selectedBeds});

  };

  handleBedSelection_3 = (selectedBeds) => {
    this.setState({selectedBeds_3: selectedBeds});

  };

  handleBedSelection_4 = (selectedBeds) => {
    this.setState({selectedBeds_4: selectedBeds});

  };

  // unused function, todo: delete after dependencies deleted!!
  toggleBreakfast(){

  }



  handleBreakfastSelection(days, guests){
    let p = 15;
    let m = guests*days;
    if(m!=0) {
      this.setState({
        breakfastPrice: p*m,
        breakfastSelected:true,
        selectedBreakfast:m

      });
    }
    else{
      this.setState({
        breakfastPrice: 0,
        breakfastSelected:false,
        selectedBreakfast:0
      });
    }

  }



  handleBikeSelection(days, guests){
    let p = 12;
    let m = guests*days;
    if(m!=0) {
      this.setState({
        bikePrice: p*m,
        bikesSelected:true,
        selectedBikes:m
      });
    }
    else{
      this.setState({
        bikePrice: 0,
        bikesSelected:false,
selectedBikes:0
      });
    }

  }

  handleLaundrySelection(fillings){
    let p = 15;
    let m = fillings*p;
    if(m!=0) {
      this.setState({
        laundryPrice: m,
        laundrySelected:true,
        selectedLaundry:fillings
      });
    }
    else{
      this.setState({
        laundryPrice: 0,
        laundrySelected:false,
        selectedLaundry:0
      });
    }

  }

  handleChampagneSelection(bottles){
    let p = 40;
    let m = bottles*p;
    if(m!=0) {
      this.setState({
        champagnePrice: m,
       champagneSelected:true

      });
    }
    else{
      this.setState({
        champagnePrice: 0,
        champagneSelected:false

      });
    }

  }




  setSelectedBreakfastGuests  = (selectedGuests) => {

    this.setState({
      selectedBreakfastGuests: selectedGuests

    });
this.handleBreakfastSelection(this.state.selectedBreakfastDays.value, selectedGuests.value)
  };

  setSelectedBreakfastDays = (selectedDays) => {

    this.setState({
      selectedBreakfastDays: selectedDays

    });
    this.handleBreakfastSelection(selectedDays.value,this.state.selectedBreakfastGuests.value)

  };


  setSelectedBikeGuests  = (selectedGuests) => {

    this.setState({
      selectedBikeGuests: selectedGuests

    });
    this.handleBikeSelection(this.state.selectedBikeDays.value, selectedGuests.value)
  };

  setSelectedBikeDays = (selectedDays) => {

    this.setState({
      selectedBikeDays: selectedDays

    });
    this.handleBikeSelection(selectedDays.value,this.state.selectedBikeGuests.value)

  };

  setSelectedLaundryFillings = (selectedFillings) => {

    this.setState({
      selectedLaundryFillings: selectedFillings

    });
    this.handleLaundrySelection(selectedFillings.value)

  };


  setSelectedChampagneBottles = (selectedBottles) => {

    this.setState({
      selectedChampagneBottles: selectedBottles

    });
    this.handleChampagneSelection(selectedBottles.value)

  };

  getDatoCmsImages(id, queryData){
    for(let i=0;i< queryData.allResidences.edges;i++){
      if(queryData.allResidences.edges.node[i].id === id){
        return queryData.allResidences.edges.node[i].images
      }
      else {

        return "No images found"
      }
    }
  }

  setStepOne(){

    this.setState({
      current:0,
      stepOneStatus: 'process',
      stepTwoStatus: 'wait',
      stepOneSubTitle: 'Step 1',
    })


  }

  setStepTwo(){

    this.setState({
      sheetOpen:false,
      current:1,
      stepOneStatus:'finish',
      stepTwoStatus:'process',
      stepOneSubTitle:<StyledSmallCheck/>
    })
    scroll.scrollToTop();


  }

  renderMonthElement = ({ month, onMonthSelect, onYearSelect }) =>
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <div>
        <select
          value={month.month()}
          onChange={(e) => onMonthSelect(month, e.target.value)}
        >
          {moment.months().map((label, value) => (
            <option value={value}>{label}</option>
          ))}
        </select>
      </div>
      <div>
        <select value={month.year()} onChange={(e) => onYearSelect(month, e.target.value)}>
          <option value={moment().year()}>{moment().year()}</option>
          <option value={moment().add(1,'y').year()}>{moment().add(1,'y').year()}</option>
        </select>
      </div>
    </div>


    render() {
    // console.log("Suite_Blocker: " + suite_blocker["0"][1]);
      if(this.props.locale==='de') {
        moment1.locale('de', deLocale)
      }

      return (
      <Outer ref='stick-end' id={'sticky-end'}>
        <Element name="test1" className="element">
        </Element>

        <StyledSticky innerZ={99} enabled={true} top={150} bottomBoundary='#sticky-end'>


          <Inner>
            <div style={{display: (this.state.stepTwoStatus==='process') ? 'block':'none'}}>
              <BackButton onClick={this.setStepOne.bind(this)}> <FiEdit style={{marginRight:'7px'}}/><FormattedMessage id="btn_edit" /></BackButton>
              <FlexDivTwo>
                <CheckinDiv>
                  <CheckinSpan>Check-In

                  </CheckinSpan>
                  <DateDiv> {this.getFormattedDate(this.state.startDate)}
                    <svg className="DateRangePickerInput_arrow_svg DateRangePickerInput_arrow_svg_1" focusable="false"
                         viewBox="0 0 1000 1000">
                      <path
                        d="M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z"/>
                    </svg>

                  </DateDiv>



                </CheckinDiv>
                <CheckinDiv>
                  <Span>Check-Out</Span>
                  <DateDiv>{this.getFormattedDate(this.state.endDate)}</DateDiv>
                </CheckinDiv>
              </FlexDivTwo>


              <InnerBottom>
                <GuestNightDiv>
                  <SelectedGuests guests={this.state.totalGuests}/>
                  <SelectedNights nights={this.state.nights}/>
                </GuestNightDiv>
                <ConditionalStPricing
                  stSelected={this.state.stCount}
                  finalStudioPrice={this.state.finalStPrice}
                  finalStudioPrice5={this.state.finalStPrice5}
                  finalStudioPrice7={this.state.finalStPrice7}
                  finalStudioPrice15={this.state.finalStPrice15}

                  payTotal={this.state.payTotal}
                  payHalf={this.state.payHalf}
                  payDuringStay={this.state.payDuringStay}
                />
                <ConditionalStpPricing stpSelected={this.state.stpCount}
                                       finalStudioPlusPrice={this.state.finalStpPrice}
                                       finalStudioPlusPrice5={this.state.finalStpPrice5}
                                       finalStudioPlusPrice7={this.state.finalStpPrice7}
                                       finalStudioPlusPrice15={this.state.finalStpPrice15}

                                       payTotal={this.state.payTotal}
                                       payHalf={this.state.payHalf}
                                       payDuringStay={this.state.payDuringStay}
                />
                <ConditionalSuPricing

                  payTotal={this.state.payTotal}
                  payHalf={this.state.payHalf}
                  payDuringStay={this.state.payDuringStay}
                  suSelected={this.state.suCount}
                  finalSuitePrice={this.state.finalSuPrice}
                  finalSuitePrice5={this.state.finalSuPrice5}
                  finalSuitePrice7={this.state.finalSuPrice7}
                  finalSuitePrice15={this.state.finalSuPrice15}
                />
                <SpecialsPricingBlock>

                  <ConditionalBreakfast breakfastSelected={this.state.breakfastSelected}
                                        selectedBreakfastGuests={this.state.selectedBreakfastGuests} selectedBreakfastDays={this.state.selectedBreakfastDays}/>
                  <ConditionalBikes bikesSelected={this.state.bikesSelected}
                                    selectedBikeGuests={this.state.selectedBikeGuests} selectedBikeDays={this.state.selectedBikeDays}/>

                  <ConditionalLaundry laundrySelected={this.state.laundrySelected}
                                      selectedLaundryFillings={this.state.selectedLaundryFillings} />
                  <ConditionalChampagne champagneSelected={this.state.champagneSelected}
                                        selectedChampagneBottles={this.state.selectedChampagneBottles} />
                </SpecialsPricingBlock>
                <ConditionalDiscount
                  allSelected={this.state.currentSelected}
                  payHalf={this.state.payHalf} payDuringStay={this.state.payDuringStay} payTotal={this.state.payTotal} discount={this.state.discount}
                                     finalPrice={this.state.totalPrice}
                                     finalPrice5={this.state.totalPrice5}
                                     finalPrice7={this.state.totalPrice7}
                                     finalPrice15={this.state.totalPrice15}
                                     discount5={this.state.discount5}
                                     discount7={this.state.discount7}
                                     discount8={this.state.discount8}
                                     discount15={this.state.discount15}

                />

                <ConditionalLoyaltyDiscount allSelected={this.state.currentSelected} payHalf={this.state.payHalf} payDuringStay={this.state.payDuringStay} payTotal={this.state.payTotal} loyaltyDiscount={this.state.loyaltyDiscount}
                                            totalPrice={this.state.totalPrice}
                                            totalPrice5={this.state.totalPrice5}
                                            totalPrice7={this.state.totalPrice7}
                                            totalPrice15={this.state.totalPrice15}
                                            discount5={this.state.discount5}
                                            discount7={this.state.discount7}
                                            discount8={this.state.discount8}
                                            discount15={this.state.discount15}
                />
                <ConditionalFreeBreakfast nights={this.state.nights}/>
                <ConditionalTotalPricing
                  allSelected={this.state.currentSelected}
                  payTotal={this.state.payTotal}
                  payHalf={this.state.payHalf}
                  payDuringStay={this.state.payDuringStay}
                  nights={this.state.nights}
                  totalPrice={this.state.totalPrice}
                  totalPrice5={this.state.totalPrice5}
                  totalPrice7={this.state.totalPrice7}
                  totalPrice15={this.state.totalPrice15}
                  discount5={this.state.discount5}
                  discount7={this.state.discount7}
                  discount8={this.state.discount8}
                  discount15={this.state.discount15}
                  loyaltyDiscount={this.state.loyaltyDiscount}

                />

              </InnerBottom>

              <ConditionalPayButton guestEmail={this.state.guestEmail} guestFirstName={this.state.guestFirstName} guestLastName={this.state.guestLastName}
                                     guestZipCode={this.state.guestZipCode}
                                     refresh={this.state.refresh} email={this.state.emailVerified} paypal={this.state.paypal}
                                     paySepa={this.state.paySepa} payCreditCard={this.state.payCreditCard}
                                     payKlarna={this.state.payKlarna} payGiropay={this.state.payGiropay}
                                     payBankTransfer={this.state.payBankTransfer}
                                     payDuringStay={this.state.payDuringStay} openModal={this.openPaymentModal} avail={this.state.allAvailable} stDate={this.state.startDate}
                                     eDate={this.state.endDate} selRooms={this.state.selectedRooms.value}
                                     currSelected={this.state.currentSelected}
                                     finalPrice={this.state.totalPrice}
                                    />
              <NoChargeNote style={{display: this.state.payDuringStay ? 'block' :'none'}}><Pa><FormattedMessage id="booking_fixed_box_17" /> </Pa></NoChargeNote>


            </div>

            <div style={{display: (this.state.stepOneStatus==='process') ? 'block':'none'}}>
            <Checkin>Check-In</Checkin>
            <Span>Check-Out</Span>

            <StyledWrapper>
              <DateRangePicker
                startDatePlaceholderText="TT.MM.JJJJ"
                endDatePlaceholderText="TT.MM.JJJJ"
                showClearDates={true}
                reopenPickerOnClearDates={true}
                numberOfMonths={1}
                displayFormat="DD.MM.YYYY"
                startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                startDateId="start_date" // PropTypes.string.isRequired,
                endDate={this.state.endDate} //   momentPropTypes.momentObj or null,
                endDateId="end_date" // PropTypes.string.isRequired,
                onDatesChange={({startDate, endDate}) => this.checkAvailability(startDate, endDate)} // PropTypes.func.isRequired,
                focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                onFocusChange={focusedInput => this.setState({focusedInput})} // PropTypes.func.isRequired,
                // isDayBlocked= {this.isOutsideRange}
                //orientation={'vertical'}
                renderMonthElement={this.renderMonthElement}
              >
              </DateRangePicker>
            </StyledWrapper>
            <SelectDiv>
              <RoomGuestDiv>
                <Span><FormattedMessage id="booking_fixed_box_1" /></Span>
                <StyledRoomSelect>
                <Select
                  type={'number'} styles={customRoomStyles} components={{ DropdownIndicator }}  onChange={this.handleRoomSelection}
                                  value={this.state.selectedRooms}
                                  clearable={false} options={roomOptions}/>
                </StyledRoomSelect>
              </RoomGuestDiv>

            </SelectDiv>
            <StyledSpinner style={{display:(this.state.showSpinner && this.state.startDate!=null && this.state.endDate!=null) ? 'flex':'none'}}>
              <Loader
                type="Triangle"
                color="rgb(68,68,68)"
                height={55}
                width={55}
                // timeout={30000} //3 secs

              />
            </StyledSpinner >
            <InnerBottom style={{display:(this.state.showSpinner) ? 'none':'block'}}>
              <GuestNightDiv style={{display: (this.state.displayNoAvailable==='none' && this.state.startDate!=null && this.state.endDate!=null) ? 'flex' : 'none'}}>
                <SelectedGuests guests={this.state.totalGuests}/>
                <SelectedNights nights={this.state.nights}/>
              </GuestNightDiv>
              <ConditionalStPricing

                payTotal={this.state.payTotal}
                payHalf={this.state.payHalf}
                payDuringStay={this.state.payDuringStay}
                                    stSelected={this.state.stCount}
                                     finalStudioPrice={this.state.finalStPrice}
                                     finalStudioPrice5={this.state.finalStPrice5}
                                     finalStudioPrice7={this.state.finalStPrice7}
                                     finalStudioPrice15={this.state.finalStPrice15}
              />
              <ConditionalStpPricing

                payTotal={this.state.payTotal}
                payHalf={this.state.payHalf}
                payDuringStay={this.state.payDuringStay}
                stpSelected={this.state.stpCount}
                                     finalStudioPlusPrice={this.state.finalStpPrice}
                                     finalStudioPlusPrice5={this.state.finalStpPrice5}
                                     finalStudioPlusPrice7={this.state.finalStpPrice7}
                                     finalStudioPlusPrice15={this.state.finalStpPrice15}
              />
              <ConditionalSuPricing
                payTotal={this.state.payTotal}
                payHalf={this.state.payHalf}
                payDuringStay={this.state.payDuringStay}
                suSelected={this.state.suCount}
                finalSuitePrice={this.state.finalSuPrice}
                finalSuitePrice5={this.state.finalSuPrice5}
                finalSuitePrice7={this.state.finalSuPrice7}
                finalSuitePrice15={this.state.finalSuPrice15}
              />
              <SpecialsPricingBlock>

              <ConditionalBreakfast breakfastSelected={this.state.breakfastSelected}
                                    selectedBreakfastGuests={this.state.selectedBreakfastGuests} selectedBreakfastDays={this.state.selectedBreakfastDays}/>
              <ConditionalBikes bikesSelected={this.state.bikesSelected}
                                    selectedBikeGuests={this.state.selectedBikeGuests} selectedBikeDays={this.state.selectedBikeDays}/>

              <ConditionalLaundry laundrySelected={this.state.laundrySelected}
                                  selectedLaundryFillings={this.state.selectedLaundryFillings} />
              <ConditionalChampagne champagneSelected={this.state.champagneSelected}
                                  selectedChampagneBottles={this.state.selectedChampagneBottles} />
              </SpecialsPricingBlock>
              <ConditionalDiscount
                allSelected={this.state.currentSelected}
                payTotal={this.state.payTotal}
                payHalf={this.state.payHalf}
                payDuringStay={this.state.payDuringStay}
                discount={this.state.discount}
                discount5={this.state.discount5}
                discount7={this.state.discount7}
                discount8={this.state.discount8}
                discount15={this.state.discount15}
                totalPrice={this.state.totalPrice}
                totalPrice5={this.state.totalPrice5}
                totalPrice7={this.state.totalPrice7}
                totalPrice15={this.state.totalPrice15}
              />
              <ConditionalLoyaltyDiscount
                allSelected={this.state.currentSelected}
                payHalf={this.state.payHalf} payDuringStay={this.state.payDuringStay} payTotal={this.state.payTotal} loyaltyDiscount={this.state.loyaltyDiscount}
                                          totalPrice={this.state.totalPrice}
                                          totalPrice5={this.state.totalPrice5}
                                          totalPrice7={this.state.totalPrice7}
                                          totalPrice15={this.state.totalPrice15}
                                          discount5={this.state.discount5}
                                          discount7={this.state.discount7}
                                          discount8={this.state.discount8}
                                          discount15={this.state.discount15}
              />
              <ConditionalFreeBreakfast nights={this.state.nights}/>

              <ConditionalTotalPricing          payTotal={this.state.payTotal}
                                                payHalf={this.state.payHalf}
                                                payDuringStay={this.state.payDuringStay}
                                                allSelected={this.state.currentSelected}
                                                nights={this.state.nights}
                                                totalPrice={this.state.totalPrice}
                                                totalPrice5={this.state.totalPrice5}
                                                totalPrice7={this.state.totalPrice7}
                                                totalPrice15={this.state.totalPrice15}
                                                discount5={this.state.discount5}
                                                discount7={this.state.discount7}
                                                discount8={this.state.discount8}
                                                discount15={this.state.discount15}
                                                loyaltyDiscount={this.state.loyaltyDiscount}

              />
            </InnerBottom>

            <ConditionalNextButton  showSpinner={this.state.showSpinner} openModal={this.openModal} avail={this.state.allAvailable} stDate={this.state.startDate}
                                   eDate={this.state.endDate} selRooms={this.state.selectedRooms.value}
                                   currSelected={this.state.currentSelected}
                                   finalPrice={this.state.totalPrice}/>

</div>
          </Inner>
        </StyledSticky>
        <Div>

          <Steps style={containerStyle} type="navigation" current={this.state.current} >
            <Step
              title={<FormattedMessage id="booking_text_1" />}
              status={this.state.stepOneStatus}
              subTitle={(this.state.stepOneSubTitle==="Step 1")?<FormattedMessage id="booking_text_2" />:""}
              description={<FormattedMessage id="booking_text_3" />}
            />
            <Step
              title={<FormattedMessage id="booking_text_4" />}
              status={this.state.stepTwoStatus}
              subTitle={<FormattedMessage id="booking_text_5" />}
              description={<FormattedMessage id="booking_text_6" />}
            />
          </Steps>
          <StyledSpinner style={{display:(this.state.showSpinner && this.state.startDate!=null && this.state.endDate!=null) ? 'flex':'none'}}>
            <Loader
              type="Triangle"
              color="rgb(68,68,68)"
              height={55}
              width={55}
              // timeout={30000} //3 secs

            />
          </StyledSpinner >

          <div style={{display:(!this.state.showSpinner) ? 'block':'none'}}>

            <br/>

          <AttentionDiv style={{display: this.state.displayNoAvailable}}>      <EmailIconDiv> <StyledAttention/></EmailIconDiv>
            <AttetionP> <FormattedMessage id={'no_available_1'}/> <br/> <FormattedMessage id={'no_available_2'}/> <br/> Email:  <a href={"mailto:info@vilhelm7.de"}>info@vilhelm7.de</a>  <br/> </AttetionP></AttentionDiv>
          <div style={{display: this.state.displayPleaseSelect}}>
            <BookingTextDiv sheetOpen={this.state.sheetOpen} openBottom={this.openBottom.bind(this)}> </BookingTextDiv>
          </div>
            <div style={{display: (this.state.stepTwoStatus==='process') ? 'none':'block'}}>

              <Element name="container" className="selectContainer" id="selectContainer">
                <Element name="selectBlock_1"></Element>
                {
                  this.state.displayPleaseSelect==='none' &&
                  <EditBookingDetails style={{opacity:this.state.sheetOpen?0:1}} onClick={()=>this.openBottomSheet(true)}>
                  <EditButton2 > <FiEdit/></EditButton2>
                  <FormattedMessage id="booking_text_000" />
                </EditBookingDetails>}
<br/>
              <SelectBlock_1
                stPrice={this.state.stRate7} stpPrice={this.state.stpRate7} suPrice={this.state.suRate7} nights={this.state.nights}
                selectText={this.state.selectText_1} bedOptions={this.state.bedOptions_1} selectedBeds={this.state.selectedBeds_1}
                         handleBedSelection={this.handleBedSelection_1.bind(this)}
            handleGuestSelection={this.handleGuestSelection_1.bind(this)} guestOptions={this.state.guestOptions_1} gpr={this.state.gpr_1} handleGprOptions={this.handleGPRSelection_1.bind(this)} changeGuests={this.changeGuestPerRoom1.bind(this)} maxGuestValue={this.state.maxValue1}
                         guestsPerRoom={this.state.guestsPerRoom1} checkVisible={this.state.firstCheck} blockClosed={this.state.firstBlockClosed} rotation={this.state.rotation_1} toggleSelect={this.toggleSelect_1.bind(this)} stCount={this.state.stCount}
                         currSelected={this.state.currentSelected} selectedGuests={this.state.selectedGuests_1} firstSelection={this.state.firstSelection} secondSelection={this.state.secondSelection} thirdSelection={this.state.thirdSelection}
                         fourthSelection={this.state.fourthSelection}
                         handleCatState={this.setCategoryState.bind(this)}
                         availableSuites={this.state.suite} availableStudios={this.state.studio}
                         availableStudioPlus={this.state.studioPlus} availableRooms={this.state.allAvailable}
                         roomsSelected={this.state.selectedRooms}  >
          </SelectBlock_1>
                <Element name="selectBlock_2"></Element>

                <SelectBlock_2

                  stPrice={this.state.stRate7} stpPrice={this.state.stpRate7} suPrice={this.state.suRate7} nights={this.state.nights}            selectText={this.state.selectText_1} bedOptions={this.state.bedOptions_2} selectedBeds={this.state.selectedBeds_2}
            handleBedSelection={this.handleBedSelection_2.bind(this)}
            handleGuestSelection={this.handleGuestSelection_2.bind(this)} guestOptions={this.state.guestOptions_2}
            gpr={this.state.gpr_2} handleGprOptions={this.handleGPRSelection_2.bind(this)}
            changeGuests={this.changeGuestPerRoom2.bind(this)} maxGuestValue={this.state.maxValue2}
            guestsPerRoom={this.state.guestsPerRoom2} checkVisible={this.state.secondCheck}
            blockClosed={this.state.secondBlockClosed} rotation={this.state.rotation_2}
            toggleSelect={this.toggleSelect_2.bind(this)} stCount={this.state.stCount}
            currSelected={this.state.currentSelected} selectedGuests={this.state.selectedGuests_2}
            firstSelection={this.state.firstSelection} secondSelection={this.state.secondSelection}
            thirdSelection={this.state.thirdSelection}
                         fourthSelection={this.state.fourthSelection} handleCatState={this.setCategoryState.bind(this)}
                         availableSuites={this.state.suite} availableStudios={this.state.studio}
                         availableStudioPlus={this.state.studioPlus} availableRooms={this.state.allAvailable}
                         roomsSelected={this.state.selectedRooms}>
          </SelectBlock_2>
                <Element name="selectBlock_3"></Element>

                <SelectBlock_3

                  stPrice={this.state.stRate7} stpPrice={this.state.stpRate7} suPrice={this.state.suRate7} nights={this.state.nights}            selectText={this.state.selectText_1} bedOptions={this.state.bedOptions_3} selectedBeds={this.state.selectedBeds_3}
            handleBedSelection={this.handleBedSelection_3.bind(this)}
            handleGuestSelection={this.handleGuestSelection_3.bind(this)} guestOptions={this.state.guestOptions_3}
            gpr={this.state.gpr_3} handleGprOptions={this.handleGPRSelection_3.bind(this)}
            changeGuests={this.changeGuestPerRoom3.bind(this)} maxGuestValue={this.state.maxValue3}
            guestsPerRoom={this.state.guestsPerRoom3} checkVisible={this.state.thirdCheck}
            blockClosed={this.state.thirdBlockClosed} rotation={this.state.rotation_3}
            toggleSelect={this.toggleSelect_3.bind(this)} stCount={this.state.stCount}
            currSelected={this.state.currentSelected} selectedGuests={this.state.selectedGuests_3}
            firstSelection={this.state.firstSelection} secondSelection={this.state.secondSelection}
            thirdSelection={this.state.thirdSelection}
                         fourthSelection={this.state.fourthSelection} handleCatState={this.setCategoryState.bind(this)}
                         availableSuites={this.state.suite} availableStudios={this.state.studio}
                         availableStudioPlus={this.state.studioPlus} availableRooms={this.state.allAvailable}
                         roomsSelected={this.state.selectedRooms}>
          </SelectBlock_3>
                <Element name="selectBlock_4"></Element>

                <SelectBlock_4

                  stPrice={this.state.stRate7} stpPrice={this.state.stpRate7} suPrice={this.state.suRate7} nights={this.state.nights}            selectText={this.state.selectText_1} bedOptions={this.state.bedOptions_4} selectedBeds={this.state.selectedBeds_4}
            handleBedSelection={this.handleBedSelection_4.bind(this)}
            handleGuestSelection={this.handleGuestSelection_4.bind(this)} guestOptions={this.state.guestOptions_4}
            gpr={this.state.gpr_4} handleGprOptions={this.handleGPRSelection_4.bind(this)}
            changeGuests={this.changeGuestPerRoom4.bind(this)} maxGuestValue={this.state.maxValue4}
            guestsPerRoom={this.state.guestsPerRoom4} checkVisible={this.state.fourthCheck}
            blockClosed={this.state.fourthBlockClosed} rotation={this.state.rotation_4}
            toggleSelect={this.toggleSelect_4.bind(this)} stCount={this.state.stCount}
            currSelected={this.state.currentSelected} selectedGuests={this.state.selectedGuests_4} firstSelection={this.state.firstSelection} secondSelection={this.state.secondSelection} thirdSelection={this.state.thirdSelection}
                         fourthSelection={this.state.fourthSelection} handleCatState={this.setCategoryState.bind(this)}
                         availableSuites={this.state.suite} availableStudios={this.state.studio}
                         availableStudioPlus={this.state.studioPlus} availableRooms={this.state.allAvailable}
                         roomsSelected={this.state.selectedRooms}>
          </SelectBlock_4>
              </Element>
<br/>
              <br/>
          <div style={{display: 'block'}}>
            <SpnDiv>
              <Spn><FormattedMessage id="specials_text_0" /></Spn>
            </SpnDiv>
            <Amneties>
              <HighBox><FormattedMessage id={'info_text_13'}/></HighBox>
              <HighBox><FormattedMessage id={'info_text_14'}/></HighBox>
              <HighBox><FormattedMessage id={'info_text_27'}/></HighBox>
              <HighBox><FormattedMessage id={'info_text_15'}/></HighBox>
              <HighBox><FormattedMessage id={'info_text_16'}/></HighBox>
              <HighBox><FormattedMessage id={'info_text_17'}/></HighBox>
              <HighBox><FormattedMessage id={'info_text_18'}/></HighBox>
              <HighBox><FormattedMessage id={'info_text_19'}/></HighBox>
              <HighBox><FormattedMessage id={'info_text_20'}/></HighBox>
              <HighBox><FormattedMessage id={'info_text_21'}/></HighBox>
              <HighBox><FormattedMessage id={'info_text_22'}/></HighBox>
              <HighBox><FormattedMessage id={'info_text_23'}/></HighBox>
              <HighBox><FormattedMessage id={'info_text_24'}/></HighBox>
              <HighBox><FormattedMessage id={'info_text_25'}/></HighBox>
              <HighBox><FormattedMessage id={'info_text_26'}/></HighBox>
              <HighBox>TV</HighBox>
              <HighBox><FormattedMessage id={'info_text_3'}/></HighBox>

              <HighBox><FormattedMessage id={'info_text_4'}/></HighBox>
              <HighBox>SHUTTLE SERVICE</HighBox>
              <HighBox>LATE CHECK-IN</HighBox>
            <br/>
              <HighBox><FormattedMessage id={'info_text_1'}/></HighBox>
            </Amneties>

            <StyledExtrasP><FormattedMessage id="booking_fixed_box_12" /></StyledExtrasP>
            <AddBreakfast guestOptions={this.state.specialsGuestOptions} daysOptions={this.state.specialsDaysOptions} guestValue={this.state.selectedBreakfastGuests} daysValue={this.state.selectedBreakfastDays} setBreakfastDays={this.setSelectedBreakfastDays.bind(this)}  isSelected={this.state.breakfastSelected} setBreakfastGuests={this.setSelectedBreakfastGuests.bind(this)}/>
            <AddChampagne  champagneOptions={this.state.specialsDaysOptions} champagneValue={this.state.selectedChampagneBottles} isSelected={this.state.champagneSelected} setChampagneBottles={this.setSelectedChampagneBottles.bind(this)}/>
            <AddBikes  guestOptions={this.state.specialsGuestOptions} daysOptions={this.state.specialsDaysOptions} guestValue={this.state.selectedBikeGuests} daysValue={this.state.selectedBikeDays} setBikeDays={this.setSelectedBikeDays.bind(this)}  isSelected={this.state.bikesSelected} setBikeGuests={this.setSelectedBikeGuests.bind(this)}/>
              <AddLaundry laundryOptions={this.state.specialsDaysOptions} laundryValue={this.state.selectedLaundryFillings} isSelected={this.state.laundrySelected} setLaundryFillings={this.setSelectedLaundryFillings.bind(this)}/>
            <StyledExtrasP><FormattedMessage id="booking_text_16" /></StyledExtrasP>
            <br/>
            <div>
              <StyledTextarea value={this.state.notes} onChange={this.handleAnnotationsChange}  useCacheForDOMMeasurements={true} minRows={5} maxRows={10} />
            </div>


            <Div360 style={{textAlign:'center'}}>

              <div style={{ width:'100%', textAlign: 'center',display: (this.state.current===0)?'block':'none'}}>
                <ConditionalNextButton2  showSpinner={this.state.showSpinner} openModal={this.openModal} avail={this.state.allAvailable} stDate={this.state.startDate}
                                        eDate={this.state.endDate} selRooms={this.state.selectedRooms.value}
                                        currSelected={this.state.currentSelected}
                                        finalPrice={this.state.totalPrice}/>
              </div>
            </Div360>

          </div>
          </div>
            <div style={{display: (this.state.stepTwoStatus==='none') ? 'none':'none'}}>
              <form>
                <Flex>
                  <FlexGuestDiv>
                    <Input style={{borderRadius:'0rem', height:'40px'}} label={<FormattedMessage id="payment_text_0" />} onChange={this.handleGuestEmailChange}  value={this.state.guestEmail} name="email" type="email" required />

                  </FlexGuestDiv>
                  <RightFlexDiv>
                    <Input style={{borderRadius:'0rem', height:'40px'}} label={<FormattedMessage id="payment_text_0_1" />} onChange={this.handleGuestCompanyChange}  value={this.state.guestCompany} name="company" type="text"  />

                  </RightFlexDiv>

                </Flex>

              <Flex>
                <FlexGuestDiv>
                  <Input style={{borderRadius:'0rem', height:'40px'}} label={<FormattedMessage id="payment_text_1" />} onChange={this.handleFirstNameChange}  value={this.state.guestFirstName} name="firstName" type="text" required />
                </FlexGuestDiv>
                <RightFlexDiv>
                  <Input style={{borderRadius:'0rem', height:'40px'}} label={<FormattedMessage id="payment_text_2" />} onChange={this.handleLastNameChange}  value={this.state.guestLastName} name="lastName" type="text" required />
                </RightFlexDiv>
              </Flex>

                <AddAddress1 style={{color:!this.state.addressOpen? 'rgba(24,140,236,1)':'lightgrey'}}>
                  <div onClick={()=>this.setState({addressOpen:!this.state.addressOpen})} style={{display:'flex', cursor:'pointer'}}><PlusMinus > <div className={this.state.addressOpen?'plus-minus-toggle':'plus-minus-toggle collapsed'}></div></PlusMinus>
                  {this.state.addressOpen &&
                  <FormattedMessage id="payment_text_3_01" />

                  }       {!this.state.addressOpen &&
                  <FormattedMessage id="payment_text_3_00" />

                  }
                  </div>
                </AddAddress1>
                <AddressSlideDown closed={!this.state.addressOpen}>

                <Flex2>
                <FlexGuestDiv>
                  <Input style={{borderRadius:'0rem', height:'40px'}} label={<FormattedMessage id="payment_text_3_0" />} onChange={this.handleGuestAddress1Change}  value={this.state.guestAddress1} name="address1" type="text"  />
                </FlexGuestDiv>
                <RightFlexDiv>
                  <Input style={{borderRadius:'0rem', height:'40px'}} label={<FormattedMessage id="payment_text_3_1" />} onChange={this.handleGuestCityChange}  value={this.state.guestCity} name="city" type="text"  />
                </RightFlexDiv>
              </Flex2>
                </AddressSlideDown>
              <Flex>
                <FlexGuestDiv2>
                  <Input style={{borderRadius:'0rem', height:'40px'}} label={<FormattedMessage id="payment_text_3" />} onChange={this.handleZipCodeChange}  value={this.state.guestZipCode} id="zip" name="zip" type="text" pattern="[0-9]*" required/>
                </FlexGuestDiv2>

                <RightFlexDiv>
                  { this.props.locale==='de'&&
                  <CountryWrapper>

                    <label style={{marginBottom:'.4em', fontSize:'.7em'}}>
                     <LabelTxt>Land</LabelTxt>
                      <CountryDropdown
                        valueType={'short'}
                        defaultOptionLabel={'Land auswählen'}
                        value={this.state.guestCountry}
                        onChange={(val) => this.handleCountryChange(val)} />
                    </label>
                  </CountryWrapper>
                  }
                  { this.props.locale==='en'&&
                  <CountryWrapper>

                    <label style={{marginBottom:'.4em',fontSize:'.7em'}}>
                      <LabelTxt>Country</LabelTxt>
                    <CountryDropdown
                      valueType={'short'}
                      defaultOptionLabel={'Select country'}
                      value={this.state.guestCountry}
                      onChange={(val) => this.handleCountryChange(val)} />
                    </label>
                  </CountryWrapper>
                  }


                </RightFlexDiv>
              </Flex>
              </form>
              <br/>
              <br/>
              <div style={{textAlign: 'left'}}>

                <Span><FormattedMessage id="payment_text_4" /></Span>
                <StyledSelect>
                  <Select
                    menuPlacement="top"
                    styles={customGuestStyles} components={{ DropdownIndicator,SingleValue: customSingleValue  }} onChange={this.handlePaymentMethodSelection}
                          value={paymentMethods[this.state.selectedPaymentMethod-1]}
                          clearable={false} options={this.state.paymentMethods} />
                </StyledSelect>
                <br/>
                <br/>
                <br/>


                <Span><FormattedMessage id="payment_text_5" /></Span>
                <StyledSelect>
                  <Select
                    menuPlacement="top"
                    styles={customGuestStyles} components={{ DropdownIndicator }} onChange={this.handlePaymentOptionSelection}
                          value={this.state.selectedPaymentOption}
                          clearable={false} options={paymentOptions}/>
                </StyledSelect>
              </div>

              <PricingPlan>

                <PricingOption onClick={this.handlePayTotal.bind(this)} style={{border: !this.state.payTotal ? '1px solid rgba(68,68,68,.05)' :'1px solid white', background: !this.state.payTotal ? 'white' :'rgba(24,140,236,.1)'}}>
                  <PricingOptionHeader style={{background: !this.state.payTotal ? 'rgba(68,68,68,.05)' :'#188cec', color: !this.state.payTotal ? 'rgba(68,68,68,1)' :'white'}}>NON-REFUNDABLE</PricingOptionHeader>
                  <PricingPlanDiv>

                    <SavePriceDiv><FormattedMessage id="payment_text_8" /> {(this.state.discount15).toLocaleString('de-DE', {
                      style: 'currency',
                      currency: 'EUR',
                      minimumFractionDigits: 2
                    })}</SavePriceDiv>
                    <PricingOptionDetails>
                      <b>15%</b> Discount <br/>
                      <b><FormattedMessage id="payment_text_9" /></b> <br/>
                      <br/>
                      <FormattedMessage id="payment_text_12" /> <b>{this.state.totalPrice15.toLocaleString('de-DE', {
                      style: 'currency',
                      currency: 'EUR',
                      minimumFractionDigits: 2
                    })} </b> <FormattedMessage id="payment_text_13" />
                    </PricingOptionDetails>

                  </PricingPlanDiv>
                </PricingOption>
                <PricingOption  style={{border: !this.state.payHalf ? '1px solid rgba(68,68,68,.05)' :'1px solid white', background: !this.state.payHalf ? 'white' :'rgba(24,140,236,.1)'}} onClick={this.handlePayHalf.bind(this)}>
                  <PricingOptionHeader style={{background: !this.state.payHalf ? 'rgba(68,68,68,.05)' :'#188cec', color: !this.state.payHalf ? 'rgba(68,68,68,1)' :'white'}}><FormattedMessage id="payment_text_6" /></PricingOptionHeader>
                  <PricingPlanDiv>

                    <SavePriceDiv><FormattedMessage id="payment_text_8" /> {(this.state.discount7).toLocaleString('de-DE', {
                      style: 'currency',
                      currency: 'EUR',
                      minimumFractionDigits: 2
                    })}</SavePriceDiv>
                    <PricingOptionDetails>
                      <b>7%</b> Discount <br/>
                      <FormattedMessage id="payment_text_10" /> <b>24h</b> <FormattedMessage id="payment_text_11" /> <br/>
                      <br/>
                      <FormattedMessage id="payment_text_12" /> <b>{(this.state.totalPrice7/2).toLocaleString('de-DE', {
                      style: 'currency',
                      currency: 'EUR',
                      minimumFractionDigits: 2
                    })} </b><FormattedMessage id="payment_text_13" />
                    </PricingOptionDetails>

                  </PricingPlanDiv>
                </PricingOption>
                <PricingOption  onClick={this.handleDuringStay.bind(this)} style={{border: !this.state.payDuringStay ? '1px solid rgba(68,68,68,.05)' :'1px solid white', background: !this.state.payDuringStay ? 'white' :'rgba(24,140,236,.1)'}}>
                  <PricingOptionHeader style={{background: !this.state.payDuringStay ? 'rgba(68,68,68,.05)' :'#188cec', color: !this.state.payDuringStay ? 'rgba(68,68,68,1)' :'white'}}><FormattedMessage id="payment_text_7" /></PricingOptionHeader>
                  <PricingPlanDiv>

                    <SavePriceDiv><FormattedMessage id="payment_text_8" /> {(this.state.discount5).toLocaleString('de-DE', {
                      style: 'currency',
                      currency: 'EUR',
                      minimumFractionDigits: 2
                    })}</SavePriceDiv>
                    <PricingOptionDetails>
                      <b>5%</b> Discount <br/>
                      <FormattedMessage id="payment_text_10_1" /> <b>48h</b> <FormattedMessage id="payment_text_11" /> <br/>
                      <br/>
                      <FormattedMessage id="payment_text_12" /><b> 00,00 € </b> <FormattedMessage id="payment_text_13" /> <br/>
                      <br/>
                      <b><FormattedMessage id="payment_text_14" /></b>

                    </PricingOptionDetails>

                  </PricingPlanDiv>
                </PricingOption>
              </PricingPlan>

              <SecuredPayment>
                  <PciCompliantImg/>
                <PaymentLogosImg/>
                <SslSecureImg/>
              </SecuredPayment>

              <ConditionalContinueButton openBottomSheet={this.openBottomSheet.bind(this)} sheetOpen={this.state.sheetOpen}/>


            </div>
          </div>
        </Div>
        <PopWrapperPayment>
          <StyledPopup
            open={this.state.paymentOpen}
            closeOnDocumentClick
            onClose={this.closePaymentModal}
          >
            <div className="modal">
              <a className="close" onClick={this.closePaymentModal}>
                <PopIcon src={cross}/>
              </a>
              <ConditionalPayment checkIn={moment(this.state.startDate).format('DD.MM.YYYY')} checkOut={moment(this.state.endDate).format('DD.MM.YYYY')} billingPlan={this.getBillingPlan()}
                                   firstName={this.state.guestFirstName} lastName={this.state.guestLastName} email={this.state.guestEmail}
                                  stCount={this.state.stCount} stpCount={this.state.stpCount} suCount={this.state.suCount}
                                  payDuringStay ={this.state.payDuringStay} postBooking={this.postBooking.bind(this)}
                                  amountToPay={this.state.amountToPay} fullAmount={this.state.totalPrice}
                                  totalGuests={this.state.totalGuests} nights={this.state.nights}
                                  selectedStudios={this.state.selectedStudios}
                                  selectedStudioPlus={this.state.selectedStudioPlus}
                                  selectedSuites={this.state.selectedSuites}
                                  rooms={this.state.rooms} categories={this.state.categories}
                                  payOption={this.state.payOption}
                                  startDate={this.state.startDate} endDate={this.state.endDate}
                                  paypal={this.state.paypal} paySepa={this.state.paySepa}
                                  payCreditCard={this.state.payCreditCard} payKlarna={this.state.payKlarna}
                                  payGiropay={this.state.payGiropay} payBankTransfer={this.state.payBankTransfer}
                                  breakfast={this.state.selectedBreakfast} bikes={this.state.selectedBikes}
                                  laundry={this.state.selectedLaundry} spa={this.state.selectedSpa} champagne={this.state.selectedChampagne}
                                  redWine={this.state.selectedRedWine} whiteWine={this.state.selectedWhiteWine} notes={this.state.notes}/>
            </div>        </StyledPopup>
        </PopWrapperPayment>


        <PopWrapper>
          <StyledPopup
            open={this.state.verifyOpen}
            closeOnDocumentClick
            onClose={this.closeVerifyModal}
          >
            <div className="modal">
              <a className="close" onClick={this.closeVerifyModal}>
                <PopIcon src={cross}/>
              </a>

              <PopLoginVerify closeModal={this.closeVerify}/>
              <LoginDiv onClick={this.openModal}> <FormattedMessage id={'auth_text_2'} /> <LoginA onClick={this.openModal}>Sign Up </LoginA>


              </LoginDiv>
              <Centered>  <FormattedMessage id={'auth_text_6'} />
                <Without onClick={this.closeVerifyModal}> <FormattedMessage id={'auth_text_13'} />    </Without></Centered>



            </div>        </StyledPopup>
        </PopWrapper>

        <PopWrapper>
        <StyledPopup
          open={this.state.open}
          closeOnDocumentClick
          onClose={this.closeModal}
        >
          <div className="modal">
            <a className="close" onClick={this.closeModal}>
              <PopIcon src={cross}/>
            </a>

   <PopLock closeModal={this.closeModal} closeBottom={this.closeBottomSheet} setStepTwo={this.setStepTwo.bind(this)}  metadata={

     {
       stRate5:this.state.stRate5,
       stRate7:this.state.stRate7,
       stRate15:this.state.stRate15,
       stpRate5:this.state.stpRate5,
       stpRate7:this.state.stpRate7,
       stpRate15:this.state.stpRate15,
       suRate5:this.state.suRate5,
       suRate7:this.state.suRate7,
       suRate15:this.state.suRate15 ,
       studio:this.state.studio,
       studioPlus:this.state.studioPlus,
       suite:this.state.suite,
       allAvailable:this.state.allAvailable,
       startDate:this.state.startDate,
       endDate:this.state.endDate,
       stCount: this.state.stCount,
       stpCount: this.state.stpCount,
       suCount: this.state.suCount,

       firstSelection:this.state.firstSelection,
       secondSelection:this.state.secondSelection,
       thirdSelection:this.state.thirdSelection,
       fourthSelection:this.state.fourthSelection,

       selectedGuests_1:this.state.selectedGuests_1,
       selectedGuests_2:this.state.selectedGuests_2,
       selectedGuests_3:this.state.selectedGuests_3,
       selectedGuests_4:this.state.selectedGuests_4,
       totalGuests:this.state.totalGuests,
       timestamp:moment(),

       selectedBreakfast:this.state.selectedBreakfast,
       selectedBikes:this.state.selectedBikes,
       selectedLaundry:this.state.selectedLaundry,
       selectedSpa:this.state.selectedSpa,
       selectedChampagne:this.state.selectedChampagne,
       selectedRedWine:this.state.selectedRedWine,
       selectedWhiteWine:this.state.selectedWhiteWine,

       breakfastSelected: this.state.breakfastSelected,
       bikesSelected: this.state.bikesSelected,
       spaSelected: this.state.spaSelected,
       laundrySelected: this.state.laundrySelected,
       champagneSelected: this.state.champagneSelected,
       whiteWineSelected: this.state.whiteWineSelected,
       redWineSelected: this.state.redWineSelected,
       notes: this.state.notes
     }
   } />

          </div>
          <Centered>  <FormattedMessage id={'auth_text_6'} />
            <Without onClick={this.closeModal}> <FormattedMessage id={'auth_text_13'} />    </Without></Centered>

          <LoginDiv onClick={this.openLogin}> <FormattedMessage id={'auth_text_1'}/> <LoginA onClick={this.openLogin}>Log In </LoginA>
          </LoginDiv>

        </StyledPopup>
        </PopWrapper>

        <PopWrapper>
        <StyledPopup
          open={this.state.openLogin}
          closeOnDocumentClick
          onClose={this.closeLogin}
        >
          <div className="modal">
            <a className="close" onClick={this.closeLogin}>
              <PopIcon src={cross}/>
            </a>

   <PopLogin closeModal={this.closeLogin} closeBottom={this.closeBottomSheet} setStepTwo={this.setStepTwo.bind(this)} metadata={

     {
       stRate5:this.state.stRate5,
       stRate7:this.state.stRate7,
       stRate15:this.state.stRate15,
       stpRate5:this.state.stpRate5,
       stpRate7:this.state.stpRate7,
       stpRate15:this.state.stpRate15,
       suRate5:this.state.suRate5,
       suRate7:this.state.suRate7,
       suRate15:this.state.suRate15 ,
       studio:this.state.studio,
       studioPlus:this.state.studioPlus,
       suite:this.state.suite,
       allAvailable:this.state.allAvailable,
       startDate:this.state.startDate,
       endDate:this.state.endDate,
       stCount: this.state.stCount,
       stpCount: this.state.stpCount,
       suCount: this.state.suCount,

       firstSelection:this.state.firstSelection,
       secondSelection:this.state.secondSelection,
       thirdSelection:this.state.thirdSelection,
       fourthSelection:this.state.fourthSelection,

       selectedGuests_1:this.state.selectedGuests_1,
       selectedGuests_2:this.state.selectedGuests_2,
       selectedGuests_3:this.state.selectedGuests_3,
       selectedGuests_4:this.state.selectedGuests_4,
       totalGuests:this.state.totalGuests,
       timestamp:moment(),

       selectedBreakfast:this.state.selectedBreakfast,
       selectedBikes:this.state.selectedBikes,
       selectedLaundry:this.state.selectedLaundry,
       selectedSpa:this.state.selectedSpa,
       selectedChampagne:this.state.selectedChampagne,
       selectedRedWine:this.state.selectedRedWine,
       selectedWhiteWine:this.state.selectedWhiteWine,

       breakfastSelected: this.state.breakfastSelected,
       bikesSelected: this.state.bikesSelected,
       spaSelected: this.state.spaSelected,
       laundrySelected: this.state.laundrySelected,
       champagneSelected: this.state.champagneSelected,
       whiteWineSelected: this.state.whiteWineSelected,
       redWineSelected: this.state.redWineSelected,
       notes: this.state.notes
     }
   } />
            <Centered>  <FormattedMessage id={'auth_text_6'} />
              <Without onClick={this.closeLogin}> <FormattedMessage id={'auth_text_13'} />    </Without></Centered>

            <LoginDiv onClick={this.openModal}><FormattedMessage id={'auth_text_2'}/> <LoginA onClick={this.openModal}>Sign Up </LoginA>

            </LoginDiv>



          </div>        </StyledPopup>
        </PopWrapper>
        <StateToLocal stepOneStatus={this.state.stepOneStatus} stepTwoStatus={this.state.stepTwoStatus} current={this.state.current} resExp={this.state.resExp}  guestOptions={this.state.guestOptions} calculateFinalPrice={this.calculateFinalPrice}  open={this.state.open} startDate={this.state.startDate} endDate={this.state.endDate} nights={this.state.nights}
                      selectedRooms={this.state.selectedRooms} selectedGuests={this.state.selectedGuests}
                      suite={this.state.suite} studio={this.state.studio} studioPlus={this.state.studioPlus}
                      allAvailable={this.state.allAvailable} displayNoAvailable={this.state.displayNoAvailable}
                      displayPleaseSelect={this.state.displayPleaseSelect} suPrice={this.state.suPrice}
                      stPrice={this.state.stPrice} stpPrice={this.state.stpPrice}
                      firstSelection={this.state.firstSelection} secondSelection={this.state.secondSelection}
                      thirdSelection={this.state.thirdSelection}
                      fourthSelection={this.state.fourthSelection} currentSelected={this.state.currentSelected}
                      stCount={this.state.stCount} stpCount={this.state.stpCount} suCount={this.state.suCount}
                      finalStPrice={this.state.finalStPrice} finalStpPrice={this.state.finalStpPrice} finalSuPrice={this.state.finalSuPrice}
                      discount={this.state.discount} totalPrice={this.state.totalPrice} rotation_1={this.state.rotation_1}
                      rotation_2={this.state.rotation_2} rotation_3={this.state.rotation_3} rotation_4={this.state.rotation_4}
        firstBlockClosed={this.state.firstBlockClosed} secondBlockClosed={this.state.secondBlockClosed}
                      thirdBlockClosed={this.state.thirdBlockClosed} fourthBlockClosed={this.state.fourthBlockClosed}
                      firstCheck = {this.state.firstCheck} secondCheck = {this.state.secondCheck}
                      thirdCheck = {this.state.thirdCheck} fourthCheck = {this.state.fourthCheck} selectedBikes={this.state.selectedBikes}
                      selectedBreakfast={this.state.selectedBreakfast} selectedLaundry={this.state.selectedLaundry}
                      selectChampagne={this.state.selectedChampagne} selectedWhiteWine={this.state.selectedWhiteWine}
                      selectedSpa={this.state.selectedSpa} notes={this.state.notes}
                      selectedBreakfastGuests={this.state.selectedBreakfastGuests}
        selectedBreakfastDays={this.state.selectedBreakfastDays}
        selectedBikeGuests={this.state.selectedBikeGuests}
        selectedBikeDays={this.state.selectedBikeDays}
        selectedLaundryFillings={this.state.selectedLaundryFillings} selectedChampagneBottles={this.state.selectedChampagneBottles}
                      selectedRedWineBottles={this.state.selectedRedWineBottles}
                      selectedWhiteWineBottles={this.state.selectedWhiteWineBottles} selectedSpaTours={this.state.selectedSpaTours}
                      guestOptions_1={this.state.guestOptions_1}
        guestOptions_2={this.state.guestOptions_2}
        guestOptions_3={this.state.guestOptions_3}
        guestOptions_4={this.state.guestOptions_4}
        selectedGuests_1={this.state.selectedGuests_1}
        selectedGuests_2={this.state.selectedGuests_2}
        selectedGuests_3={this.state.selectedGuests_3}
        selectedGuests_4={this.state.selectedGuests_4}
                       breakfastSelected={this.state.breakfastSelected}
        bikesSelected={this.state.bikesSelected}
        laundrySelected={this.state.laundrySelected}
        champagneSelected={this.state.champagneSelected}
        spaSelected={this.state.spaSelected}
        whiteWineSelected={this.state.whiteWineSelected}
        redWineSelected={this.state.redWineSelected}
                       paypal={this.state.paypal}
                       paySepa={this.state.paySepa}
                       payCreditCard={this.state.payCreditCard}
                       payKlarna={this.state.payKlarna}
                       payGiropay={this.state.payGiropay}
                       payBankTransfer={this.state.payBankTransfer}

                       payDuringStay={this.state.payDuringStay} payHalf={this.state.payHalf} payTotal={this.state.payTotal} selectedPaymentOption={this.state.selectedPaymentOption}


        > </StateToLocal>

        <StyledSheet>
        <SwipeableBottomSheet  	marginTop={40} onChange={this.openBottomSheet.bind(this)} overflowHeight={25} open={this.state.sheetOpen}>
          <StyledStickyEdit innerZ={99} enabled={true} >
            <ConditionalEditButton toggleBottomSheet={this.toggleBottomSheet.bind(this)} openBottomSheet={this.openBottomSheet.bind(this)} sheetOpen={this.state.sheetOpen}/>

          </StyledStickyEdit>
          <BlueLine onClick={this.toggleBottomSheet.bind(this)}>


          </BlueLine>

          <SheetWrapper onClick={this.toggleBottomSheetIfClosed.bind(this)}>
  <MobileInner>
    <div style={{display: (this.state.current===1)?'none':'block'}}>

    <Checkin>Check-In</Checkin>
    <Span>Check-Out</Span>

    <StyledWrapper>
      <DateRangePicker
        readOnly={true}
        startDatePlaceholderText="TT.MM.JJJJ"
        endDatePlaceholderText="TT.MM.JJJJ"
        showClearDates={true}
        reopenPickerOnClearDates={true}
        numberOfMonths={1}
        displayFormat="DD.MM.YYYY"
        startDate={this.state.startDate} // momentPropTypes.momentObj or null,
        startDateId="start_date" // PropTypes.string.isRequired,
        endDate={this.state.endDate} //   momentPropTypes.momentObj or null,
        endDateId="end_date" // PropTypes.string.isRequired,
        onDatesChange={({startDate, endDate}) => this.checkAvailability(startDate, endDate)} // PropTypes.func.isRequired,
        focusedInput={this.state.focusedInput_2} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
        onFocusChange={focusedInput_2 => this.setState({focusedInput_2})} // PropTypes.func.isRequired,
        // isDayBlocked= {this.isOutsideRange}
        //orientation={'vertical'}
        renderMonthElement={this.renderMonthElement}

      >
      </DateRangePicker>
    </StyledWrapper>
    <SelectDiv>
      <RoomGuestDiv>
        <Span><FormattedMessage id="booking_fixed_box_1" /></Span>
        <StyledRoomSelect>
        <Select

          type={'number'}
                        styles={customRoomStyles} components={{ DropdownIndicator }}  onChange={this.handleRoomSelection}
                          value={this.state.selectedRooms}
                          clearable={false} options={roomOptions}/>
        </StyledRoomSelect>
      </RoomGuestDiv>

    </SelectDiv>
    </div>
    <StyledSpinner style={{display:(this.state.showSpinner && this.state.startDate!=null && this.state.endDate!=null) ? 'flex':'none'}}>
      <Loader
        type="Triangle"
        color="rgb(68,68,68)"
        height={40}
        width={40}
        // timeout={30000} //3 secs

      />
    </StyledSpinner>

    <InnerBottom>
      {this.state.current===1 &&
      <div> <br/>
      <EditBookingDetails2 style={{opacity:this.state.sheetOpen?1:0}} onClick={()=>this.openBookingDetails()}>
        <EditButton3 > <FiEdit/></EditButton3>
        <FormattedMessage id="booking_text_000" />
      </EditBookingDetails2>
      </div>
      }
      <GuestNightDiv style={{display: (this.state.displayNoAvailable==='none' && this.state.startDate!=null && this.state.endDate!=null) ? 'flex' : 'none'}}>
        <SelectedGuests guests={this.state.totalGuests}/>
        <SelectedNights nights={this.state.nights}/>
      </GuestNightDiv>
      <ConditionalStPricing stSelected={this.state.stCount}
                            finalStudioPrice={this.state.finalStPrice}/>
      <ConditionalStpPricing stpSelected={this.state.stpCount}
                             finalStudioPlusPrice={this.state.finalStpPrice}
                             finalStudioPlusPrice5={this.state.finalStpPrice5}
                             finalStudioPlusPrice7={this.state.finalStpPrice7}
                             finalStudioPlusPrice15={this.state.finalStpPrice15}/>
      <ConditionalSuPricing suSelected={this.state.suCount}
                            finalSuitePrice={this.state.finalSuPrice}/>
      <SpecialsPricingBlock>

        <ConditionalBreakfast breakfastSelected={this.state.breakfastSelected}
                              selectedBreakfastGuests={this.state.selectedBreakfastGuests} selectedBreakfastDays={this.state.selectedBreakfastDays}/>
        <ConditionalBikes bikesSelected={this.state.bikesSelected}
                          selectedBikeGuests={this.state.selectedBikeGuests} selectedBikeDays={this.state.selectedBikeDays}/>

        <ConditionalLaundry laundrySelected={this.state.laundrySelected}
                            selectedLaundryFillings={this.state.selectedLaundryFillings} />
        <ConditionalChampagne champagneSelected={this.state.champagneSelected}
                              selectedChampagneBottles={this.state.selectedChampagneBottles} />
      </SpecialsPricingBlock>
      <ConditionalDiscount
        allSelected={this.state.currentSelected}
        payTotal={this.state.payTotal}
        payHalf={this.state.payHalf}
        payDuringStay={this.state.payDuringStay}
        discount={this.state.discount}
        discount5={this.state.discount5}
        discount7={this.state.discount7}
        discount8={this.state.discount8}
        discount15={this.state.discount15}
                           totalPrice={this.state.totalPrice}
                           totalPrice5={this.state.totalPrice5}
                           totalPrice7={this.state.totalPrice7}
                           totalPrice15={this.state.totalPrice15}
      />
      <ConditionalLoyaltyDiscount allSelected={this.state.currentSelected} payHalf={this.state.payHalf} payDuringStay={this.state.payDuringStay} payTotal={this.state.payTotal} loyaltyDiscount={this.state.loyaltyDiscount}
                                  totalPrice={this.state.totalPrice}
                                  totalPrice5={this.state.totalPrice5}
                                  totalPrice7={this.state.totalPrice7}
                                  totalPrice15={this.state.totalPrice15}
                                  discount5={this.state.discount5}
                                  discount7={this.state.discount7}
                                  discount8={this.state.discount8}
                                  discount15={this.state.discount15}
      />
      <ConditionalFreeBreakfast nights={this.state.nights}/>

      <ConditionalTotalPricing payTotal={this.state.payTotal}
                               payHalf={this.state.payHalf}
                               payDuringStay={this.state.payDuringStay}
                               allSelected={this.state.currentSelected}
                               nights={this.state.nights}
                               totalPrice={this.state.totalPrice}
                               totalPrice5={this.state.totalPrice5}
                               totalPrice7={this.state.totalPrice7}
                               totalPrice15={this.state.totalPrice15}
                               discount5={this.state.discount5}
                               discount7={this.state.discount7}
                               discount8={this.state.discount8}
                               discount15={this.state.discount15}
                               loyaltyDiscount={this.state.loyaltyDiscount}/>
    </InnerBottom>

    <div style={{display: (this.state.current===0)?'none':'none'}}>

    </div>
    <div style={{display: (this.state.current===1)?'block':'none'}}>

    <ConditionalPayButton  guestFirstName={this.state.guestFirstName} guestLastName={this.state.guestLastName}
                           guestZipCode={this.state.guestZipCode}
                           refresh={this.state.refresh} email={this.state.emailVerified} paypal={this.state.paypal}
                           paySepa={this.state.paySepa} payCreditCard={this.state.payCreditCard}
                           payKlarna={this.state.payKlarna} payGiropay={this.state.payGiropay}
                           payBankTransfer={this.state.payBankTransfer}
                           payDuringStay={this.state.payDuringStay} openModal={this.openPaymentModal} avail={this.state.allAvailable} stDate={this.state.startDate}
                           eDate={this.state.endDate} selRooms={this.state.selectedRooms.value}
                           currSelected={this.state.currentSelected}
                           finalPrice={this.state.totalPrice}
    />
    </div>



  </MobileInner>
</SheetWrapper>
        </SwipeableBottomSheet>
        </StyledSheet>

      </Outer>



    )
    }
    }
/*
 <ConditionalNextButton  showSpinner={this.state.showSpinner} openModal={this.openModal} avail={this.state.allAvailable} stDate={this.state.startDate}
                           eDate={this.state.endDate} selRooms={this.state.selectedRooms.value}
                           currSelected={this.state.currentSelected}
                           finalPrice={this.state.totalPrice}/>
 */


    // display items condition
//( this.state.allAvailable!=0 && this.state.displayNoAvailable==='none' && this.state.startDate!=null && this.state.endDate!=null) ? 'block' : 'none'}



// Steps onChange={this.onStepChange}
